const assetUrl = "https://s3-ap-southeast-1.amazonaws.com/rlc-misc/properties";

export default [
  {
    id: 1,
    property_id: "40015",
    cover_image: `${assetUrl}/am/images/cover.jpg`,
    logo_image: `${assetUrl}/am/images/logo.png`,
    pdf: `${assetUrl}/am/am.pdf`,
    video: `https://www.youtube.com/embed/s93n-YovIxE`,
    value_proposition:
      "For Filipino and foreign retirees and successful Cebuanos coming from the AA-AAA segment, AmiSa provides its unit owners the experience of having a weekend seafront home, via its units designed for restful living, its amenities, its landscaping, the Magellan Bay’s stunning tropical seascape, and Mactan’s refreshing atmosphere, for a live-heal-play lifestyle.",
    reasons: [
      "Perfect location for weekend living",
      "Perfectly maintained amenities and landscaping",
      "Efficiently designed unit spaces with big/wide balconies to maximize seaside views",
      "A gated master planned complex"
    ],
    address:
      "Located in Punta Engaño, Mactan, Cebu which is only 15 minutes away from the Mactan Cebu International Airport.",
    address_image: `${assetUrl}/am/images/map.png`,
    lat: 10.3300379,
    lng: 124.0401244,
    nearby_establishments: [
      {
        name: "Malls/Shopping Centers",
        places: [
          {
            name: "Marina Mall",
            distance: ""
          },
          {
            name: "Parkmall",
            distance: ""
          },
          {
            name: "Mactan Newtown",
            distance: ""
          }
        ]
      },
      {
        name: "Hotels & Resorts",
        places: [
          {
            name: "Movenpick cebu",
            distance: ""
          },
          {
            name: "Shangrila Mactan",
            distance: ""
          },
          {
            name: "Abaca",
            distance: ""
          },
          {
            name: "Crimson Resort",
            distance: ""
          },
          {
            name: "Be Resorts",
            distance: ""
          }
        ]
      },
      {
        name: "Transportation Hubs",
        places: [
          {
            name: "Mactan International Airport",
            distance: ""
          },
          {
            name: "Cebu International Port",
            distance: ""
          }
        ]
      },
      {
        name: "Cultural Sites",
        places: [
          {
            name: "Lapu-Lapu Shrine",
            distance: ""
          },
          {
            name: "Magellan Marker",
            distance: ""
          }
        ]
      },
      {
        name: "Schools",
        places: [
          {
            name: "Bigfoot Studios",
            distance: ""
          },
          {
            name: "Intenational Academy of Film and Television",
            distance: ""
          },
          {
            name: "Saint Augustine International School",
            distance: ""
          },
          {
            name: "Aviatour Flight School",
            distance: ""
          }
        ]
      }
    ],
    site_development_image: `${assetUrl}/am/images/site-plan.png`,
    building_feature_image: `${assetUrl}/am/images/cover.jpg`,
    site_development: [
      "Approx. 6-hectare land area",
      "6 Residential Condominiums"
    ],
    building_features: [
      "Entrance lobby with reception/ security counter",
      "Two (2) passenger elevators for each tower",
      "CCTV monitoring of selected common areas",
      "Automatic heat/ smoke detection and fire sprinkler system",
      "Annunciator panel with emergency speaker at all floors",
      "Water reservoir",
      "Standby power generator for common areas and selected outlet in the residential unit",
      "Individual mail box",
      "Central garbage area",
      "Building Administration Office",
      "Fire Exits"
    ],
    design_concept: [
      "Residential towers are inspired by Australian Gold Coast architecture",
      "Master-planned residential community",
      "All flat units"
    ],
    design_partners: [
      "Architectural Partner:   ASYA Design Partners",
      "Landscaping Design:  PGAA Creative Design",
      "Beach Development:    Petra Konsult & Associate, Inc."
    ],
    amenities: [
      "Clubhouse",
      "Swimming Pools",
      "Fitness Center/Gym",
      "Videoke",
      "Game Room",
      "Mini Theater",
      "Biking/jogging path",
      "Multi-purpose court",
      "Picnic area",
      "Playground"
    ],
    amenities_images: [
      `${assetUrl}/am/images/amenities/a1.jpg`,
      `${assetUrl}/am/images/amenities/a2.jpg`,
      `${assetUrl}/am/images/amenities/a3.jpg`,
      `${assetUrl}/am/images/amenities/a4.jpg`,
      `${assetUrl}/am/images/amenities/a5.jpg`,
      `${assetUrl}/am/images/amenities/a6.png`,
      `${assetUrl}/am/images/amenities/a7.png`,
      `${assetUrl}/am/images/amenities/a8.png`
    ],
    floor_plan_images: [
      `${assetUrl}/am/images/fp/f1.png`,
      `${assetUrl}/am/images/fp/f2.png`,
      `${assetUrl}/am/images/fp/f3.png`,
      `${assetUrl}/am/images/fp/f4.png`,
      `${assetUrl}/am/images/fp/f5.png`,
      `${assetUrl}/am/images/fp/f6.png`,
      `${assetUrl}/am/images/fp/f7.png`
    ],
    floor_stacking: [
      {
        name: "Tower A",
        properties: [
          {
            floor: "15",
            number: "1",
            use: "Penthouse"
          },
          {
            floor: "2 to 14",
            number: "12",
            use: "Typical Residential Floors"
          },
          {
            floor: "Ground",
            number: "1",
            use: "Lobby/Garden Units"
          }
        ]
      },
      {
        name: "Tower B",
        properties: [
          {
            floor: "19",
            number: "1",
            use: "Penthouse"
          },
          {
            floor: "10 to 18",
            number: "8",
            use: "Typical Residential Floors"
          },
          {
            floor: "2 to 9",
            number: "8",
            use: "Typical Residential Floors"
          },
          {
            floor: "Ground",
            number: "1",
            use: "Lobby/Garden Units"
          }
        ]
      },
      {
        name: "Tower C",
        properties: [
          {
            floor: "19",
            number: "1",
            use: "Penthouse"
          },
          {
            floor: "10 to 18",
            number: "8",
            use: "Typical Residential Floors"
          },
          {
            floor: "3 to 9",
            number: "7",
            use: "Typical Residential Floors"
          },
          {
            floor: "2",
            number: "1",
            use: "Typical Residential Floors"
          },
          {
            floor: "Ground",
            number: "1",
            use: "Lobby/Garden Units/Amenities"
          }
        ]
      }
    ],
    floors: [
      {
        name: "Tower A",
        properties: [
          {
            col1: "No. of Studio Units",
            col2: "51"
          },
          {
            col1: "No. of 1BR Units",
            col2: "53"
          },
          {
            col1: "No. of 2BR Units",
            col2: "28"
          },
          {
            col1: "No. of 3BR Units",
            col2: "2"
          },
          {
            col1: "Total Units/Floor",
            col2: "15fl - 1, 2fl to 14fl - 15, 1fl - 1"
          },
          {
            col1: "Number of Floors",
            col2: "15"
          },
          {
            col1: "Total No. of Units",
            col2: "131"
          }
        ]
      },
      {
        name: "Tower B",
        properties: [
          {
            col1: "No. of Studio Units",
            col2: "37"
          },
          {
            col1: "No. of 2BR Units",
            col2: "116"
          },
          {
            col1: "No. of 3BR Units",
            col2: "2"
          },
          {
            col1: "Total Units/Floor",
            col2: "19fl - 1, 10fl to 18fl - 8, 2fl to 9fl - 8, 1fl - 1"
          },
          {
            col1: "Number of Floors",
            col2: "19"
          },
          {
            col1: "Total No. of Units",
            col2: "155"
          }
        ]
      },
      {
        name: "Tower C",
        properties: [
          {
            col1: "No. of Studio Units",
            col2: "135"
          },
          {
            col1: "No. of 2BR Units",
            col2: "51"
          },
          {
            col1: "No. of 3BR Units",
            col2: "3"
          },
          {
            col1: "Total Units/Floor",
            col2: "19fl - 1, 10fl to 18fl - 8, 3fl to 9fl - 7, 2fl - 1"
          },
          {
            col1: "Number of Floors",
            col2: "19"
          },
          {
            col1: "Total No. of Units",
            col2: "189"
          }
        ]
      }
    ],
    units: [
      {
        name: "One Bedroom",
        image: `${assetUrl}/am/images/units/u1.png`,
        properties: [
          {
            name: "Living/Dining/Kitchen",
            values: "22.18 sqm"
          },
          {
            name: "Dining",
            values: "14.16 sqm"
          },
          {
            name: "Common T&B",
            values: "5.86 sqm"
          },
          {
            name: "Balcony",
            values: "7.60 sqm"
          },
          {
            name: "Total",
            values: "49.8 sqm"
          }
        ]
      },
      {
        name: "Two Bedroom",
        image: `${assetUrl}/am/images/units/u2.png`,
        properties: [
          {
            name: "Living/Dining",
            values: "15.75 sqm"
          },
          {
            name: "Kitchen/Foyer",
            values: "9.58 sqm"
          },
          {
            name: "Utility Room",
            values: "5.65 sqm"
          },
          {
            name: "Bedroom Room",
            values: "8.26 sqm"
          },
          {
            name: "T&B",
            values: "5.60 sqm"
          },
          {
            name: "Master's Bedroom",
            values: "12.66 sqm"
          },
          {
            name: "Master's T&B",
            values: "6.40 sqm"
          },
          {
            name: "Balcony 1",
            values: "8.00 sqm"
          },
          {
            name: "Balcony 2",
            values: "9.30 sqm"
          },
          {
            name: "Hallway",
            values: "2.48 sqm"
          },
          {
            name: "Total",
            values: "83.68 sqm"
          }
        ]
      },
      {
        name: "Three Bedroom",
        image: `${assetUrl}/am/images/units/u3.png`,
        properties: [
          {
            name: "Living/Dining Area",
            values: "30.10 sqm"
          },
          {
            name: "Kitchen",
            values: "7.00 sqm"
          },
          {
            name: "Foyer",
            values: "3.80 sqm"
          },
          {
            name: "Hallway",
            values: "3.80 sqm"
          },
          {
            name: "Bedroom 2",
            values: "11.70 sqm"
          },
          {
            name: "Bedroom 2 T&B",
            values: "6.20 sqm"
          },
          {
            name: "Utility Room",
            values: "6.20 sqm"
          },
          {
            name: "Bedroom 3",
            values: "15.20 sqm"
          },
          {
            name: "Bedroom T&B",
            values: "6.30 sqm"
          },
          {
            name: "Master's Bedroom",
            values: "24.51 sqm"
          },
          {
            name: "Master's T&B",
            values: "6.70 sqm"
          },
          {
            name: "Balcony 1",
            values: "8.00 sqm"
          },
          {
            name: "Balcony 2",
            values: "9.30 sqm"
          },
          {
            name: "Balcony 3",
            values: "9.60 sqm"
          },
          {
            name: "Total",
            values: "148.41 sqm"
          }
        ]
      }
    ],
    unit_images: [
      `${assetUrl}/am/images/units/1BR-Unit.png`,
      `${assetUrl}/am/images/units/2BR-Unit.png`,
      `${assetUrl}/am/images/units/Studio-Unit.png`
    ],
    unit_features: [
      "Entrance panel with door viewer",
      "Intercom per unit connected to the reception counter",
      "Automatic smoke detectors and fire alarm with sprinkler system in all units",
      "Individual electric and water meter",
      "Cable TV line",
      "Telephone line per unit",
      "Ventilation for kitchen and toilets",
      "Window type air con openings and electrical outlet for all units except for Units B and O which will be provided with additional pipe sleeves and electrical provisions for split-type air con",
      "Hot water supply line (excluding water heater) for shower area at Toilet and Bath",
      "Electrical load provision of 20 amp for 2-burner electric cooktop"
    ],
    unit_finishes: [
      {
        area: "Floor",
        bedroom: "Laminated, Wood",
        living: "Homogeneous Tiles",
        kitchen: "Homogeneous Tiles",
        toilet: "Ceramic Tiles",
        balcony: "Ceramic Tiles"
      },
      {
        area: "Wall",
        bedroom: "Painted, Cement Finish",
        living: "Painted, Cement Finish",
        kitchen: "Painted, Cement Finish",
        toilet: "Combination of ceramic tiles and painted plastered cement",
        balcony: "1.2 meters high with metal railing"
      },
      {
        area: "Ceiling",
        bedroom: "Painted, Cement Finish",
        living: "Painted, Cement Finish",
        kitchen: "Painted, Cement Finish",
        toilet: "Painted Gypsum Board",
        balcony: ""
      },
      {
        area: "Others",
        bedroom: "",
        living: "",
        kitchen:
          "Granite finish countertop, overhead and undercounter cabinets",
        toilet: "",
        balcony: ""
      }
    ]
  },
  {
    id: 2,
    property_id: "40014",
    cover_image: `${assetUrl}/ttt/building_feature_image/cover.png`,
    logo_image: `${assetUrl}/ttt/logo.png`,
    pdf: `${assetUrl}/ttt/ttt.pdf`,
    video: `https://www.youtube.com/embed/lAWcFGXtdQE`,
    value_proposition:
      "For competent individuals from the BBB to A income segment, The Trion Towers provides efficient, relaxed and secure city living brought about by the building’s distinctive multi-functional architectural design complemented by the project’s well-thought amenities and prime location perfect for those who appreciate life and diversity in city living.",
    reasons: [
      "GLOBAL LIFESTYLE",
      "EVERYTHING YOU NEED ONLY A FEW STEPS AWAY.",
      "Located in close and comfortable proximity to restaurants, businesses, schools, a Science museum, one of the biggest hospitals in the country, and countless leisure and entertainment spots.",
      "VISIONARY DESIGN",
      "UNIQUE AND DISTINCTIVE BUILDING DESIGN FOR FUNCTIONAL LIVING",
      "Offers a panoramic view of vibrant Bonifacio Global City and peaceful Laguna de Bay with the building’s tri-axial design that also bestows natural light and air ventilation, maximized unit cuts, and enhanced structural stability.",
      "32 AMAZING AMENITIES",
      "THOUGHTFULLY PLANNED AMENITIES TO REINVIGORATE YOUR LIFESTYLE",
      "Incredible set of amenities zoned perfectly per tower: The Fitness Arena for Tower 1, The Entertainment Domain for Tower 2 and The Wellness Enclave for Tower 3.",
      "RETAIL CONVENIENCES",
      "A SELECTION OF COMMUNITY SHOPS FOR EASY EVERYDAY LIVING.",
      "Everyday necessities can conveniently be accessed through the commercial areas at the ground floor of the building."
    ],
    address:
      "The Trion Towers is located in the country’s best urban-planned commercial and business districts, the Bonifacio Global City in Taguig. This 1-hectare development stands at the corner of Eight Avenue and McKinley Parkway which means it is just a few minutes away from the Fort Strip, Bonifacio High Street, Market! Market!, Serendra, and countless other shopping and leisure establishments scattered all over BGC.",
    address_image: `${assetUrl}/ttt/map.png`,
    lat: 14.5458442,
    lng: 121.0475805,
    nearby_establishments: [
      {
        name: "Schools",
        places: [
          {
            name: "British School Manila",
            distance: "10 km"
          },
          {
            name: "International School Manila",
            distance: "20 km"
          },
          {
            name: "Manila Japanese School",
            distance: "20 km"
          },
          {
            name: "Korean International",
            distance: "20 km"
          },
          {
            name: "School Philippines",
            distance: "20 km"
          },
          {
            name: "Chinese International",
            distance: "20 km"
          },
          {
            name: "School Manila",
            distance: "20 km"
          }
        ]
      },
      {
        name: "OFFICES",
        places: [
          {
            name: "Arts in the City",
            distance: "5 km"
          },
          {
            name: "Bonifacio Arts",
            distance: "5 km"
          },
          {
            name: "Foundation, Inc. (BAFI)",
            distance: "5 km"
          },
          {
            name: "Del Monte Pacific Ltd.",
            distance: "5 km"
          },
          {
            name: "Department of Energy",
            distance: "5 km"
          },
          {
            name: "Fort Bonifacio",
            distance: "5 km"
          },
          {
            name: "Development Corp.",
            distance: "5 km"
          },
          {
            name: "Hanjin Phil. Headquarters",
            distance: "5 km"
          },
          {
            name: "HSBC Center",
            distance: "5 km"
          },
          {
            name: "Singapore Embassy",
            distance: "5 km"
          },
          {
            name: "Sunlife Financial",
            distance: "5 km"
          },
          {
            name: "JP Morgan Chase Philippines",
            distance: "5 km"
          },
          {
            name: "Samsung Electronics",
            distance: "5 km"
          },
          {
            name: "Phils. Corporation",
            distance: "5 km"
          }
        ]
      },
      {
        name: "LEISURE AND ENTERTAINMENT",
        places: [
          {
            name: "Bonifacio High Street",
            distance: "3.4 km"
          },
          {
            name: "Burgos Circle",
            distance: "3.4 km"
          },
          {
            name: "Market! Market!",
            distance: "3.4 km"
          },
          {
            name: "Shops at Serendra",
            distance: "3.4 km"
          },
          {
            name: "SM Aura Premier",
            distance: "3.4 km"
          },
          {
            name: "Venice Piazza",
            distance: "3.4 km"
          },
          {
            name: "S&R Membership Shopping",
            distance: "3.4 km"
          }
        ]
      },
      {
        name: "MUSEUMS",
        places: [
          {
            name: "The Mind Museum",
            distance: "4.3 km"
          }
        ]
      },
      {
        name: "HOSPITALS",
        places: [
          {
            name: "St. Luke’s Medical Center",
            distance: "4.3 km"
          }
        ]
      }
    ],
    site_development_image: `${assetUrl}/ttt/site_development_image/06-Site-Development-Plan.png`,
    building_feature_image: `${assetUrl}/ttt/building_feature_image/cover.png`,
    site_development: [
      "1 Hectare Residential Development",
      "3 Residential Towers",
      "5 Levels of Basement Parking",
      "Flat Design Concept",
      "Retail Area at the Lower Ground Floor"
    ],
    building_features: [
      "Grand Lobby",
      "Central Plaza with fountain",
      "Perimeter fence",
      "Exclusive drop-off areas",
      "Five levels of basement parking",
      "Four passenger elevators (3 passenger, 1 passenger cum service)",
      "CCTV monitoring on strategic areas",
      "Automatic smoke detectors, fire alarm, and sprinkler system in all common areas",
      "Standby power generator for common areas and selected outlets in residential units",
      "Elevated water tank and underground cistern",
      "Private mailboxes",
      "Building administration office"
    ],
    design_concept: [
      "Visionary Design",
      "Modern Tri-axial architectural design which promotes:",
      "Natural Ventilation",
      "Maximized Views",
      "Building Stability",
      "More Privacy",
      "Flat design concept",
      "Concrete façade with glass windows and alternating balconies"
    ],
    design_partners: [
      "Architectural Partner:   ASYA Design Partners",
      "Structural Consultant: SY2 + Associates",
      "Landscape Designer: EA Aurelio Landscape Architects"
    ],
    amenities: [
      "Exercise and Dance Room",
      "Cardio and Workout Rooms",
      "Boxing Room",
      "Gaming Room",
      "Party Room",
      "Social Lounges",
      "Receiving Lounge",
      "Outdoor Playscapes",
      "Kids’ Play Pool",
      "Outdoor Pool with Pool Deck",
      "Exercise Porch",
      "Al Fresco Lounge",
      "Play Station",
      "Cyber Hub (with high-speed wifi access and computer facilities)",
      "Children’s Discovery Rooms",
      "Music Room",
      "High-Definition Screening Room",
      "Party Room",
      "Social Lounge",
      "Receiving Lounge",
      "Outdoor Lap Pool with Leisure Deck",
      "Hobbyists’ Nook",
      "Pleasure Trail",
      "Passion Garden",
      "Tranquility Pool with Outdoor Deck",
      "Soothing Spa and Sauna Room",
      "Yoga and Pilates Studio",
      "Knowledge Room",
      "Therapeutic Massage Room",
      "Party Room",
      "Social Lounge",
      "Receiving Lounge"
    ],
    amenities_images: [
      `${assetUrl}/ttt/amenities/Cardio-and-Workout-Room.png`,
      `${assetUrl}/ttt/amenities/Exercise-and-Dance-Room.png`,
      `${assetUrl}/ttt/amenities/Outdoor-Playscapes.png`,
      `${assetUrl}/ttt/amenities/Receiving-Lounge.png`
    ],
    floor_plan_images: [
      `${assetUrl}/ttt/floor_plan_images/f1.png`,
      `${assetUrl}/ttt/floor_plan_images/f2.png`
    ],
    floor_stacking: [
      {
        name: "Tower 3",
        properties: [
          {
            floor: "49 to 50",
            number: "2",
            use: "Residential Floor"
          },
          {
            floor: "39 to 48",
            number: "10",
            use: "Residential Floor"
          },
          {
            floor: "3 to 38",
            number: "35",
            use: "Residential Floor"
          },
          {
            floor: "2",
            number: "1",
            use: "Residential Floor"
          },
          {
            floor: "Upper Ground",
            number: "1",
            use: "Amenities"
          },
          {
            floor: "Lower Ground",
            number: "1",
            use: "Main Lobby and Reatil Area"
          },
          {
            floor: "Basement 1-5",
            number: "1",
            use: "Residential Parking"
          }
        ]
      }
    ],
    floors: [
      {
        name: "Tower 1",
        properties: [
          {
            col1: "No. of 1BR Units",
            col2: "515"
          },
          {
            col1: "No. of 2BR Units",
            col2: "157"
          },
          {
            col1: "No. of 3BR Units",
            col2: "23"
          },
          {
            col1: "Total Units/Floor",
            col2: "8 to 16"
          },
          {
            col1: "No. of Floors",
            col2: "49"
          },
          {
            col1: "Total Number of Units",
            col2: "695"
          }
        ]
      },
      {
        name: "Tower 2",
        properties: [
          {
            col1: "No. of 1BR Units",
            col2: "516"
          },
          {
            col1: "No. of 2BR Units",
            col2: "192"
          },
          {
            col1: "No. of 3BR Units",
            col2: "8"
          },
          {
            col1: "No. of Penthouse",
            col2: "1"
          },
          {
            col1: "Total Units/Floor",
            col2: "5 to 17"
          },
          {
            col1: "No. of Floors",
            col2: "50"
          },
          {
            col1: "Total Number of Units",
            col2: "725"
          }
        ]
      },
      {
        name: "Tower 3",
        properties: [
          {
            col1: "No. of 1BR Units",
            col2: "428"
          },
          {
            col1: "No. of 2BR Units",
            col2: "180"
          },
          {
            col1: "No. of 3BR Units",
            col2: "28"
          },
          {
            col1: "Total Units/Floor",
            col2: "11 to 14"
          },
          {
            col1: "Number of Floors",
            col2: "50"
          },
          {
            col1: "Total No. of Units",
            col2: "636"
          }
        ]
      }
    ],
    units: [
      {
        name: "One Bedroom",
        image: `${assetUrl}/ttt/unit_images/u1.png`,
        properties: [
          {
            name: "Living/Dining",
            values: "±14.85 sqm"
          },
          {
            name: "Kitchen",
            values: "±6.85 sqm"
          },
          {
            name: "Master BR",
            values: "±10.40 sqm"
          },
          {
            name: "Master T&B",
            values: "±6.00 sqm"
          },
          {
            name: "Unit Area",
            values: "±38.10 sqm"
          },
          {
            name: "Balcony",
            values: "±4.35 sqm"
          },
          {
            name: "Total",
            values: "±42.45 sqm"
          }
        ]
      },
      {
        name: "Two Bedroom",
        image: `${assetUrl}/ttt/unit_images/u2.png`,
        properties: [
          {
            name: "Living/Dining",
            values: "±11.50 sqm"
          },
          {
            name: "Kitchen",
            values: "5.70 sqm"
          },
          {
            name: "Master BR",
            values: "±11.30 sqm"
          },
          {
            name: "Master T&B",
            values: "±7.70 sqm"
          },
          {
            name: "Bedroom 1",
            values: "±11.00 sqm"
          },
          {
            name: "Common T&B",
            values: "±7.10 sqm"
          },
          {
            name: "Balcony",
            values: "±4.80 sqm"
          },
          {
            name: "Total",
            values: "±59.10 sqm"
          }
        ]
      },
      {
        name: "Three Bedroom",
        image: `${assetUrl}/ttt/unit_images/u3.png`,
        properties: [
          {
            name: "Living/Dining",
            values: "±24.80 sqm"
          },
          {
            name: "Kitchen",
            values: "±9.75 sqm"
          },
          {
            name: "Master BR",
            values: "±14.15 sqm"
          },
          {
            name: "Master T&B",
            values: "±6.75 sqm"
          },
          {
            name: "Bedroom 1",
            values: "±8.85 sqm"
          },
          {
            name: "Bedroom 2",
            values: "±13.30 sqm"
          },
          {
            name: "Common T&B",
            values: "±6.90 sqm"
          },
          {
            name: "Utility Area",
            values: "±7.40 sqm"
          },
          {
            name: "Balcony 1",
            values: "±5.64 sqm"
          },
          {
            name: "Balcony 2",
            values: "4.80 sqm"
          },
          {
            name: "Total",
            values: "102.34 sqm"
          }
        ]
      }
    ],
    unit_images: [
      `${assetUrl}/ttt/unit_images/1BR-Unit.png`,
      `${assetUrl}/ttt/unit_images/2BR-Unit.png`,
      `${assetUrl}/ttt/unit_images/Studio-Unit.png`
    ],
    unit_features: [
      "Open-air private outdoor spaces in selected units",
      "Generous floor to ceiling height at approximately 2.90 meters",
      "Expansive window installations offering panoramic views of the city skyline",
      "Main door security view hole feature",
      "Continuous airflow system for kitchen and toilet areas",
      "Pre-wired cable TV and telephone outlets ready for high-speed internet access",
      "Individual intercom facility in each unit that gives push button access to Security, Reception and Property Management personnel",
      "In-suite automatic smoke detectors and fire alarm sprinkler system",
      "Personalized monitoring facility for water and electric usage",
      "Dedicated spaces for utility areas in selected units"
    ],
    unit_finishes: [
      {
        area: "Floor",
        bedroom: "Laminated Wood",
        living: "Homogeneous Tiles",
        kitchen: "Homogeneous Tiles",
        toilet: "Ceramic Tiles",
        balcony: ""
      },
      {
        area: "Wall",
        bedroom: "Painted Plastered Wall",
        living: "Painted Plastered Wall",
        kitchen: "Painted Plastered Wall",
        toilet: "Full-height Ceramic Tiles",
        balcony: ""
      },
      {
        area: "Ceiling",
        bedroom: "Painted Slab Soffit",
        living: "Painted Slab Soffit",
        kitchen: "Painted Gypsum Board",
        toilet: "Painted Gypsum Board",
        balcony: ""
      },
      {
        area: "Other",
        bedroom: "Full-height bedroom closets with mirror",
        living: "",
        kitchen:
          "Solid Surface kitchen countertop, Modular overhead kitchen cabinets with glass door, Moduler undercounter kitchen cabinets with laminated wood finish, Single point water heater, Water filtation unit",
        toilet:
          "Shower glass enclosure in Master T&B, Multi-point water heater in Master T&B with undercounter cabinet, Provision for multipoint water heater in common T&B (water heater excluded)",
        balcony: ""
      }
    ]
  },
  {
    id: 3,
    property_id: "40032",
    cover_image: `${assetUrl}/grc/cover.png`,
    logo_image: `${assetUrl}/grc/logo.jpg`,
    pdf: `${assetUrl}/grc/grc.pdf`,
    video: `https://www.youtube.com/embed/d3tWxWSVXPE`,
    value_proposition:
      "For young, highly mobile individuals, who are on the rise in Cebu and nearby key provincial cities with a minimum household income of Php50,000. Galleria Residences is part of a master-planned, mixed-use complex headlined by a full-scale mall which offers an exciting mix of retail shops while the development is outfitted with resort-like amenities and features which allows its residents a unique city lifestyle amidst Cebu’s bustling main port area.",
    reasons: [
      "FULLY INTEGRATED WITHIN ROBINSONS GALLERIA CEBU COMPLEX \nStrategically located within Cebu’s emerging district offering a live-work-playlifestyle",
      "WELL-PLANNED UNITS FOR YOUNG URBANITES \nPractical unit layouts providing residents adequate personal space",
      "A MYRIAD OF AMENITIES TO RECHARGE AND PLAY \nWide array of resort-like amenities to allow residents to relax and recharge after a long day at work",
      "ENJOY LIFE A LITTLE MORE \nValue-added services such as Ring Rob Concierge so you can focus more on the things that matter"
    ],
    address:
      "Strategically located along Maxilom Avenue, a thriving commercial district accessible to key establishments, Galleria Residences will serve as your own gateway to all of the city’s most interesting and important destinations.",
    address_image: `${assetUrl}/grc/map.png`,
    lat: 10.3036393,
    lng: 123.9086436,
    nearby_establishments: [
      {
        name: "EDUCATIONAL INSTITUTIONS",
        places: [
          {
            name: "University of San Carlos",
            distance: ""
          },
          {
            name: "Cebu Normal University",
            distance: ""
          },
          {
            name: "University of Cebu Main Campus",
            distance: ""
          },
          {
            name: "University of the Visayas",
            distance: ""
          },
          {
            name: "Cebu Technological University",
            distance: ""
          }
        ]
      },
      {
        name: "CHURCHES",
        places: [
          {
            name: "Blessed Sacrament Parish",
            distance: ""
          },
          {
            name: "Cebu Metropolitan Cathedral",
            distance: ""
          },
          {
            name: "Basilica Minore Del Santo Nino",
            distance: ""
          },
          {
            name: "Sto. Nino Chapel",
            distance: ""
          },
          {
            name: "San Nicolas De Tolentino Parish Church",
            distance: ""
          }
        ]
      },
      {
        name: "GOVERNMENT INSTITUTIONS",
        places: [
          {
            name: "Cebu City Hall",
            distance: ""
          },
          {
            name: "Cebu City Government City Health Department",
            distance: ""
          },
          {
            name: "Department of Public Works and Highways",
            distance: ""
          },
          {
            name: "Department of Public Works and Highways",
            distance: ""
          },
          {
            name: "Department of Tourism",
            distance: ""
          }
        ]
      },
      {
        name: "COMMERCIAL CENTERS",
        places: [
          {
            name: "Robinsons Galleria Cebu",
            distance: ""
          },
          {
            name: "Robinsons Fuente",
            distance: ""
          },
          {
            name: "Robinsons Cybergate",
            distance: ""
          },
          {
            name: "Gaisano Capital South",
            distance: ""
          }
        ]
      },
      {
        name: "HOSPITALS",
        places: [
          {
            name: "Sacred Heart Hospital",
            distance: ""
          },
          {
            name: "St. Vincent’s Hospital",
            distance: ""
          },
          {
            name: "St. Vincent’s Hospital",
            distance: ""
          },
          {
            name: "Cebu Velez General Hospital",
            distance: ""
          },
          {
            name: "Cebu City Medical Center",
            distance: ""
          }
        ]
      },
      {
        name: "TOURIST DESTINATIONS",
        places: [
          {
            name: "Fort San Pedro",
            distance: ""
          },
          {
            name: "Magellan’s Cross",
            distance: ""
          },
          {
            name: "San Diego-Yap Ancestral House",
            distance: ""
          },
          {
            name: "Casa Gorordo Museum",
            distance: ""
          }
        ]
      }
    ],
    site_development_image: `${assetUrl}/grc/site-plan.png`,
    building_feature_image: `${assetUrl}/grc/cover.png`,
    site_development: [
      "Approx. 8,629 sq.m land area",
      "Residential area approx. 6,112 sq.m",
      "2 residential towers",
      "30 residential floors",
      "4 level podium parking",
      "3 levels of retail experience"
    ],
    building_features: [
      "Main entrance lobby with reception counter at the Ground Floor",
      "Four (4) elevators (3 passenger elevators and 1 service cum service)",
      "CCTV monitoring at selected common areas",
      "Automatic smoke detectors, fire alarm and sprinkler system at all common areas",
      "Annunciator panel with emergency speaker at selected floors",
      "Water is supplied by an elevated water tank and underground cistern",
      "Standby power generator for all common areas",
      "Individual mail boxes",
      "Garbage holding area per residential floor",
      "Centralized garbage holding room located at the Ground Floor",
      "Building administration office",
      "Security room",
      "Driver’s lounge and toilet",
      "Transformer and genset room",
      "Sewage treatment plant",
      "Two (2) fire exits per building with well-lighted signage conforming to Fire Code of the Philippines"
    ],
    design_concept: [
      "Modern resort-inspired community",
      "Modern architectural design",
      "Natural Lighting",
      "Natural Ventilation",
      "Concrete façade with glass windows and balconies in selected units"
    ],
    design_partners: [
      "Architectural Design: ASYA Design Partners",
      "Structural Design: Sy^² and Associates",
      "Plumbing, Sanitary & Fire Protection: F.L. Figueroa and Associate",
      "Electrical: M.A. Alix and Partners",
      "Mechanical: L.R. Punsalan and Associates",
      "Landscaping: E.A. Aurelio Landscape Architects"
    ],
    amenities: [
      "Spa/Sauna",
      "Fitness Gym",
      "Private Theater",
      "Children’s Playroom",
      "Open Lounge",
      "Function Room",
      "Lap Pool",
      "Kiddie Pool",
      "Outdoor Playground",
      "Game Station",
      "Virtual Golf",
      "Health Bar",
      "Clinic",
      "Dance Studio",
      "Martial Arts Studio",
      "Aerobics/Yoga Room",
      "Boxing Room",
      "Bar/Game Room",
      "Videoke Room",
      "Bar Lounge",
      "Meeting Room",
      "Business Center/Library",
      "Multi-purpose Hall/Badminton",
      "Wi-Fi Lounge",
      "Arts and Crafts Room",
      "Pre-function Hall",
      "Sky Deck",
      "Garden Area"
    ],
    amenities_images: [
      `${assetUrl}/grc/amenities/am1.png`,
      `${assetUrl}/grc/amenities/am2.png`,
      `${assetUrl}/grc/amenities/am3.png`
    ],
    floor_plan_images: [`${assetUrl}/grc/fp/f1.png`],
    floor_stacking: [
      {
        name: "",
        properties: [
          {
            floor: "6 to 22",
            number: "16",
            use: "Typical Residential Floors"
          },
          {
            floor: "5",
            number: "1",
            use: "Amenity Level"
          },
          {
            floor: "2 to 4",
            number: "3",
            use: "Residential Parking"
          },
          {
            floor: "Ground",
            number: "1",
            use: "Main Lobby, Retail and Driveway"
          },
          {
            floor: "Basement",
            number: "1",
            use: "Residential Parking"
          }
        ]
      }
    ],
    floors: [
      {
        name: "Tower 1",
        properties: [
          {
            col1: "No. of Studio Units",
            col2: "32"
          },
          {
            col1: "No. of 1BR Units",
            col2: "112"
          },
          {
            col1: "No. of 2BR Units",
            col2: "96"
          },
          {
            col1: "Total Units/Floor",
            col2: "15"
          },
          {
            col1: "Number of Floors",
            col2: "16"
          },
          {
            col1: "Total No. of Units",
            col2: "240"
          }
        ]
      },
      {
        name: "Tower 2",
        properties: [
          {
            col1: "No. of Studio Units",
            col2: "48"
          },
          {
            col1: "No. of 1BR Units",
            col2: "288"
          },
          {
            col1: "No. of Exec. 1BR Units",
            col2: "16"
          },
          {
            col1: "Total Units/Floor",
            col2: "22"
          },
          {
            col1: "Number of Floors",
            col2: "16"
          },
          {
            col1: "Total No. of Units",
            col2: "352"
          }
        ]
      }
    ],
    units: [
      {
        name: "One Bedroom Unit C - Tower 2",
        image: `${assetUrl}/grc/units/u1.png`,
        properties: [
          {
            name: "Living/Dining",
            values: "12.51 sqm"
          },
          {
            name: "Kitchen",
            values: "7.11 sqm"
          },
          {
            name: "Master BR",
            values: "10.08 sqm"
          },
          {
            name: "Master T&B",
            values: "6.30 sqm"
          },
          {
            name: "Balcony",
            values: "4.50 sqm"
          },
          {
            name: "Total",
            values: "40.50 sqm"
          }
        ]
      },
      {
        name: "Exsecutive One Bedroom Unit S - Tower 2",
        image: `${assetUrl}/grc/units/u2.png`,
        properties: [
          {
            name: "Living/Dining",
            values: "15.73 sqm"
          },
          {
            name: "Kitchen",
            values: "6.62 sqm"
          },
          {
            name: "Master BR",
            values: "13.91 sqm"
          },
          {
            name: "Master T&B",
            values: "5.33 sqm"
          },
          {
            name: "Utility with T&B",
            values: "6.91 sqm"
          },
          {
            name: "Total",
            values: "48.50 sqm"
          }
        ]
      },
      {
        name: "Studio Unit O - Tower 2",
        image: `${assetUrl}/grc/units/u3.png`,
        properties: [
          {
            name: "Living/Dining/Bedroom",
            values: "15.00 sqm"
          },
          {
            name: "Kitchen",
            values: "4.00 sqm"
          },
          {
            name: "T&B",
            values: "5.00 sqm"
          },
          {
            name: "Total",
            values: "24.00 sqm"
          }
        ]
      }
    ],
    unit_images: [
      `${assetUrl}/grc/units/1BR-Bedroom.png`,
      `${assetUrl}/grc/units/1BR-Kitchen.png`,
      `${assetUrl}/grc/units/1BR-Living-and-Dining.png`,
      `${assetUrl}/grc/units/2BR-Bedroom.png`,
      `${assetUrl}/grc/units/2BR-Living-and-Dining.png`,
      `${assetUrl}/grc/units/Studio-Dining.png`,
      `${assetUrl}/grc/units/Studio-Living.png`
    ],
    unit_features: [
      "Entrance panel door with viewer",
      "Intercom per unit connected to the reception counter",
      "Automatic smoke detectors, fire alarm and sprinkler system in all units",
      "Individual electric and water meter",
      "Telephone line at living area and master’s bedroom",
      "Cable TV line at living area and bedrooms",
      "Ventilation for kitchen and toilet",
      "Window-type air conditioner provision at all units",
      "Hot water line (water heater excluded) at kitchen and toilet",
      "Washer / dryer",
      "Standby power at selected areas in residential units",
      "One (1) ceiling light for living area and each bedroom",
      "One (1) convenience outlet for living and dining areas",
      "One (1) convenience outlet for refrigerator",
      "One (1) convenience outlet for each bedroom"
    ],
    unit_finishes: [
      {
        area: "Floor",
        bedroom: "Laminated Wood",
        living: "Homogeneous Tiles",
        kitchen: "Homogeneous Tiles",
        toilet: "Homogeneous Tiles",
        balcony: ""
      },
      {
        area: "Wall",
        bedroom: "Painted Plastered Wall",
        living: "Painted Plastered Wall",
        kitchen: "Painted Plastered Wall",
        toilet: "Combination of Plastered Wall and Homogenous Tiles",
        balcony: ""
      },
      {
        area: "Ceiling",
        bedroom: "Painted Slab Soffit",
        living: "Painted Slab Soffit",
        kitchen: "Painted Gypsum Board",
        toilet: "Painted Gypsum Board",
        balcony: ""
      },
      {
        area: "Other",
        bedroom: "Bedroom Closet",
        living: "",
        kitchen:
          "Single-Point Water Heater Provision (water heater excluded) Granite Countertop and Splashboard Overhead and undercounter Cabinets",
        toilet:
          "Multi-Point Water Heater Provision (water heater excluded) Lavatory with Granite Countertop",
        balcony: ""
      }
    ]
  },
  {
    id: 4,
    property_id: "40028",
    cover_image: `${assetUrl}/apc/cover.png`,
    logo_image: `${assetUrl}/apc/logo.jpg`,
    video: `https://www.youtube.com/embed/EozKDHNPpLk`,
    pdf: `${assetUrl}/apc/apc.pdf`,
    value_proposition:
      "Azalea Place targets competent single/married businessmen based in Cebu or its nearby provinces belonging to the income segment BBB to A. Azalea Place offers relaxed and convenient city living as provided by the project’s modern Asian atmosphere and amenities perfect for the Cebuano’s modern but calmer take on city living.",
    reasons: [
      "Architecture to adapt modern Asian design",
      "Basic leisure and business amenities",
      "Convenience facilities",
      "Comfortable and efficient unit spaces",
      "The perfect location advantage of being the only residential condominium in the busy street of Gorordo Avenue"
    ],
    address:
      "Located along Gorordo Avenue in Lahug, means Azalea Place is just a stone’s throw away from schools, commercial establishments, office buildings and hospitals in one of Cebu City’s most enviable addresses. It is just across the University of the Philippines, and is well-situated just between Cebu Business Park and Asiatown I.T. Park.",
    address_image: `${assetUrl}/apc/map.jpg`,
    lat: 10.3212582,
    lng: 123.8971872,
    nearby_establishments: [
      {
        name: "Schools",
        places: [
          {
            name: "University of the Philippines",
            distance: "10 km"
          },
          {
            name: "PAREF Springdale School",
            distance: "20 km"
          }
        ]
      },
      {
        name: "Malls",
        places: [
          {
            name: "Ayala Center Cebu",
            distance: "5 km"
          },
          {
            name: "Robinsons Cybergate",
            distance: "5 km"
          }
        ]
      },
      {
        name: "Government Offices",
        places: [
          {
            name: "Provincial Capitol",
            distance: "3.4 km"
          },
          {
            name: "DepEd Cebu",
            distance: "3.4 km"
          }
        ]
      },
      {
        name: "Business Parks",
        places: [
          {
            name: "Cebu I.T. Park",
            distance: "4.3 km"
          },
          {
            name: "Cebu Business Park",
            distance: "4.3 km"
          }
        ]
      }
    ],
    site_development_image: `${assetUrl}/apc/site-plan.png`,
    building_feature_image: `${assetUrl}/apc/cover.png`,
    site_development: [
      "Sits on a 2,158 sqm lot",
      "25-storey development",
      "408 units",
      "4 levels of basement parking"
    ],
    building_features: [
      "Entrance lobby with reception counter",
      "Three (3) passenger elevators, one of which will also serve as a service elevator",
      "CCTV Monitoring on selected common areas",
      "Automatic smoke detectors, fire alarm and sprinkler system at all common areas",
      "Annunciator panel with emergency speaker at all floors",
      "Elevated water tank and underground cistern",
      "Standby power generator for common areas and selected outlets in the residential unit",
      "Individual mail boxes",
      "Central garbage area",
      "Building Administration office",
      "Fire exits",
      "Laundry cages at roof deck level"
    ],
    design_concept: [
      "Azalea Place is the ideal contemporary living space for the progressive Cebuanos, featuring modern-Asian aesthetics in its building design and residential facilities that allows for complete relaxation and convenient city living.",
      "Modern Asian-inspired 25-storey residential development"
    ],
    design_partners: [
      "Architect: ASYA Design Partners",
      "Structural Designer: SY2 and Associates",
      "Plumbing, Sanitary and Fire: N.G. Yumol and Associates",
      "Electrical Designer: PCS Philippines, Inc.",
      "Mechanical Designer: L.R. Punzalan& Associates"
    ],
    amenities: [
      "Retail Units",
      "Library/Wi-Fi Lounge",
      "Indoor Game Room",
      "Audio-Visual Room",
      "Function Room",
      "Conference Room",
      "Business Center",
      "Fitness Center/Gym",
      "Japanese-inspired Gazebo",
      "Reading Nooks",
      "Swimming Pool",
      "Spa Pool"
    ],
    amenities_images: [
      `${assetUrl}/apc/amenities/am1.png`,
      `${assetUrl}/apc/amenities/am2.png`,
      `${assetUrl}/apc/amenities/am3.png`,
      `${assetUrl}/apc/amenities/am4.png`,
      `${assetUrl}/apc/amenities/am5.png`,
      `${assetUrl}/apc/amenities/am6.png`,
      `${assetUrl}/apc/amenities/am7.png`
    ],
    floor_plan_images: [
      `${assetUrl}/apc/fp/f1.png`,
      `${assetUrl}/apc/fp/f2.png`,
      `${assetUrl}/apc/fp/f3.png`
    ],
    floor_stacking: [
      {
        name: "",
        properties: [
          {
            floor: "3 to 26",
            number: "23",
            use: "Residential Units"
          },
          {
            floor: "2",
            number: "1",
            use: "Residential Units / Outdoor Amenities"
          },
          {
            floor: "Ground",
            number: "1",
            use: "Retail Units / Outdoor Amenities"
          },
          {
            floor: "Basement 1 to 4",
            number: "4",
            use: "Basement Parking"
          }
        ]
      }
    ],
    floors: [
      {
        name: "",
        properties: [
          {
            col1: "No. of Studio Units",
            col2: "24"
          },
          {
            col1: "No. of 1BR Units",
            col2: "313"
          },
          {
            col1: "No. of 2BR Units",
            col2: "71"
          },
          {
            col1: "Total Units/Floor",
            col2: "17"
          },
          {
            col1: "Number of Floors",
            col2: "24"
          },
          {
            col1: "Total No. of Units",
            col2: "408"
          }
        ]
      }
    ],
    units: [
      {
        name: "Studio",
        image: `${assetUrl}/apc/units/u3.png`,
        properties: [
          {
            name: "Living/Sleeping/Dining",
            values: "±15.10 sqm"
          },
          {
            name: "Kitchen",
            values: "±5.17 sqm"
          },
          {
            name: "Common T&B",
            values: "±4.63 sqm"
          },
          {
            name: "Balcony",
            values: "±4.50 sqm"
          },
          {
            name: "TOTAL",
            values: "±29.4 sqm"
          }
        ]
      },
      {
        name: "One Bedroom",
        image: `${assetUrl}/apc/units/u1.png`,
        properties: [
          {
            name: "Living/Dining",
            values: "±11.30 sqm"
          },
          {
            name: "Kitchen",
            values: "±3.70 sqm"
          },
          {
            name: "Master BR",
            values: "±10.00 sqm"
          },
          {
            name: "Master T&B",
            values: "±5.00 sqm"
          },
          {
            name: "Balcony",
            values: "±4.50 sqm"
          },
          {
            name: "TOTAL",
            values: "±34.50 sqm"
          }
        ]
      },
      {
        name: "Two Bedroom",
        image: `${assetUrl}/apc/units/u2.png`,
        properties: [
          {
            name: "Living/Dining",
            values: "±14.13 sqm"
          },
          {
            name: "Kitchen",
            values: "±3.74 sqm"
          },
          {
            name: "Master BR",
            values: "±9.92 sqm"
          },
          {
            name: "Master T&B",
            values: "±5.09 sqm"
          },
          {
            name: "2nd Bedroom",
            values: "±6.96 sqm"
          },
          {
            name: "Common T&B",
            values: "±4.66 sqm"
          },
          {
            name: "Balcony",
            values: "±4.50 sqm"
          },
          {
            name: "TOTAL",
            values: "±49.00 sqm"
          }
        ]
      }
    ],
    unit_images: [
      `${assetUrl}/apc/units/1BR-Bedroom.png`,
      `${assetUrl}/apc/units/1BR-Living-and-Dining.png`,
      `${assetUrl}/apc/units/2BR-Bedroom.png`,
      `${assetUrl}/apc/units/2BR-Living-and-Dining.png`,
      `${assetUrl}/apc/units/2BR-Sectional.png`,
      `${assetUrl}/apc/units/Studio.png`
    ],
    unit_features: [
      "Entrance panel with door viewer",
      "Intercom per unit connected to the reception counter",
      "Automatic smoke detectors, fire alarm and sprinkler system in all units",
      "Provisions for: Individual electric and water meter, Cable TV line, Telephone line per unit, Ventilation for kitchen and toilets, Window type air con openings and electrical outlet for all units except for Units B and O which will be provided with additional pipe sleeves and electrical provisions for split-type air con, Hot water supply line (excluding water heater) for shower area at Toilet and Bath",
      "Electrical load provision of 20 amp for 2-burner electric cooktop"
    ],
    unit_finishes: [
      {
        area: "Floor",
        bedroom: "Laminated Wood",
        living: "Homogeneous Tiles",
        kitchen: "Homogeneous Tiles",
        toilet: "Ceramic Tiles"
      },
      {
        area: "Wall",
        bedroom: "Plastered Painted Finish",
        living: "Plastered Painted Finish",
        kitchen: "Plastered Painted Finish",
        toilet: "Combination of Plastered Painted Cement and Ceramic Tiles"
      },
      {
        area: "Ceiling",
        bedroom: "Painted Slab Soffit",
        living: "Painted Slab Soffit",
        kitchen: "Painted Slab Soffit",
        toilet: "Painted Gypsum Board"
      },
      {
        area: "Other Deliverables",
        bedroom: "Bedroom Closet",
        living:
          "Granite Kitchen Countertop, Kitchen Sink Faucet, Kitchen Sink, Kitchen Base, Overhead Cabinet",
        kitchen:
          "Granite Kitchen Countertop, Kitchen Sink Faucet, Kitchen Sink, Kitchen Base, Overhead Cabinet",
        toilet:
          "Water Closet, Tissue Paper Holder, Shower Head, Towel Bar, Lavatory with, Granite, Countertop for T&B"
      }
    ]
  },
  {
    id: 5,
    property_id: "40030",
    cover_image: `${assetUrl}/rmb/cover.png`,
    logo_image: `${assetUrl}/rmb/logo.png`,
    pdf: `${assetUrl}/rmb/rmb.pdf`,
    video: `https://www.youtube.com/embed/lfUu3EG6Zjo`,
    value_proposition:
      "For competent individuals from the BBB to A income segment, The Radiance Manila Bay provides a relaxing and convenient living experience, brought about by the complex’s wide range of wellness amenities, central location, and efficiently cut living spaces that promotes a life of wellness.",
    reasons: [
      "SIGHTS AND SOUNDS TO ENRICH TO YOUR SOUL",
      "WAVES OF DAILY CALM",
      "STREAMS OF COMFORT IN YOUR LIVING SPACES"
    ],
    address:
      "The Radiance Manila Bay is located along historic Roxas Boulevard, -- an address with a glorious past, famous for its sunsets and beautifully-lined coconut trees.",
    address_image: `${assetUrl}/rmb/map.png`,
    lat: 14.5575543,
    lng: 120.9862043,
    nearby_establishments: [
      {
        name: "CCP Complex",
        places: [
          {
            name: "Cultural Center of the Phillippines",
            distance: "10 km"
          },
          {
            name: "Folk Arts Theater",
            distance: "20 km"
          },
          {
            name: "Manila Film Center",
            distance: "20 km"
          }
        ]
      },
      {
        name: "Museums",
        places: [
          {
            name: "The Metropolitan Musuem of Manila",
            distance: "5 km"
          },
          {
            name: "Museo Pambata",
            distance: "5 km"
          },
          {
            name: "Banko Sentral ng Pilipinas Money Museum",
            distance: "5 km"
          }
        ]
      },
      {
        name: "Parks",
        places: [
          {
            name: "Rizal Park",
            distance: "3.4 km"
          },
          {
            name: "Manila Ocean Park",
            distance: "3.4 km"
          }
        ]
      },
      {
        name: "Hotels",
        places: [
          {
            name: "Traders Hotel",
            distance: "4.3 km"
          },
          {
            name: "Manila Hotel",
            distance: "4.3 km"
          },
          {
            name: "Diamond Hotel",
            distance: "4.3 km"
          },
          {
            name: "Sofitel Plaza Hotel",
            distance: "4.3 km"
          },
          {
            name: "Heritage Hotel",
            distance: "4.3 km"
          },
          {
            name: "Midas Hotel and Casino",
            distance: "4.3 km"
          },
          {
            name: "Manila Yacht Club",
            distance: "4.3 km"
          }
        ]
      },
      {
        name: "Convention and Trade Center",
        places: [
          {
            name: "Philippine International and Convention Center (PICC)",
            distance: "3.4 km"
          },
          {
            name: "World Trade Center",
            distance: "3.4 km"
          },
          {
            name: "SMX Convention Center",
            distance: "3.4 km"
          },
          {
            name: "SM Moa Arena",
            distance: "3.4 km"
          }
        ]
      },
      {
        name: "Government Buildings",
        places: [
          {
            name: "Bangko Sentral ng Pilipinas",
            distance: "3.4 km"
          },
          {
            name: "Department of Foreign Affairs",
            distance: "3.4 km"
          },
          {
            name: "Department of Finance",
            distance: "3.4 km"
          },
          {
            name: "Philippine Navy",
            distance: "3.4 km"
          },
          {
            name: "Senate of the Philippines",
            distance: "3.4 km"
          },
          {
            name:
              "Office of the Vice President of the Philippines (Coconut Palace)",
            distance: "3.4 km"
          }
        ]
      },
      {
        name: "Foreign Embassies",
        places: [
          {
            name: "Embassy of United States",
            distance: "3.4 km"
          },
          {
            name: "Embassy of Japan",
            distance: "3.4 km"
          }
        ]
      },
      {
        name: "Malls",
        places: [
          {
            name: "Robinsons Place Manila",
            distance: "3.4 km"
          },
          {
            name: "SM Mall of Asia",
            distance: "3.4 km"
          }
        ]
      }
    ],
    site_development_image: `${assetUrl}/rmb/site-plan.png`,
    building_feature_image: `${assetUrl}/rmb/cover.png`,
    site_development: [
      "Approx. 8,629 sq.m land area",
      "Residential area approx. 6,112 sq.m",
      "2 residential towers",
      "30 residential floors",
      "4 level podium parking",
      "3 levels of retail experience"
    ],
    building_features: [
      "Main entrance lobby with reception counter at the Ground Floor",
      "Four (4) elevators (3 passenger elevators and 1 service cum service)",
      "CCTV monitoring at selected common areas",
      "Automatic smoke detectors, fire alarm and sprinkler system at all common areas",
      "Annunciator panel with emergency speaker at selected floors",
      "Water is supplied by an elevated water tank and underground cistern",
      "Standby power generator for all common areas",
      "Individual mail boxes",
      "Garbage holding area per residential floor",
      "Centralized garbage holding room located at the Ground Floor",
      "Building administration office",
      "Security room",
      "Driver’s lounge and toilet",
      "Transformer and genset room",
      "Sewage treatment plant",
      "Two (2) fire exits per building with well-lighted signage conforming to Fire Code of the Philippines"
    ],
    design_concept: [
      "Modern architectural design",
      "Applies principle of Green Architecture",
      "Design philosophy takes inspiration from water, which is associated with luck and prosperity",
      "Concrete facade with glass windows",
      "All flat units"
    ],
    design_partners: [
      "Architectural: ASYA Design",
      "Structural: SY2 & Associates",
      "Plumbing, Sanitary & Fire Protection: N.G. Yumol + Associates",
      "Electrical: PCS Philippines Inc.",
      "Mechanical: L.R. Punsalan & Associates",
      "Landscape: Espina, Perez - Espina & Associates"
    ],
    amenities: [
      "Reading Lounge",
      "Function Room",
      "Kid’s Play Area",
      "Game Room",
      "Videoke Room",
      "Private Theater",
      "Spa/Sauna/Massage Room",
      "Semi-Open lounge",
      "50-m Lap Pool",
      "Kiddie Pool",
      "Transition Pool",
      "Outdoor Lounge",
      "Arbour Lounge",
      "Sunset Grove and Pavilion",
      "Meditation Exercise Garden",
      "Activity Lawn and Play Area",
      "Pool Deck Lounge",
      "Garden Walk",
      "Flower Garden",
      "Gazebo",
      "Sky Lounge (Roof Deck)"
    ],
    amenities_images: [
      `${assetUrl}/rmb/amenities/am1.png`,
      `${assetUrl}/rmb/amenities/am2.png`,
      `${assetUrl}/rmb/amenities/am3.png`,
      `${assetUrl}/rmb/amenities/am4.png`,
      `${assetUrl}/rmb/amenities/am5.png`,
      `${assetUrl}/rmb/amenities/am6.png`,
      `${assetUrl}/rmb/amenities/am7.png`,
      `${assetUrl}/rmb/amenities/am8.png`
    ],
    floor_plan_images: [
      `${assetUrl}/rmb/fp/f1.png`,
      `${assetUrl}/rmb/fp/f2.png`,
      `${assetUrl}/rmb/fp/f3.png`
    ],
    floor_stacking: [
      {
        name: "North",
        properties: [
          {
            floor: "35 to 26",
            number: "2",
            use: "Residential Units"
          },
          {
            floor: "32 to 34",
            number: "3",
            use: "Residential Units"
          },
          {
            floor: "28 to 31",
            number: "5",
            use: "Residential Units"
          },
          {
            floor: "22 to 27",
            number: "6",
            use: "Residential Units"
          },
          {
            floor: "18 to 21",
            number: "4",
            use: "Residential Units"
          },
          {
            floor: "7 to 17",
            number: "10",
            use: "Residential Units"
          },
          {
            floor: "6",
            number: "1",
            use: "Garden Units"
          },
          {
            floor: "2 to 5",
            number: "4",
            use: "Podium Parking"
          },
          {
            floor: "Ground",
            number: "1",
            use: "Main Lobby"
          }
        ]
      },
      {
        name: "South",
        properties: [
          {
            floor: "34 to 26",
            number: "3",
            use: "Residential Units"
          },
          {
            floor: "32 to 33",
            number: "2",
            use: "Residential Units"
          },
          {
            floor: "22 to 31",
            number: "10",
            use: "Residential Units"
          },
          {
            floor: "17 to 21",
            number: "5",
            use: "Residential Units"
          },
          {
            floor: "7 to 16",
            number: "9",
            use: "Residential Units"
          },
          {
            floor: "6",
            number: "1",
            use: "Garden Zone"
          },
          {
            floor: "2 to 5",
            number: "4",
            use: "Podium Parking"
          },
          {
            floor: "Ground",
            number: "1",
            use: "Main Lobby"
          }
        ]
      }
    ],
    floors: [
      {
        name: "North Tower",
        properties: [
          {
            col1: "No. of 1BR Units",
            col2: "398"
          },
          {
            col1: "No. of 2BR Units",
            col2: "118"
          },
          {
            col1: "No. of 3BR Units",
            col2: "8"
          },
          {
            col1: "No. of Penthouse",
            col2: "14"
          },
          {
            col1: "Total Units/Floor",
            col2:
              "6th – 17,7th - 17th – 21,22nd - 27th – 21,18th - 21st – 13,28th - 31st – 20,32nd - 34th – 13,35th - 36th – 7"
          },
          {
            col1: "Number of Floors",
            col2: "36"
          },
          {
            col1: "Total No. of Units",
            col2: "538"
          }
        ]
      },
      {
        name: "South Tower",
        properties: [
          {
            col1: "No. of Studio Units",
            col2: "27"
          },
          {
            col1: "No. of 1BR Units",
            col2: "352"
          },
          {
            col1: "No. of E1BR Units",
            col2: "28"
          },
          {
            col1: "No. of 2BR Units",
            col2: "114"
          },
          {
            col1: "No. of 3BR Units",
            col2: "6"
          },
          {
            col1: "Total Units/Floor",
            col2: "6th – 17,7th to 21st – 20,27th to 34th – 14,35th to 36th – 9"
          },
          {
            col1: "Number of Floors",
            col2: "36"
          },
          {
            col1: "Total No. of Units",
            col2: "527"
          }
        ]
      }
    ],
    units: [
      {
        name: "One Bedroom",
        image: `${assetUrl}/rmb/units/u1.png`,
        properties: [
          {
            name: "Living",
            values: "6.90 sqm"
          },
          {
            name: "Kitchen/Dining",
            values: "13.19 sqm"
          },
          {
            name: "Bedroom",
            values: "9.90 sqm"
          },
          {
            name: "T&B",
            values: "6.01 sqm"
          },
          {
            name: "Balcony",
            values: "4.00 sqm"
          },
          {
            name: "Total",
            values: "40.00 sqm"
          }
        ]
      },
      {
        name: "Two Bedroom",
        image: `${assetUrl}/rmb/units/u2.png`,
        properties: [
          {
            name: "Living/Hallway",
            values: "23.02 sqm"
          },
          {
            name: "Dining",
            values: "11.74 sqm"
          },
          {
            name: "Kitchen",
            values: "6.41 sqm"
          },
          {
            name: "Utility",
            values: "5.95 sqm"
          },
          {
            name: "Bedroom",
            values: "7.83 sqm"
          },
          {
            name: "Master's Bedroom",
            values: "12.20 sqm"
          },
          {
            name: "Master's T&B",
            values: "5.45 sqm"
          },
          {
            name: "Common T&B",
            values: "5.40 sqm"
          },
          {
            name: "Balcony",
            values: "4.00 sqm"
          },
          {
            name: "Balcony 2",
            values: "4.50 sqm"
          },
          {
            name: "Total",
            values: "86.50 sqm"
          }
        ]
      },
      {
        name: "Executive One Bedroom",
        image: `${assetUrl}/rmb/units/u3.png`,
        properties: [
          {
            name: "Living",
            values: "12.96 sqm"
          },
          {
            name: "Dining",
            values: "10.33 sqm"
          },
          {
            name: "Kitchen",
            values: "11.12 sqm"
          },
          {
            name: "Utility",
            values: "4.64 sqm"
          },
          {
            name: "Bedroom",
            values: "10.38 sqm"
          },
          {
            name: "T&B",
            values: "5.07 sqm"
          },
          {
            name: "Balcony",
            values: "4.50 sqm"
          },
          {
            name: "Total",
            values: "59.00 sqm"
          }
        ]
      },
      {
        name: "Studio",
        image: `${assetUrl}/rmb/units/u4.png`,
        properties: [
          {
            name: "Living/Bedroom",
            values: "10.44 sqm"
          },
          {
            name: "Kitchen/Dining",
            values: "7.68 sqm"
          },
          {
            name: "T&B",
            values: "5.88 sqm"
          },
          {
            name: "Total",
            values: "24.00 sqm"
          }
        ]
      }
    ],
    unit_images: [
      `${assetUrl}/rmb/units/1BR-Bedroom.png`,
      `${assetUrl}/rmb/units/1BR-Dining.png`,
      `${assetUrl}/rmb/units/1BR-Living.png`,
      `${assetUrl}/rmb/units/2BR-Bedroom.png`,
      `${assetUrl}/rmb/units/2BR-Dining.png`,
      `${assetUrl}/rmb/units/2BR-Master_s-Bedroom.png`,
      `${assetUrl}/rmb/units/3BR-Bedroom-1.png`,
      `${assetUrl}/rmb/units/3BR-Bedroom-2.png`,
      `${assetUrl}/rmb/units/3BR-Living-and-Dining.png`,
      `${assetUrl}/rmb/units/3BR-Master_s-Bedroom.png`
    ],
    unit_features: [
      "Entrance panel door with viewer",
      "Intercom per unit connected to the reception counter",
      "Automatic smoke detectors, fire alarm and sprinkler system in all units",
      "Provisions for: Individual electric and water meters, Telephone line at living area and master’s bedroom, Cable TV line at living area and bedrooms, Ventilation for kitchen and toilets, Hot water supply line (excluding water heater) for toilet and kitchen, Space provision for washer/dryer for all units, Window-type air conditioner openings and electrical outlet for all units except for all unit H which are provisioned with a combination of window-type and split-type air conditioner",
      "Standby power at selected outlets in residential unit as follows: One (1) ceiling light for living area and each bedroom, One (1) convenience outlet for living and dining areas, One (1) convenience outlet for refrigerator, One (1) convenience outlet for each bedroom"
    ],
    unit_finishes: [
      {
        area: "Floor",
        bedroom: "Laminated Wood",
        living: "Homogeneous Tiles",
        kitchen: "Homogeneous Tiles",
        toilet: "Homogeneous Tiles"
      },
      {
        area: "Wall",
        bedroom: "Painted Plastered Finish",
        living: "Painted Plastered Finish",
        kitchen: "Painted Plastered Finish",
        toilet: "Combination of Painted Plastered Wall and Homogenous Tiles"
      },
      {
        area: "Ceiling",
        bedroom: "Painted Slab Soffit",
        living: "Painted Slab Soffit",
        kitchen: "Painted Gypsum Board",
        toilet: "Painted Gypsum Board"
      },
      {
        area: "Other Deliverables",
        bedroom: "Bedroom Closet",
        living: "",
        kitchen:
          "Single-Point Water Heater Provision (water heater excluded), Granite Countertop and Splashboard, Overhead and Undercounter Kitchen Cabinets, 2-burner cooktop with rangehood (Studio, 1BR, and Exec 1BR units), 4-burner cooktop with rangehood (2BR units), Outlet for: Refrigerator - 350W, Cooktop - 20AMPS",
        toilet: ""
      }
    ]
  },
  {
    id: 6,
    property_id: "40033",
    cover_image: `${assetUrl}/rws/cover.jpg`,
    logo_image: `${assetUrl}/rws/logo.jpg`,
    pdf: `${assetUrl}/rws/rws.pdf`,
    video: `https://www.youtube.com/embed/J-FccSBpBTs`,
    value_proposition:
      "The Residences at The Westin Manila Sonata Place offers prime branded residential condominium development located at the heart of Ortigas Center. It provides generous living suite-like unit spaces, comprehensive medley of amenities, hotel-like signature services, and exclusive VIP benefits provided by the heritage of excellence expected from a Westin brand –creating a haven of serenity and an experience of pampered living for well-travelled individuals and expatriates who appreciates luxury and world class standards.",
    reasons: [
      "World class service that discerning travellers have come to expect",
      "Offers services, products and amenities that rejuvenate, renew and restore the mind, body and spirit.",
      "A haven of serenity and distinctive alternatives for those who appreciates higher standards of luxury and pampering",
      "Known for signature services, amenities and hospitality product innovations like Westin WORKOUT® fitness center and Westin Heavenly® Bed and Bath",
      "The Residences at The Westin Manila Sonata Place takes pride in curating every detail of each residence, so that the finishes and fixtures speak of luxury, with your well-being in mind. All residences are equipped with Westin signature features and luxury brand products.",
      "The Westin Heavenly® Bed",
      "The Westin Heavenly® Bath Shower Experience",
      "Gaggenau for kitchen appliances",
      "Leicht for kitchen cabinets",
      "Duravit,and Hansgrohe for toilet & bath fixtures and finishes",
      "At the core of the Westin brand is the life of wellness. The goal is to help you achieve balanced living by creating thoughtful spaces where you can sleep well, eat well, move well, feel well, work well, and play well—the six pillars of well-being Westin designed for a better you.",
      "A la carte hotel services such as housekeeping, in-residence dining, catering, transportation, and in-residence spa are all available to the homeowners of The Residences at The Westin Manila Sonata Place.",
      "The homeowners of The Residences at The Westin Manila Sonata Place are entitled to receive the Starwood Preferred Guest® Gold Card, valid for five (5) years. Unlock a world of possibilities as you get to enjoy special benefits on distinctive hotel brands under Marriott International — including St. Regis®, The Ritz‑Carlton® and Westin®. The Starwood Preferred Guest® Gold Card can be linked with Marriott Rewards or The Ritz‑Carlton Rewards®."
    ],
    address:
      "San Miguel Avenue corner Lourdes St., Brgy Wack – Wack, Mandaluyong City",
    address_image: `${assetUrl}/rws/map.jpg`,
    lat: 14.5811898,
    lng: 121.0562823,
    nearby_establishments: [
      {
        name: "Corporate Headquarters",
        places: [
          {
            name: "San Miguel Corporation",
            distance: "10 km"
          },
          {
            name: "Hewlett-Packard",
            distance: "20 km"
          },
          {
            name: "BDO",
            distance: "20 km"
          },
          {
            name: "Jollibee",
            distance: "20 km"
          },
          {
            name: "Asia Development Bank",
            distance: "20 km"
          },
          {
            name: "Robinsons Land",
            distance: "20 km"
          },
          {
            name: "The Philippine Stock Exchange",
            distance: "20 km"
          }
        ]
      },
      {
        name: "Hotels",
        places: [
          {
            name: "Crowne Plaza Manila Galleria",
            distance: "5 km"
          },
          {
            name: "Edsa Shangri-la Hotel",
            distance: "5 km"
          },
          {
            name: "Marco Polo Ortigas",
            distance: "5 km"
          },
          {
            name: "Discovery Suites Ortigas",
            distance: "5 km"
          },
          {
            name: "Oakwood Joy Nostalg",
            distance: "5 km"
          },
          {
            name: "Holiday Inn Manila Galleria",
            distance: "5 km"
          }
        ]
      },
      {
        name: "Medical Facilities",
        places: [
          {
            name: "Medical City",
            distance: "3.4 km"
          },
          {
            name: "Medical Plaza Ortigas",
            distance: "3.4 km"
          }
        ]
      },
      {
        name: "Academic Institutions",
        places: [
          {
            name: "University of Asia and the Pacific",
            distance: "4.3 km"
          },
          {
            name: "Lourdes School of Mandaluyong",
            distance: "4.3 km"
          },
          {
            name: "St. Paul College Pasig",
            distance: "4.3 km"
          },
          {
            name: "St. Pedro Poveda",
            distance: "4.3 km"
          },
          {
            name: "Ateneo Medical School",
            distance: "4.3 km"
          }
        ]
      },
      {
        name: "High-end Villages",
        places: [
          {
            name: "Valle Verde",
            distance: "4.3 km"
          },
          {
            name: "Greenmeadows",
            distance: "4.3 km"
          },
          {
            name: "Corinthian Gardens",
            distance: "4.3 km"
          },
          {
            name: "Wack-wack",
            distance: "4.3 km"
          },
          {
            name: "White Plains",
            distance: "4.3 km"
          },
          {
            name: "Greenhills",
            distance: "4.3 km"
          }
        ]
      }
    ],
    site_development_image: `${assetUrl}/rws/site-plan.jpg`,
    building_feature_image: `${assetUrl}/rws/cover.jpg`,
    site_development: [
      "Approximately 11 kilometers away from the Ninoy Aquino International Airport, The Residences at The Westin Manila Sonata Place is strategically located at the heart of Ortigas Center. It is found in the midst of major corporate headquarters (such as the Asian Development Bank, Philippine Stock Exchange, and San Miguel Corporation), exciting commercial shopping centers (Robinsons Galleria, Shangri-La Mall, and SM Megamall, to name a few), as well as countless medical facilities, dining establishments, schools, and places of worship."
    ],
    building_features: [
      "Safety & Security",
      "Exclusive residential access",
      "24-hour security and building maintenance",
      "Fully addressable fire detection and alarm system",
      "Access card for elevators and residential unit",
      "CCTV in common areas and elevators",
      "100% back-up power",
      "Convenience & Services",
      "24-hour concierge desk at the Ground floor",
      "Four (4) high speed passenger elevators",
      "One (1) dedicated service elevator",
      "Exclusive access to The Westin Manila Sonata Place at the Second Floor",
      "Wi-fi connection in common areas",
      "Pre-assigned appurtenant parking slot/s for every residential unit",
      "Hotel a la carte services, such as housekeeping, in-residences dining, catering, transportation and in-residence spa",
      "Exclusive residential drop-off area",
      "Main entrance lobby with reception counter",
      "Fully addressable fire detection and alarm system",
      "Five (5) elevators (4 passenger and 1 service)",
      "CCTV monitoring in select common areas and elevators",
      "Water is supplied by an elevated water tank and underground cistern",
      "100% standby power in residential unit and common areas",
      "Individual mailboxes at the G/F",
      "Wi-Fi in select amenity areas",
      "Centralized garbage holding room at Basement Level 1",
      "Garbage holding area per residential floor",
      "Building administration office",
      "Security room",
      "Transformer and generator set room"
    ],
    design_concept: [
      "The exteriors of The Residences feature a contrast of colors that allows it to blend seamlessly with its urban setting, massive windows that showcase city views and light-colored façade elements that provide a sense of calming rhythm.",
      "From the signature White Tea scent and vertical garden to mood-lifting botanicals, atmospheric lighting and music, every element is designed to energize and refresh guests from the moment they arrive."
    ],
    design_partners: [
      "Handel Architects | Architectural Design Consultant",
      "FBEye International | Interior Design Consultant",
      "Magnusson Klemencic Associates | Structural Peer Review",
      "RWDI Anemos, Ltd. | Wind Tunnel Consultant",
      "W.V. Coscoluella & Associates | Architect of Record",
      "Sy^2 + Associates, Inc. | Structural Consultant"
    ],
    amenities: [
      "Private Drop-off Area",
      "Grand Lobby",
      "Concierge Desk",
      "Mail Room",
      "Retail Spaces",
      "Reception Center",
      "Pre-function Areas",
      "Function Rooms",
      "Business Lounge",
      "Meeting Rooms",
      "Boardroom",
      "Wine Room",
      "Resident’s Lounge",
      "Private Theater",
      "Audio-Visual Room",
      "Game Room",
      "The Studio (Music Room)",
      "Sound Stage",
      "Recital Studio",
      "The Playhouse (Children’s Indoor Play Area)",
      "Residential Administration Office",
      "Tee on Third (Golf Simulation Room)",
      "Indoor Lap Pool",
      "Kiddie Pool",
      "Pool Deck and Lounge",
      "Fitness Center",
      "Outdoor Children’s Play Area",
      "Changing Room with Sauna and Hot Tub",
      "Move Studio (Dance Studio)"
    ],
    amenities_images: [
      `${assetUrl}/rws/amenities/am1.jpg`,
      `${assetUrl}/rws/amenities/am2.jpg`,
      `${assetUrl}/rws/amenities/am3.jpg`,
      `${assetUrl}/rws/amenities/am4.jpg`,
      `${assetUrl}/rws/amenities/am5.jpg`,
      `${assetUrl}/rws/amenities/am6.jpg`,
      `${assetUrl}/rws/amenities/am7.jpg`,
      `${assetUrl}/rws/amenities/am8.jpg`,
      `${assetUrl}/rws/amenities/am9.jpg`,
      `${assetUrl}/rws/amenities/am10.jpg`,
      `${assetUrl}/rws/amenities/am11.jpg`,
      `${assetUrl}/rws/amenities/am12.jpg`,
      `${assetUrl}/rws/amenities/am13.jpg`,
      `${assetUrl}/rws/amenities/am14.jpg`,
      `${assetUrl}/rws/amenities/am15.jpg`,
      `${assetUrl}/rws/amenities/am16.jpg`,
      `${assetUrl}/rws/amenities/am17.jpg`,
      `${assetUrl}/rws/amenities/am18.jpg`
    ],
    floor_plan_images: [
      `${assetUrl}/rws/fp/f1.png`,
      `${assetUrl}/rws/fp/f2.png`,
      `${assetUrl}/rws/fp/f3.png`
    ],
    floor_stacking: [
      {
        name: "",
        properties: [
          {
            floor: "5th – 11th",
            number: "7",
            use: "1BR Zone"
          },
          {
            floor: "12th – 16th",
            number: "4",
            use: "1BR Zone"
          },
          {
            floor: "17th – 23rd",
            number: "7",
            use: "1BR and 2BR Zone"
          },
          {
            floor: "24th and 27th",
            number: "2",
            use: "1BR and 2BR Zone"
          },
          {
            floor: "25th and 26th",
            number: "2",
            use: "1BR and 2BR Zone"
          },
          {
            floor: "28th – 35th",
            number: "8",
            use: "2BR Zone"
          },
          {
            floor: "36th – 39th",
            number: "4",
            use: "1BR and 2BR Zone"
          },
          {
            floor: "40th – 46th",
            number: "7",
            use: "3BR Zone"
          },
          {
            floor: "47th",
            number: "1",
            use: "2BR and 3BR Zone"
          },
          {
            floor: "48th",
            number: "1",
            use: "2BR and 3BR Zone"
          },
          {
            floor: "49th",
            number: "1",
            use: "Lower Penthouse"
          },
          {
            floor: "50th",
            number: "1",
            use: "Upper Penthouse"
          }
        ]
      }
    ],
    floors: [
      {
        name: "",
        properties: [
          {
            col1: "1-Bedroom",
            col2: "47.29 – 82.70"
          },
          {
            col1: "2-Bedroom",
            col2: "96.52 – 160.17"
          },
          {
            col1: "3-Bedroom",
            col2: "173.79 – 254.77"
          },
          {
            col1: "Penthouse",
            col2: "234.25 – 249.22"
          },
          {
            col1: "Total No. of Units",
            col2: "344 units"
          }
        ]
      }
    ],
    units: [
      {
        name: "One Bedroom",
        image: `${assetUrl}/rws/units/u1.png`,
        properties: [
          {
            name: "Living/Dining",
            values: "±19.58 sqm"
          },
          {
            name: "Kitchen",
            values: "±5.52 sqm"
          },
          {
            name: "Master Bedroom",
            values: "±18.02 sqm"
          },
          {
            name: "Master T&B",
            values: "±5.92 sqm"
          },
          {
            name: "Laundry (W/D)",
            values: "±0.73 sqm"
          },
          {
            name: "Total",
            values: "49.77 sqm"
          }
        ]
      },
      {
        name: "Two Bedroom",
        image: `${assetUrl}/rws/units/u2.png`,
        properties: [
          {
            name: "Living/Dining",
            values: "±42.79 sqm"
          },
          {
            name: "Kitchen",
            values: "±14.39 sqm"
          },
          {
            name: "Master Bedroom",
            values: "±27.99 sqm"
          },
          {
            name: "Master T&B",
            values: "±7.58 sqm"
          },
          {
            name: "Bedroom 2",
            values: "±14.71 sqm"
          },
          {
            name: "Common T&B",
            values: "±6.35 sqm"
          },
          {
            name: "Bedroom Hallway",
            values: "±5.44 sqm"
          },
          {
            name: "Utility Room",
            values: "±10.17 sqm"
          },
          {
            name: "Utility T&B",
            values: "±3.80 sqm"
          },
          {
            name: "Balcony (Master Bedroom)",
            values: "±11.82 sqm"
          },
          {
            name: "Balcony (Living)",
            values: "±2.31 sqm"
          },
          {
            name: "Balcony (Dining)",
            values: "±10.37 sqm"
          },
          {
            name: "Total",
            values: "±157.72 sqm"
          }
        ]
      },
      {
        name: "Three Bedroom",
        image: `${assetUrl}/rws/units/u3.png`,
        properties: [
          {
            name: "Living/Dining",
            values: "±40.45 sqm"
          },
          {
            name: "Powder Room",
            values: "±4.41 sqm"
          },
          {
            name: "Kitchen",
            values: "±17.40 sqm"
          },
          {
            name: "Master Bedroom",
            values: "±32.55 sqm"
          },
          {
            name: "Master T&B",
            values: "±9.72 sqm"
          },
          {
            name: "Bedroom 2",
            values: "±18.01 sqm"
          },
          {
            name: "Bedroom 2 T&B",
            values: "±6.86 sqm"
          },
          {
            name: "Bedroom 3",
            values: "±23.21 sqm"
          },
          {
            name: "Bedroom T&B",
            values: "±5.89 sqm"
          },
          {
            name: "Bedroom Hallway",
            values: "±7.69 sqm"
          },
          {
            name: "Utility Room",
            values: "±12.66 sqm"
          },
          {
            name: "Utility T&B",
            values: "±3.80 sqm"
          },
          {
            name: "Balcony (Master Bedroom)",
            values: "±5.74 sqm"
          },
          {
            name: "Balcony (Living)",
            values: "±2.31 sqm"
          },
          {
            name: "Balcony (Dining)",
            values: "±10.37 sqm"
          },
          {
            name: "Total",
            values: "±201.07 sqm"
          }
        ]
      }
    ],
    unit_images: [
      `${assetUrl}/rws/units/ui1.jpg`,
      `${assetUrl}/rws/units/ui2.jpg`,
      `${assetUrl}/rws/units/ui3.jpg`,
      `${assetUrl}/rws/units/ui4.jpg`,
      `${assetUrl}/rws/units/ui5.jpg`,
      `${assetUrl}/rws/units/ui6.jpg`,
      `${assetUrl}/rws/units/ui7.jpg`,
      `${assetUrl}/rws/units/ui8.jpg`,
      `${assetUrl}/rws/units/ui9.jpg`
    ],
    unit_features: [
      "Entrance panel door with viewer and access card",
      "Audio intercom connected to the reception counter",
      "Automatic smoke detectors, fire alarm and sprinkler system",
      "Grease trap in kitchen",
      "Duress button in all master bedroom",
      "Individual electric and water meters",
      "Hot water line for master T&B; provision for hot water line (water heater excluded) at common T&B and kitchen",
      "Provision for: Telephone line in living area and master bedroom, Cable TV line in living area and all bedrooms (except utility room), Ventilation for kitchen and T&B"
    ],
    unit_finishes: [
      {
        area: "Floor",
        bedroom: "Engineered Wood",
        living: "Engineered Wood",
        kitchen: "Homogeneous Tiles",
        toilet: "Natural stone / Homogenous tiles / Natural stone"
      },
      {
        area: "Wall",
        bedroom: "Painted finish with painted wood baseboard",
        living: "Painted finish with painted wood baseboard",
        kitchen: "Painted finish with homogenous tile skirting",
        toilet:
          "Full height natural stone for shower area; painted finish with natural stone skirting for other areas / homogenous tile skirting for other areas"
      },
      {
        area: "Ceiling",
        bedroom: "Painted slab soffit with bulkhead",
        living: "Painted slab soffit with bulkhead",
        kitchen: "Moisture resistant gypsum painted finish",
        toilet: "Moisture resistant gypsum painted finish"
      },
      {
        area: "Other Deliverables",
        bedroom:
          "The Westin Heavenly® Bed (for Master Bedroom only), Bedroom closet",
        living: "",
        kitchen:
          "Solid surface countertop and splashboard / Built-in overhead and base cabinets / Provision for single-point water heater (water heater excluded)",
        toilet:
          "Built-in base cabinets with natural stone countertop / Glass shower enclosure with door in shower area / Lavatory, water closet, rain shower, mixer and hand spray / Multi-point water heater"
      }
    ]
  },
  {
    id: 7,
    property_id: "40021",
    cover_image: `${assetUrl}/sdr/cover.png`,
    logo_image: `${assetUrl}/sdr/logo.png`,
    pdf: `${assetUrl}/sdr/sdr.pdf`,
    video: `https://www.youtube.com/embed/9c52LFXzNT4`,
    value_proposition:
      "The strategic location of Signa Designer Residences in the heart of Makati Commercial and Business District., specifically in Salcedo Village, allow one to easily access major thoroughfares in the area such as corporate centers, educational institutions, commercial centers, and healthcare institutions. The Philippines&#39; first designer residence, Signa Designer Residences was designed by globally-recognized architects Budji Layug, Royal Pineda and Kenneth Cobonpue. Enjoy premium amenities and facilities in an artistic and tropical-inspired urban haven and with only 14 units per floor, the spacious and meticulously planned units were designed to fit one’s evolving taste. Indulge on Signa Designer Residences’ wide array of culinary offerings with Ramen Nagi, Hai Chix and Steak, Starbucks Reserve, and Poly Incense.",
    reasons: [
      "The strategic location of Signa Designer Residences in the heart of Makati Commercial and Business District, specifically in Salcedo Village, allow one to easily access major thoroughfares in the area such as corporate centers, educational institutions, commercial centers, and healthcare institutions.",
      "The Philippines’ first designer residence, Signa Designer Residences was designed by globally-recognized architects Budji Layug, Royal Pineda and Kenneth Cobonpue.",
      "Enjoy premium amenities and facilities in an artistic and tropical-inspired urban haven and with only 14 units per floor, the spacious and meticulously planned units were designed to fit one’s evolving taste.",
      "Indulge on Sigma Designer Residences’ wide array of culinary offerings with Ramen Nagi, Hai Chix and Steak, Starbucks Reserve, and Poly Incense."
    ],
    address:
      "Strategically located at the heart of Makati, the project is near major access roads, schools, medical institutions and commercial establishments, corporate offices and headquarters",
    address_image: `${assetUrl}/sdr/map.png`,
    lat: 14.5592355,
    lng: 121.0169571,
    nearby_establishments: [
      {
        name: "Corporate Centers",
        places: [
          {
            name: "Robinsons Summit Center",
            distance: "10 km"
          },
          {
            name: "Citibank Tower",
            distance: "20 km"
          },
          {
            name: "Social Security System Building",
            distance: "10 km"
          },
          {
            name: "Philippine Bank of Commerce",
            distance: "20 km"
          },
          {
            name: "SMART Tower",
            distance: "10 km"
          },
          {
            name: "Rufino Pacific Tower",
            distance: "20 km"
          },
          {
            name: "Insular Life Building",
            distance: "10 km"
          },
          {
            name: "RCBC Tower",
            distance: "20 km"
          },
          {
            name: "Philippine Stock Exchange Plaza",
            distance: "10 km"
          },
          {
            name: "Makati Stock Exchange",
            distance: "20 km"
          },
          {
            name: "Royal Embassy of Saudi Arabia",
            distance: "10 km"
          },
          {
            name: "Norwegian Embassy",
            distance: "20 km"
          },
          {
            name: "Embassy of Malaysia",
            distance: "10 km"
          },
          {
            name: "Embassy of Brazil",
            distance: "20 km"
          }
        ]
      },
      {
        name: "Commercial Centers",
        places: [
          {
            name: "Greenbelt",
            distance: "5 km"
          },
          {
            name: "SM Makati",
            distance: "5 km"
          },
          {
            name: "Glorietta Mall",
            distance: "5 km"
          },
          {
            name: "The Landmark",
            distance: "5 km"
          },
          {
            name: "Rustan’s Supermarket",
            distance: "5 km"
          }
        ]
      },
      {
        name: "Educational Institutions",
        places: [
          {
            name: "MAPUA Institute of Technology",
            distance: "3.4 km"
          },
          {
            name: "Lyceum of the Philippines",
            distance: "3.4 km"
          },
          {
            name: "Ateneo Professional School",
            distance: "3.4 km"
          },
          {
            name: "Asian Institute of Management",
            distance: "3.4 km"
          },
          {
            name: "Centro Escolar University Makati",
            distance: "3.4 km"
          },
          {
            name: "De La Salle Graduate School Of Business",
            distance: "3.4 km"
          }
        ]
      },
      {
        name: "Recreation and Lifestyle",
        places: [
          {
            name: "Greenbelt Park",
            distance: "4.3 km"
          },
          {
            name: "Jaime Velasquez Park",
            distance: "4.3 km"
          },
          {
            name: "Ayala Triangle Garden",
            distance: "4.3 km"
          },
          {
            name: "Makati Sports Club",
            distance: "4.3 km"
          },
          {
            name: "Hair Philosophie by Jing Monis Salon",
            distance: "4.3 km"
          },
          {
            name: "Felipe and Sons Barbersdashery",
            distance: "4.3 km"
          }
        ]
      },
      {
        name: "Healthcare Institution",
        places: [
          {
            name: "Makati Medical Center",
            distance: "4.3 km"
          },
          {
            name: "Medical Plaza Makati",
            distance: "4.3 km"
          }
        ]
      },
      {
        name: "Hotels",
        places: [
          {
            name: "Makati Shangri-La Hotel",
            distance: "4.3 km"
          },
          {
            name: "The Manila Peninsula Hotel",
            distance: "4.3 km"
          },
          {
            name: "Dusit Thani Hotel",
            distance: "4.3 km"
          }
        ]
      }
    ],
    site_development_image: `${assetUrl}/sdr/site-plan.png`,
    building_feature_image: `${assetUrl}/sdr/cover.png`,
    site_development: [
      "Two Residential Towers",
      "Retail strip in the ground level",
      "Podium and basement parking"
    ],
    building_features: [
      "Grand Atrium",
      "Tower Lobby with reception and lounge areas designed by Kenneth Cobonpue featuring his furniture",
      "Three (3) passenger elevators",
      "Building Administration Office",
      "Centralized Mail Room",
      "24-hour Security",
      "CCTV monitoring of selected common areas",
      "Annunciator panel with emergency speakers at all floors",
      "Automatic smoke detectors, fire alarm and sprinkler system in all common areas",
      "Fire Exits",
      "100% back up power for all common areas and residential units",
      "Water reservoir",
      "Centralized garbage room"
    ],
    design_concept: [
      "Rising at the heart of the country’s major financial district, Makati City, the Philippines’ first designer residences is a two-tower development with a modern tropical artisanal-inspired aesthetic. The unique development will make use of masterpieces from internationally-renowned interior designers Budji Layug, Royal Pineda and furniture designer Kenneth Cobonpue, making it a signature property not only within the area but in the world. Thus, the name Signa Designer Residences."
    ],
    design_partners: [
      "Architect-on-record: Danilo C. Ibay Architects",
      "Designers: Budji Layug + Royal Pineda, Kenneth Cobonpue",
      "Mechanical: LR Punzalan Associates",
      "Electrical: Mar Alix & Partners",
      "Plumbing/Sanitation: Noel B. Franco and Associates",
      "Structural: G. E. Origenes and Associates Consulting Engineers"
    ],
    amenities: [
      "Game Room",
      "Kids’ Playroom",
      "Therapeutic and Massage Room",
      "Fitness Gym",
      "Sauna Room",
      "Meditation Enclave",
      "Function Room",
      "Multi-purpose Room",
      "Private Theater",
      "Reading Room",
      "Playground",
      "Outdoor Bar",
      "Leisure Pool with Sun Deck",
      "Children’s Pool"
    ],
    amenities_images: [
      `${assetUrl}/sdr/amenities/am1.png`,
      `${assetUrl}/sdr/amenities/am2.png`,
      `${assetUrl}/sdr/amenities/am3.png`,
      `${assetUrl}/sdr/amenities/am4.png`,
      `${assetUrl}/sdr/amenities/am5.png`,
      `${assetUrl}/sdr/amenities/am6.png`,
      `${assetUrl}/sdr/amenities/am7.png`,
      `${assetUrl}/sdr/amenities/am8.png`,
      `${assetUrl}/sdr/amenities/am9.png`,
      `${assetUrl}/sdr/amenities/am10.png`
    ],
    floor_plan_images: [
      `${assetUrl}/sdr/floor_plan_images/f1.png`,
      `${assetUrl}/sdr/floor_plan_images/f2.png`
    ],
    floor_stacking: [
      {
        name: "TOWER 1",
        properties: [
          {
            floor: "30th",
            number: "1",
            use: "Penthouse"
          },
          {
            floor: "3rd to 29th",
            number: "26",
            use: "Residential Floors"
          },
          {
            floor: "2nd",
            number: "1",
            use: "Amenities"
          },
          {
            floor: "Ground",
            number: "1",
            use: "Lobby"
          },
          {
            floor: "Basement 1 to 5",
            number: "5",
            use: "Basement Parking"
          }
        ]
      },
      {
        name: "TOWER 2",
        properties: [
          {
            floor: "30th",
            number: "1",
            use: "Penthouse"
          },
          {
            floor: "3rd to 29th",
            number: "26",
            use: "Residential Floors"
          },
          {
            floor: "2nd",
            number: "1",
            use: "Amenities"
          },
          {
            floor: "Ground",
            number: "1",
            use: "Lobby"
          },
          {
            floor: "Basement 1 to 5",
            number: "5",
            use: "Basement Parking"
          }
        ]
      }
    ],
    floors: [
      {
        name: "Tower 1",
        properties: [
          {
            col1: "No. of Studio Units",
            col2: ""
          },
          {
            col1: "No. of 1BR Units",
            col2: ""
          },
          {
            col1: "No. of E1BR Units",
            col2: ""
          },
          {
            col1: "No. of 2BR Units",
            col2: ""
          },
          {
            col1: "Total Units/Floor",
            col2: "30"
          },
          {
            col1: "Number of Floors",
            col2: "30"
          },
          {
            col1: "Total No. of Units",
            col2: "307"
          }
        ]
      },
      {
        name: "Tower 2",
        properties: [
          {
            col1: "No. of Studio Units",
            col2: ""
          },
          {
            col1: "No. of 1BR Units",
            col2: ""
          },
          {
            col1: "No. of E1BR Units",
            col2: ""
          },
          {
            col1: "No. of 2BR Units",
            col2: ""
          },
          {
            col1: "Total Units/Floor",
            col2: "30"
          },
          {
            col1: "Number of Floors",
            col2: "29"
          },
          {
            col1: "Total No. of Units",
            col2: "353"
          }
        ]
      }
    ],
    units: [
      {
        name: "One Bedroom",
        image: `${assetUrl}/sdr/models/u1.png`,
        properties: [
          {
            name: "Living/Kitchen/Dining",
            values: "±32.18 sqm"
          },
          {
            name: "Master Bedroom",
            values: "±10.26 sqm"
          },
          {
            name: "T&B",
            values: "±4.12 sqm"
          },
          {
            name: "Utility Room",
            values: "±6.24 sqm"
          },
          {
            name: "Balcony",
            values: "±3.30 sqm"
          },
          {
            name: "Total",
            values: "±56.10 sqm"
          }
        ]
      },
      {
        name: "Two Bedroom",
        image: `${assetUrl}/sdr/models/u2.png`,
        properties: [
          {
            name: "Living/Kitchen/Dining",
            values: "±30.00 sqm"
          },
          {
            name: "Master Bedroom",
            values: "±12.70 sqm"
          },
          {
            name: "Master T&B",
            values: "±4.50 sqm"
          },
          {
            name: "Bedroom 2",
            values: "±12.45 sqm"
          },
          {
            name: "T&B",
            values: "±5.55 sqm"
          },
          {
            name: "Utility Room",
            values: "±6.90 sqm"
          },
          {
            name: "Balcony",
            values: "±3.75 sqm"
          },
          {
            name: "Total",
            values: "±75.85 sqm"
          }
        ]
      },
      {
        name: "Three Bedroom",
        image: `${assetUrl}/sdr/models/u3.png`,
        properties: [
          {
            name: "Living/Kitchen/Dining",
            values: "±37.12 sqm"
          },
          {
            name: "Master Bedroom",
            values: "±14.55 sqm"
          },
          {
            name: "Master T&B",
            values: "±5.02 sqm"
          },
          {
            name: "Bedroom 2",
            values: "±9.39 sqm"
          },
          {
            name: "BedRoom 3",
            values: "±9.36 sqm"
          },
          {
            name: "T&B",
            values: "±5.82 sqm"
          },
          {
            name: "Utility Room",
            values: "±3.22 sqm"
          },
          {
            name: "Balcony 1",
            values: "±3.66 sqm"
          },
          {
            name: "Balcony 2",
            values: "±3.36 sqm"
          },
          {
            name: "Total",
            values: "±91.50 sqm"
          }
        ]
      },
      {
        name: "Executive One Bedroom",
        image: `${assetUrl}/sdr/models/u4.png`,
        properties: [
          {
            name: "Living/",
            values: "±8.75 sqm"
          },
          {
            name: "Kitchen/Dining",
            values: "±11.47 sqm"
          },
          {
            name: "Master Bedroom",
            values: "±15.00 sqm"
          },
          {
            name: "T&B",
            values: "±5.86 sqm"
          },
          {
            name: "Balcony",
            values: "±3.36 sqm"
          },
          {
            name: "Total",
            values: "±44.44 sqm"
          }
        ]
      },
      {
        name: "Penthouse",
        image: `${assetUrl}/sdr/models/u5.png`,
        properties: [
          {
            name: "Deck 1",
            values: "±18.35 sqm"
          },
          {
            name: "Deck",
            values: "±12.00 sqm"
          },
          {
            name: "Deck 3",
            values: "±14.30 sqm"
          },
          {
            name: "Living",
            values: "±40.04 sqm"
          },
          {
            name: "DIning",
            values: "±24.06 sqm"
          },
          {
            name: "Powder Room",
            values: "±4.51 sqm"
          },
          {
            name: "Utility Room",
            values: "±9.51 sqm"
          },
          {
            name: "Kitchen",
            values: "±24.52 sqm"
          },
          {
            name: "Hallway",
            values: "±39.95 sqm"
          },
          {
            name: "Master Bedroom",
            values: "±36.66 sqm"
          },
          {
            name: "Master's T&B",
            values: "±12.05 sqm"
          },
          {
            name: "Bedroom 2",
            values: "±23.88 sqm"
          },
          {
            name: "Bedroom 2 W.I.C/T&B",
            values: "±8.32 sqm"
          },
          {
            name: "Bedroom 3",
            values: "±25.77 sqm"
          },
          {
            name: "Bedroom 3 W.I.C/T&B",
            values: "±10.38 sqm"
          },
          {
            name: "Master T&B",
            values: "±3.95 sqm"
          },
          {
            name: "Balcony",
            values: "±3.95 sqm"
          },
          {
            name: "Balcony 2",
            values: "±3.05 sqm"
          },
          {
            name: "Total",
            values: "±311.30 sqm"
          }
        ]
      },
      {
        name: "Studio",
        image: `${assetUrl}/sdr/models/u6.png`,
        properties: [
          {
            name: "Kitchen/Dining",
            values: "±12.35 sqm"
          },
          {
            name: "Living/Bedroom",
            values: "±20.00 sqm"
          },
          {
            name: "T&B",
            values: "±4.85 sqm"
          },
          {
            name: "Balcony",
            values: "±3.66 sqm"
          },
          {
            name: "Total",
            values: "±40.86 sqm"
          }
        ]
      }
    ],
    unit_images: [
      `${assetUrl}/sdr/models/ui1.png`,
      `${assetUrl}/sdr/models/ui2.png`,
      `${assetUrl}/sdr/models/ui3.png`,
      `${assetUrl}/sdr/models/ui4.png`,
      `${assetUrl}/sdr/models/ui5.png`,
      `${assetUrl}/sdr/models/ui6.png`
    ],
    unit_features: [
      "Entrance panel door with viewer",
      "Intercom per unit connected to the reception counter",
      "Individual electric and water meter",
      "Cable TV line per unit",
      "Telephone line per unit",
      "Electrical power provision and ledge for owner-supplied split type air-conditioning unit",
      "Ventilation for kitchen and toilets",
      "Provision for hot water supply line (excluding water heater) for shower at toilet and bath",
      "Automatic smoke detector and fire alarm with sprinkler system in all units",
      "Utility room with toilet for 2-Bedroom and 3-Bedroom units only",
      "Balcony with steel railings at selected units"
    ],
    unit_finishes: [
      {
        area: "Floor",
        bedroom: "Engineered wood",
        living: "Homogeneous Tiles",
        kitchen: "Homogeneous Tiles",
        toilet: "Ceramic Tiles"
      },
      {
        area: "Wall",
        bedroom: "Painted Plastered Wall",
        living: "Painted Plastered Wall",
        kitchen: "Painted Plastered Wall",
        toilet: "Combination of Ceramic Tiles and Plastered Painted Wall"
      },
      {
        area: "Ceiling",
        bedroom: "Painted Slab Soffit",
        living: "Painted Slab Soffit",
        kitchen: "Painted Slab Soffit",
        toilet: "Painted Gypsum Board"
      },
      {
        area: "Other Deliverables",
        bedroom:
          "Bedroom closets / Provision for split-type  aircon / Utility room with maid’s toilet and bath for 2BR and 3BR units / Aluminum-framed glass windows",
        living: "Aluminum-framed glass windows",
        kitchen:
          "Kitchen granite countertop with overhead and undercounter cabinets / Aluminum-framed glass windows / Bedroom closets",
        toilet: "Mechanical ventilation in selected units"
      }
    ]
  },
  {
    id: 8,
    property_id: "40019",
    cover_image: `${assetUrl}/tmr/cover.png`,
    logo_image: `${assetUrl}/tmr/logo.jpg`,
    pdf: `${assetUrl}/tmr/tmr.pdf`,
    video: `https://www.youtube.com/embed/aDZG6R8x7Ps`,
    value_proposition:
      "Competent individuals, Chinese and second generation families residing in QC coming from the BBB to A segment, The Magnolia Residences provides a happy, friendly neighborhood ambiance and ease in everyday living as part of a master-planned residential commercial complex in the middle of a residential area for a relaxed and comfortable life.",
    reasons: [
      "SHOPPING AND ENTERTAINMENT AT YOUR DOORSTEP",
      "Chic cafes, popular restaurants and bars, four state-of-the-art cinemas with stadium style seating and an al-fresco at the nearby Robinsons Magnolia Mall",
      "Established local and international shops",
      "MODERN LIVING SPACES",
      "Various unit types and sizes suited to each family’s needs and aspirations",
      "Wide choice of amenities",
      "EVERYTHING WITHIN REACH",
      "Accessible via the city’s major modes of transportation such as LRT 2 line",
      "Close proximity to hospitals such as St. Luke’s and Cardinal Santos as well as schools like St. Paul University, Xavier School, Immaculate Conception Academy and La Salle Greenhills",
      "The location also facilitates access to main roads leading to key urban hubs like Greenhills, Makati, Cubao and Ortigas"
    ],
    address:
      "Located at the heart of New Manila in Quezon City, The Magnolia Residences is surrounded by the city’s key places for leisure, business, health, and education.",
    address_image: `${assetUrl}/tmr/map.png`,
    lat: 14.6138408,
    lng: 121.0362978,
    nearby_establishments: [
      {
        name: "Hospitals",
        places: [
          {
            name: "St. Lukes Medical Center",
            distance: "10 km"
          },
          {
            name: "Cardinal Santos Memorial Medical Center",
            distance: "20 km"
          }
        ]
      },
      {
        name: "Schools",
        places: [
          {
            name: "St. Paul University",
            distance: "5 km"
          },
          {
            name: "Xavier School",
            distance: "5 km"
          },
          {
            name: "Immaculate Conception Academy",
            distance: "5 km"
          },
          {
            name: "La Salle Greenhills",
            distance: "5 km"
          }
        ]
      },
      {
        name: "Shopping Centers",
        places: [
          {
            name: "Robinsons Magnolia Mall",
            distance: "3.4 km"
          },
          {
            name: "Greenhills Shopping Center",
            distance: "3.4 km"
          },
          {
            name: "Gilmore Techno Hub",
            distance: "3.4 km"
          }
        ]
      },
      {
        name: "Key Urban Hubs",
        places: [
          {
            name: "Cubao",
            distance: "4.3 km"
          },
          {
            name: "Ortigas",
            distance: "4.3 km"
          },
          {
            name: "Makati",
            distance: "4.3 km"
          }
        ]
      },
      {
        name: "Train Stations",
        places: [
          {
            name: "Betty-Go Belmonte LRT Station",
            distance: "4.3 km"
          },
          {
            name: "Gilmore LRT Station",
            distance: "4.3 km"
          }
        ]
      }
    ],
    site_development_image: `${assetUrl}/tmr/site-plan.png`,
    building_feature_image: `${assetUrl}/tmr/cover.png`,
    site_development: [
      "Situated on a five-hectare mixed-use development",
      "Four Residential Towers",
      "Retail strip tucked in the residential development’s Basement A level",
      "Podium and basement parking"
    ],
    building_features: [
      "3 elevators (2 passenger elevators and 1 service elevator)",
      "Main entrance lobby at the lower ground floor",
      "CCTV monitoring at selected common areas",
      "Automatic smoke detectors and fire alarm with sprinkler system at all common areas",
      "Annunciator panel with emergency speaker at all floors",
      "Standby power generator for common areas",
      "Transformer and genset room",
      "Individual mailboxes per building",
      "Garbage holding area per residential floor and centralized garbage holding room at Basement A",
      "Building administration office",
      "Security room",
      "Driver’s lounge and toilet",
      "2 fire exits"
    ],
    design_concept: [
      "Mixed-use residential condominium development",
      "Modern flat design concept",
      "Concrete facade with glass windows"
    ],
    design_partners: [
      "Architectural Partner: ASYA Design",
      "Structural Design: SY2 Associates, Inc.",
      "Landscape Design: Efren Aurelio Landscape Architect"
    ],
    amenities: [
      "Private theater",
      "Aerobics/yoga room",
      "Multipurpose room",
      "Gym",
      "Game room",
      "Children’s playroom",
      "Shower and locker room",
      "Zen garden",
      "Function room",
      "Sundeck function area",
      "Library with WiFi lounge",
      "Swimming pool",
      "Children’s pool",
      "Gazebos",
      "Barbecue pit",
      "Rock garden",
      "Jogging path",
      "Open lawn",
      "Table tennis room",
      "Badminton court",
      "Function room",
      "Multipurpose room",
      "WiFi lounge",
      "Children’s outdoor playground",
      "Tree house",
      "Wading pool/Jacuzzi",
      "More multipurpose rooms"
    ],
    amenities_images: [
      `${assetUrl}/tmr/amenities/am1.png`,
      `${assetUrl}/tmr/amenities/am2.png`,
      `${assetUrl}/tmr/amenities/am3.png`,
      `${assetUrl}/tmr/amenities/am4.png`
    ],
    floor_plan_images: [`${assetUrl}/tmr/floor_plan_images/f1.png`],
    floor_stacking: [
      {
        name: "TOWER C",
        properties: [
          {
            floor: "38th to 39th",
            number: "2",
            use: "Residential Floors"
          },
          {
            floor: "34th to 37th",
            number: "4",
            use: "Residential Floors"
          },
          {
            floor: "4th to 33rd",
            number: "29",
            use: "Residential Floors"
          },
          {
            floor: "3rd",
            number: "1",
            use: "Residential Floors"
          },
          {
            floor: "2nd",
            number: "1",
            use: "Podium Parking"
          },
          {
            floor: "Upper Ground",
            number: "1",
            use: "Main Lobby"
          },
          {
            floor: "Lower Ground",
            number: "1",
            use: "Amenities"
          },
          {
            floor: "Basement A",
            number: "1",
            use: "Basement Parking and Retail Area"
          },
          {
            floor: "Basement B to D",
            number: "3",
            use: "Basement Parking"
          }
        ]
      },
      {
        name: "TOWER D",
        properties: [
          {
            floor: "21st to 37th",
            number: "16",
            use: "Residential Floors"
          },
          {
            floor: "8th to 20th",
            number: "12",
            use: "Residential Floors"
          },
          {
            floor: "7th",
            number: "1",
            use: "Residential Floors"
          },
          {
            floor: "Basement A to 6",
            number: "6",
            use: "Indoor and podium Amenities"
          },
          {
            floor: "Basement D to B",
            number: "3",
            use: "Basement Parking"
          }
        ]
      }
    ],
    floors: [
      {
        name: "Tower C",
        properties: [
          {
            col1: "No. of 1BR Units",
            col2: "239"
          },
          {
            col1: "No. of 2BR Units",
            col2: "90"
          },
          {
            col1: "No. of E2BR Units",
            col2: "98"
          },
          {
            col1: "No. of 3BR Units",
            col2: "9"
          },
          {
            col1: "No. of 4BR Units",
            col2: "2"
          },
          {
            col1: "Total Units/Floor",
            col2: "13"
          },
          {
            col1: "Number of Floors",
            col2: "39"
          },
          {
            col1: "Total No. of Units",
            col2: "433"
          }
        ]
      },
      {
        name: "Tower D",
        properties: [
          {
            col1: "No. of 1BR Units",
            col2: "390"
          },
          {
            col1: "No. of E2BR Units",
            col2: "30"
          },
          {
            col1: "Total Units/Floor",
            col2: "14"
          },
          {
            col1: "Number of Floors",
            col2: "37"
          },
          {
            col1: "Total No. of Units",
            col2: "420"
          }
        ]
      }
    ],
    units: [
      {
        name: "One Bedroom",
        image: `${assetUrl}/tmr/models/u1.png`,
        properties: [
          {
            name: "Living/Kitchen",
            values: "±7.72 sqm"
          },
          {
            name: "Living/Dining",
            values: "±14.89 sqm"
          },
          {
            name: "Master Bedroom",
            values: "±8.71 sqm"
          },
          {
            name: "Master's T&B",
            values: "±5.18 sqm"
          },
          {
            name: "TOTAL",
            values: "±36.50 sqm"
          }
        ]
      },
      {
        name: "Two Bedroom",
        image: `${assetUrl}/tmr/models/u2.png`,
        properties: [
          {
            name: "Living",
            values: "±9.45 sqm"
          },
          {
            name: "Kitchen/Dining",
            values: "±11.27 sqm"
          },
          {
            name: "Master Bedroom",
            values: "±11.70 sqm"
          },
          {
            name: "Master's T&B",
            values: "±4.96 sqm"
          },
          {
            name: "Bedroom 2",
            values: "±10.24 sqm"
          },
          {
            name: "Bedroom 2 T&B",
            values: "±4.96 sqm"
          },
          {
            name: "Utility Room",
            values: "±6.20 sqm"
          },
          {
            name: "Balcony",
            values: "±4.50 sqm"
          },
          {
            name: "TOTAL",
            values: "±63.25 sqm"
          }
        ]
      },
      {
        name: "Executive Two Bedroom",
        image: `${assetUrl}/tmr/models/u3.png`,
        properties: [
          {
            name: "Foyer",
            values: "±5.16 sqm"
          },
          {
            name: "Living",
            values: "±10.47 sqm"
          },
          {
            name: "Dining",
            values: "±9.76 sqm"
          },
          {
            name: "Kitchen",
            values: "±7.82 sqm"
          },
          {
            name: "T&B",
            values: "±5.46 sqm"
          },
          {
            name: "Master's Bedroom",
            values: "±13.63 sqm"
          },
          {
            name: "Master's T&B",
            values: "±7.07 sqm"
          },
          {
            name: "Bedroom 2",
            values: "±9.30 sqm"
          },
          {
            name: "Utility Room",
            values: "±5.43 sqm"
          },
          {
            name: "Balcony",
            values: "±4.50 sqm"
          },
          {
            name: "TOTAL",
            values: "±78.60 sqm"
          }
        ]
      }
    ],
    unit_images: [
      `${assetUrl}/tmr/models/1BR-Bedroom.png`,
      `${assetUrl}/tmr/models/1BR-Living-and-Dining.png`,
      `${assetUrl}/tmr/models/2BR-Bedroom.png`,
      `${assetUrl}/tmr/models/2BR-Kitchen-and-Dining.png`,
      `${assetUrl}/tmr/models/2BR-Living.png`
    ],
    unit_features: [
      "Entrance panel door with viewer",
      "Intercom per unit connected to the security/reception counter",
      "Automatic smoke detectors and fire alarm with sprinkler system in all units",
      "Provisions for: Individual electric and water meter, Cable TV line, Telephone line, Provision for owner-supplied window-type air-conditioners, Space provision for washer/dryer for all units, Ventilation for kitchen and toilets, Provision for multipoint water heater line (excluding water heater) fo kitchen and toilet",
      "Automatic smoke detectors and fire alarm with sprinkler system in all units",
      "Utility room with toilet for Executive 1BR units",
      "Balconies for selected 1BR units",
      "Standby power at selected outlets in residential units"
    ],
    unit_finishes: [
      {
        area: "Floor",
        bedroom: "Laminated Wood",
        living: "Homogeneous Tiles",
        kitchen: "Homogeneous Tiles",
        toilet: "Homogeneous Tiles"
      },
      {
        area: "Wall",
        bedroom: "Painted Plastered Wall",
        living: "Painted Plastered Wall",
        kitchen: "Painted Plastered Wall",
        toilet: "Combination of Plastered Painted Wall and Homogenous Tiles"
      },
      {
        area: "Ceiling",
        bedroom: "Painted Slab Soffit",
        living: "Painted Slab Soffit",
        kitchen: "Painted Slab Soffit",
        toilet: "Painted Gypsum Board"
      },
      {
        area: "Other Deliverables",
        bedroom: "Bedroom closets",
        living: "",
        kitchen:
          "Single-Point Water Heater / Provision (water heater excluded) / Granite Countertop and Splashboard / Overhead and undercounter Cabinets",
        toilet:
          "Multi-Point Water Heater /Provision (water heater excluded) / Lavatory with Granite Countertop"
      }
    ]
  },
  {
    id: 9,
    property_id: "40024",
    cover_image: `${assetUrl}/tsb/cover.png`,
    logo_image: `${assetUrl}/tsb/logo.png`,
    pdf: `${assetUrl}/tsb/tsb.pdf`,
    video: `https://www.youtube.com/embed/QEHYE4sl0C0`,
    value_proposition:
      "For active and career-oriented individuals, The Sapphire Bloc is a four-tower complex that is set to be a stand-out destination for authentic lifestyle finds, as seen in the ground floor’s unique mix of specialty restaurants and shops, completed by the development’s prime location and efficiently designed living spaces, perfect for authentic and efficient city living.",
    reasons: [
      "THE WALKABLE LIFE",
      "Located within Ortigas Business Center",
      "A centrally located, integrated development in close proximity to offices and commercial institutions",
      "Accessibility to main roads like C5 and EDSA",
      "AUTHENTIC LIFESTYLE FINDS",
      "Unique restaurants cooked up by individuals who have put their passions, their beloved family histories and their idealism into their gourmet dishes",
      "Services that offers a holistic approach to wellness",
      "YOUR OWN EFFICIENT LIVING SPACE",
      "Generously sized one and two bedroom unit options",
      "A residential enclave providing efficient living spaces and thoughtfully designed amenities to promote community convergence"
    ],
    address:
      "Found at the very heart of commercial and business hub in Ortigas Center, this stunning condominium development is bounded by Onyx, Sapphire and Garnet streets where it lies surrounded by towering office buildings and bustling commercial establishments.",
    address_image: `${assetUrl}/tsb/map.png`,
    lat: 14.5873089,
    lng: 121.0609042,
    nearby_establishments: [
      {
        name: "Corporate Offices",
        places: [
          {
            name: "Robinsons Equitable Tower",
            distance: "10 km"
          },
          {
            name: "Integrated Bar of the Philippines Building",
            distance: "20 km"
          },
          {
            name: "One San Miguel Building",
            distance: "20 km"
          },
          {
            name: "Meralco Corporate Office",
            distance: "20 km"
          },
          {
            name: "Rockwell Business Center",
            distance: "20 km"
          },
          {
            name: "Union Bank Plaza",
            distance: "20 km"
          },
          {
            name: "Philippine Stock Exchange Towers",
            distance: "20 km"
          },
          {
            name: "San Miguel Corporate Office",
            distance: "20 km"
          }
        ]
      },
      {
        name: "Entertainment/Leisure Establishments",
        places: [
          {
            name: "Robinsons Galleria",
            distance: "5 km"
          },
          {
            name: "The Podium",
            distance: "5 km"
          },
          {
            name: "The Podium",
            distance: "5 km"
          },
          {
            name: "EDSA Shangri-La",
            distance: "5 km"
          },
          {
            name: "SM Megamall",
            distance: "5 km"
          }
        ]
      },
      {
        name: "Hotels",
        places: [
          {
            name: "Holiday Inn Manila Galleria",
            distance: "3.4 km"
          },
          {
            name: "Crowne Plaza Manila Galleria",
            distance: "3.4 km"
          },
          {
            name: "Marco Polo Hotel",
            distance: "3.4 km"
          },
          {
            name: "EDSA Shangri-la Hotel",
            distance: "3.4 km"
          },
          {
            name: "Discovery Suites",
            distance: "3.4 km"
          },
          {
            name: "Oakwood Premier Joy-Nostalg Center",
            distance: "3.4 km"
          }
        ]
      },
      {
        name: "Schools",
        places: [
          {
            name: "St. Paul College, Pasig",
            distance: "4.3 km"
          },
          {
            name: "University of Asia and the Pacific",
            distance: "4.3 km"
          },
          {
            name: "Saint Pedro Poveda College",
            distance: "4.3 km"
          },
          {
            name: "Lourdes School of Mandaluyong",
            distance: "4.3 km"
          },
          {
            name: "De La Salle, Greenhills",
            distance: "4.3 km"
          },
          {
            name: "Domuschola International School",
            distance: "4.3 km"
          }
        ]
      },
      {
        name: "Hospitals",
        places: [
          {
            name: "The Medical City",
            distance: "4.3 km"
          }
        ]
      }
    ],
    site_development_image: `${assetUrl}/tsb/site-plan.png`,
    building_feature_image: `${assetUrl}/tsb/cover.png`,
    site_development: [
      "Total area: 8,400 sqm.",
      "4 Residential towers",
      "Phase 1 – North Tower and West Tower",
      "Phase 2 – East Tower and South Tower",
      "West Tower 38 physical floors",
      "5 levels basement parking (residential)",
      "Retail area at the ground floor"
    ],
    building_features: [
      "Main entrance lobby with reception counters shared by North & West Towers",
      "Four elevators (3 passenger, 1 passenger cum service)",
      "CCTV monitoring on selected common areas",
      "Annunciator panel with emergency speaker at selected floors",
      "Water is supplied by elevated water tank and underground cistern",
      "Standby power generator for all common areas and at selected outlets in residential units",
      "Individual mail boxes at Ground Floor",
      "Wi-Fi at selected Amenity Areas",
      "Garbage holding area per residential floor",
      "Central garbage holding room located at Basement 1",
      "Building administration office located at Ground Floor",
      "Security room located at Ground Floor",
      "Common laundry and drying area at the Roof Deck of each tower",
      "Transformer and genset room at the Upper Parking Floor",
      "Driver's lounge and toilet located at Basement 1",
      "Sewage Treatment Plant located below Basement 5",
      "Two (2) fire exit stairs per residential building with well-lighted signages conforming to the Fire Code of the Philippines"
    ],
    design_concept: [
      "Mixed-use development",
      "Modern/art deco inspired architecture",
      "Concrete facade with glass windows",
      "All flat units"
    ],
    design_partners: [
      "Architectural Consultant: W.V Coscolluela & Associates",
      "Landscaping Consultant: PGAA Creative Design",
      "Contractor: CE Construction / Amcon & Company"
    ],
    amenities: [
      "Function Rooms",
      "Private Theater",
      "Game Room",
      "Fitness Gym Lounge",
      "Kids’ Play Area",
      "Spa & Sauna",
      "Adult Lap Pool",
      "Kiddie Pool",
      "Pool Deck",
      "Lawn",
      "Children’s Playground",
      "Gazebo",
      "Reading Nook",
      "Landscaped Areas"
    ],
    amenities_images: [
      `${assetUrl}/tsb/amenities/am1.png`,
      `${assetUrl}/tsb/amenities/am2.png`,
      `${assetUrl}/tsb/amenities/am3.png`,
      `${assetUrl}/tsb/amenities/am4.png`
    ],
    floor_plan_images: [
      `${assetUrl}/tsb/floor_plan_images/f1.png`,
      `${assetUrl}/tsb/floor_plan_images/f2.png`,
      `${assetUrl}/tsb/floor_plan_images/f3.png`
    ],
    floor_stacking: [
      {
        name: "West Tower",
        properties: [
          {
            floor: "38th",
            number: "1",
            use: "Residential Floors"
          },
          {
            floor: "28th – 37th",
            number: "10",
            use: "Residential Floors"
          },
          {
            floor: "3rd – 27th",
            number: "14",
            use: "Residential Floors"
          },
          {
            floor: "Mezzanine",
            number: "1",
            use: "Indoor and podium Amenities"
          },
          {
            floor: "Upper Parking",
            number: "1",
            use: "Basement Parking"
          },
          {
            floor: "Ground Floor",
            number: "1",
            use: "Basement Parking"
          },
          {
            floor: "Basement 1-5",
            number: "5",
            use: "Basement Parking"
          }
        ]
      }
    ],
    floors: [
      {
        name: "North Tower",
        properties: [
          {
            col1: "No. of 1BR Units",
            col2: "342"
          },
          {
            col1: "No. of 2BR Units",
            col2: "50"
          },
          {
            col1: "No. of E2BR Units",
            col2: "20"
          },
          {
            col1: "No. of 3BR Units",
            col2: "2"
          },
          {
            col1: "Total Units/Floor",
            col2: "6th – 6,3rd to 27th – 14,28th to 37th – 7,38th - 2"
          },
          {
            col1: "Number of Floors",
            col2: "38"
          },
          {
            col1: "Total No. of Units",
            col2: "414"
          }
        ]
      },
      {
        name: "West Tower",
        properties: [
          {
            col1: "No. of 1BR Units",
            col2: "342"
          },
          {
            col1: "No. of 2BR Units",
            col2: "50"
          },
          {
            col1: "No. of E2BR Units",
            col2: "20"
          },
          {
            col1: "No. of 3BR Units",
            col2: "2"
          },
          {
            col1: "Total Units/Floor",
            col2: "6th – 6,3rd to 27th – 14,28th to 37th – 7,38th - 2"
          },
          {
            col1: "Number of Floors",
            col2: "37"
          },
          {
            col1: "Total No. of Units",
            col2: "414"
          }
        ]
      }
    ],
    units: [
      {
        name: "One Bedroom",
        image: `${assetUrl}/tsb/models/u1.png`,
        properties: [
          {
            name: "Living/Dining",
            values: "11.60 sqm"
          },
          {
            name: "Kitchen",
            values: "6.10 sqm"
          },
          {
            name: "Master Bedroom",
            values: "13.70 sqm"
          },
          {
            name: "Master T&B",
            values: "4.60 sqm"
          },
          {
            name: "TOTAL",
            values: "36.00 sqm"
          }
        ]
      },
      {
        name: "Two Bedroom",
        image: `${assetUrl}/tsb/models/u2.png`,
        properties: [
          {
            name: "Living/Dining",
            values: "20.00 sqm"
          },
          {
            name: "Kitchen",
            values: "6.55 sqm"
          },
          {
            name: "Master BR",
            values: "13.10 sqm"
          },
          {
            name: "Master T&B",
            values: "5.00 sqm"
          },
          {
            name: "Walk-in Closet",
            values: "4.10 sqm"
          },
          {
            name: "Bedroom 2",
            values: "11.65 sqm"
          },
          {
            name: "Bedroom 2 T&B",
            values: "4.80 sqm"
          },
          {
            name: "Utility Room",
            values: "7.30 sqm"
          },
          {
            name: "Foyer/Hallway",
            values: "3.20 sqm"
          },
          {
            name: "TOTAL",
            values: "72.00 sqm"
          }
        ]
      },
      {
        name: "Three Bedroom",
        image: `${assetUrl}/tsb/models/u3.png`,
        properties: [
          {
            name: "Living/Dining",
            values: "57.00 sqm"
          },
          {
            name: "Kitchen",
            values: "12.60 sqm"
          },
          {
            name: "Master BR",
            values: "17.60 sqm"
          },
          {
            name: "Master T&B",
            values: "9.13 sqm"
          },
          {
            name: "Walk-in Closet",
            values: "6.70 sqm"
          },
          {
            name: "Bedroom 2",
            values: "17.70 sqm"
          },
          {
            name: "Bedroom 2 T&B",
            values: "4.80 sqm"
          },
          {
            name: "Bedroom 3",
            values: "13.53 sqm"
          },
          {
            name: "Bedroom 3 T&B",
            values: "5.65 sqm"
          },
          {
            name: "Powder Room",
            values: "3.43 sqm"
          },
          {
            name: "Foyer/Hallway",
            values: "6.05 sqm"
          },
          {
            name: "Utility Room",
            values: "8.90 sqm"
          },
          {
            name: "TOTAL",
            values: "158.70 sqm"
          }
        ]
      },
      {
        name: "Executive Two Bedroom",
        image: `${assetUrl}/tsb/models/u4.png`,
        properties: [
          {
            name: "Living/Dining",
            values: "24.80 sqm"
          },
          {
            name: "Kitchen",
            values: "8.60 sqm"
          },
          {
            name: "Master BR",
            values: "14.00 sqm"
          },
          {
            name: "Master T&B",
            values: "6.20 sqm"
          },
          {
            name: "Walk-in Closet",
            values: "4.45 sqm"
          },
          {
            name: "Bedroom 2",
            values: "9.70 sqm"
          },
          {
            name: "Common T&B",
            values: "4.30 sqm"
          },
          {
            name: "Foyer/Hallway",
            values: "5.00 sqm"
          },
          {
            name: "Utility Room",
            values: "8.10 sqm"
          },
          {
            name: "Den",
            values: "4.20 sqm"
          },
          {
            name: "TOTAL",
            values: "89.35 sqm"
          }
        ]
      }
    ],
    unit_images: [
      `${assetUrl}/tsb/models/1BR-Bedroom.png`,
      `${assetUrl}/tsb/models/1BR-Living-Room.png`,
      `${assetUrl}/tsb/models/2BR-Dining.png`,
      `${assetUrl}/tsb/models/2BR-Living.png`,
      `${assetUrl}/tsb/models/3BR-Bedroom.png`,
      `${assetUrl}/tsb/models/3BR-Living.png`,
      `${assetUrl}/tsb/models/3BR-T_B.png`
    ],
    unit_features: [
      "Entrance panel door with viewer",
      "Intercom per unit connected to the reception counter",
      "Automatic smoke detectors & fire alarm with sprinkler system in all units",
      "PROVISION FOR:",
      "Individual electric and water meter",
      "Telephone at living area and master’s bedroom",
      "Cable TV line at living area and bedrooms",
      "Ventilation for kitchen and toilet",
      "Window-type air conditioner at all units, except for residential units at",
      "Mezzanine Floor which will have provisions for split-type air conditioner",
      "MAXIMIZED SPACE: PROVIDE ESSENTIAL SPACE FOR EVERYDAY LIVING",
      "Flexibility and connection of spaces (continuous activity space for living, dining and kitchen)",
      "Generously-sized bedrooms can fit a queen-sized bed with side tables",
      "A bedroom closet with mirror is also provided",
      "Dining area can accommodate at least a 4-seater dining table",
      "Provision for a utility/washing room  with toilet for 2BR and Executive 2BR units",
      "WELL-LIGHTED: PRESENCE OF LARGE WINDOWS FOR NATURAL LIGHTING AND VENTILATION"
    ],
    unit_finishes: [
      {
        area: "Floor",
        bedroom: "Laminated Wood",
        living: "Homogeneous Tiles",
        kitchen: "Homogeneous Tiles",
        toilet: "Ceramic Tiles",
        balcony: ""
      },
      {
        area: "Wall",
        bedroom: "Painted Plastered Wall",
        living: "Painted Plastered Wall",
        kitchen: "Painted Plastered Wall",
        toilet: "Combination of Plastered Painted Wall and Ceramic Tiles",
        balcony: ""
      },
      {
        area: "Ceiling",
        bedroom: "Painted Slab Soffit",
        living: "Painted Slab Soffit",
        kitchen: "Painted Gypsum Board",
        toilet: "Painted Gypsum Board",
        balcony: ""
      },
      {
        area: "Other Deliverables",
        bedroom: "Bedroom closets",
        living: "",
        kitchen:
          "Hot Water Line Provision / Granite countertop and splashboard / Overhead and undercounter cabinets / Outlet for : Refrigertor / 2 - burner cooktop - 20 amp Range - 30 amp",
        toilet: "Lavatory with granite countertop / Hot Water Line Provision",
        balcony: ""
      }
    ]
  },
  {
    id: 10,
    property_id: "40031",
    cover_image: `${assetUrl}/cgr/cover.jpg`,
    logo_image: `${assetUrl}/cgr/logo.png`,
    pdf: `${assetUrl}/cgr/cgr.pdf`,
    video: `https://www.youtube.com/embed/nnHTwui69rE`,
    value_proposition:
      "Hear the sounds of class and harmony at Chimes Greenhills. Located along Annapolis Street, Chimes Greenhills offers an affordable alternative to living in a prominent Metro Manila address. Seize the exciting opportunity to own a Greenhills property made more impressive with nearby commercial centers, a premier medical and academic institutions and Summit Hotel within the same development.",
    reasons: [
      "A tinkling tune of opportunity",
      "Chimes presents itself as an exciting opportunity to own a Greenhills property. Living in Greenhills has been synonymous to enjoying a lavish lifestyle. Considering the neighboring establishments and residential villages, Chimes Greenhills opens the doors for an affordably affluent lifestyle.",
      "A ring of retail therapy",
      "Chimes Greenhills is within walking distance from the Greenhills Shopping Center, a bustling commercial district and virtually a shoppers’ paradise. Being near a one-stop-shop for shopping, leisure and dining is a plus factor when choosing a home today",
      "A touch of prestige playing",
      "Robinsons Hotels and Resorts’ Summit brand will be introducing a branch at the 11th to 16th floors of Chimes Greenhills, lending prestige to the residential development."
    ],
    address:
      "To have a Greenhills address is a golden opportunity as the properties in the area have always come with a hefty price tag. Thus, with Chimes Greenhills’ affordable offer, buyers have the distinct chance of living in a location that has been regarded as an upscale community. Furthermore, in the day-to-day living at Chimes, unit owners can take pleasure in the convenience of being very close to the Greenhills Shopping Center for shopping, entertainment, and dining.",
    address_image: `${assetUrl}/cgr/map.png`,
    lat: 14.6057145,
    lng: 121.0530895,
    nearby_establishments: [
      {
        name: "Nearby Commercial Areas",
        places: [
          {
            name: "Greenhills Shopping Center",
            distance: "10 km"
          },
          {
            name: "Robinsons Magnolia",
            distance: "20 km"
          },
          {
            name: "Robinsons Galleria",
            distance: "20 km"
          }
        ]
      },
      {
        name: "Nearby Academic Institutions",
        places: [
          {
            name: "La Salle Greenhills",
            distance: "5 km"
          },
          {
            name: "Xavier School",
            distance: "5 km"
          },
          {
            name: "Lourdes School of Mandaluyong",
            distance: "5 km"
          },
          {
            name: "Immaculate Concepcion Academy",
            distance: "5 km"
          },
          {
            name: "Saint Pedro Poveda College",
            distance: "5 km"
          }
        ]
      },
      {
        name: "Nearby Health Care",
        places: [
          {
            name: "Cardinal Santos Medical City",
            distance: "3.4 km"
          },
          {
            name: "The Medical City",
            distance: "3.4 km"
          }
        ]
      }
    ],
    site_development_image: `${assetUrl}/cgr/site-plan.png`,
    building_feature_image: `${assetUrl}/cgr/cover.png`,
    site_development: [
      "Lot Area: 1,129 square meters",
      "No. of tower: 1 high-rise tower",
      "Number of residential units: 397 units",
      "Number of residential floors: 24 floors"
    ],
    building_features: [
      "Main entrance lobby with reception",
      "CCTV monitoring on selected common areas",
      "Water is supplied by an elevated water tank and cistern",
      "Standby power generator for common areas",
      "Standby power at selected outlets and lighting fixtures in residential units",
      "Individual mail boxes at the ground floor",
      "Centralized garbage holding room at Basement 1",
      "Garbage holding area per residential floor",
      "Building Administration office",
      "Security Room",
      "Common drying cage at Roof Deck",
      "Transformer and Gen Set Room",
      "Sewage Treatment Plant located below Basement 3",
      "Two fire exit stairs with well-lit signage conforming to the Fire Code of the Philippines"
    ],
    design_concept: [
      "Consistent with the development’s name, rods of chimes inspire the tower’s design.",
      "A stream façade with glass and natural stone translates this to create a Zen atmosphere promoted by wind chimes."
    ],
    design_partners: [
      "PROJECT DESIGNER: JONATHAN O. GAN",
      "STRUCTURAL: SY & ASSOCIATES",
      "MECHANICAL: L.R PUNZALAN & ASSOCIATES",
      "ELECTRICAL: MAR ALIX & PARTNERS",
      "PLUMBING/FIRE PROTECTION: F.L FIGUEROA & ASSOCIATES"
    ],
    amenities: [
      "Life Fitness gym",
      "Play pod",
      "Game station",
      "Private theater",
      "Leisure pool",
      "Kiddie pool",
      "Sky lounge",
      "Sky garden"
    ],
    amenities_images: [
      `${assetUrl}/cgr/amenities/am1.png`,
      `${assetUrl}/cgr/amenities/am2.png`,
      `${assetUrl}/cgr/amenities/am3.png`,
      `${assetUrl}/cgr/amenities/am4.png`,
      `${assetUrl}/cgr/amenities/am5.png`,
      `${assetUrl}/cgr/amenities/am6.png`,
      `${assetUrl}/cgr/amenities/am7.png`
    ],
    floor_plan_images: [
      `${assetUrl}/cgr/floor_plan_images/f1.png`,
      `${assetUrl}/cgr/floor_plan_images/f2.png`,
      `${assetUrl}/cgr/floor_plan_images/f3.png`,
      `${assetUrl}/cgr/floor_plan_images/f4.png`
    ],
    floor_stacking: [
      {
        name: "",
        properties: [
          {
            floor: "40th",
            number: "1",
            use: "Penthouse - Residential"
          },
          {
            floor: "34th to 39th",
            number: "6",
            use: "High Zone – Residential"
          },
          {
            floor: "21st to 33rd",
            number: "13",
            use: "Mid Zone – Residential"
          },
          {
            floor: "17TH to 20th",
            number: "4",
            use: "Low Zone -Residential"
          },
          {
            floor: "16TH",
            number: "1",
            use: "Amenity"
          },
          {
            floor: "11th to 15th",
            number: "5",
            use: "Hotel"
          },
          {
            floor: "Podium",
            number: "8",
            use: "Parking"
          },
          {
            floor: "Basement",
            number: "3",
            use: "Parking"
          }
        ]
      }
    ],
    floors: [
      {
        name: "LOW ZONE 17 to 20 floor",
        properties: [
          {
            col1: "No. of STUDIO Units",
            col2: "8"
          },
          {
            col1: "No. of 1BR Units",
            col2: "6"
          },
          {
            col1: "No. of 2BR Units",
            col2: "4"
          },
          {
            col1: "Total Units/Floor",
            col2: "18"
          },
          {
            col1: "Total No. of Floors",
            col2: "4"
          },
          {
            col1: "Total No. of Units",
            col2: "72"
          }
        ]
      },
      {
        name: "MID ZONE 21 to 33 floor",
        properties: [
          {
            col1: "No. of STUDIO Units",
            col2: "10"
          },
          {
            col1: "No. of 1BR Units",
            col2: "6"
          },
          {
            col1: "No. of 2BR Units",
            col2: "3"
          },
          {
            col1: "Total Units/Floor",
            col2: "19"
          },
          {
            col1: "Total No. of Floors",
            col2: "13"
          },
          {
            col1: "Total No. of Units",
            col2: "247"
          }
        ]
      },
      {
        name: "HIGH ZONE 34 to 39 floor",
        properties: [
          {
            col1: "No. of 2BR Units",
            col2: "10"
          },
          {
            col1: "Total # of Units / Floor",
            col2: "10"
          },
          {
            col1: "Total No. of Floors",
            col2: "6"
          },
          {
            col1: "Total No. of Units",
            col2: "60"
          }
        ]
      },
      {
        name: "PENTHOUSE 40 floor",
        properties: [
          {
            col1: "No. of 2BR Units",
            col2: "2"
          },
          {
            col1: "No. of 3BR Units",
            col2: "4"
          },
          {
            col1: "Total # of Units / Floor",
            col2: "6"
          },
          {
            col1: "Total No. of Floors",
            col2: "1"
          },
          {
            col1: "Total No. of Units",
            col2: "6"
          }
        ]
      }
    ],
    units: [
      {
        name: "Studio",
        image: `${assetUrl}/cgr/unit_images/u1.png`,
        properties: [
          {
            name: "Studio",
            values: "± 24 to ± 34 sqm"
          }
        ]
      },
      {
        name: "One Bedroom",
        image: `${assetUrl}/cgr/unit_images/u2.png`,
        properties: [
          {
            name: "One Bedroom",
            values: "± 37 to ± 39 sqm"
          }
        ]
      },
      {
        name: "Two Bedroom",
        image: `${assetUrl}/cgr/unit_images/u3.png`,
        properties: [
          {
            name: "Bedroom",
            values: "± 44 to ± 86 sqm"
          }
        ]
      }
    ],
    unit_images: [
      `${assetUrl}/cgr/unit_images/1BR.png`,
      `${assetUrl}/cgr/unit_images/STUDIO-UNIT.png`
    ],
    unit_features: [
      "Entrance panel door with viewer",
      "Intercom per unit connected to the reception",
      "Automatic smoke detector and fire alarm with sprinkler system in all units",
      "PROVISION FOR:",
      "Individual electric and water meter",
      "Telephone line per unit",
      "Cable TV line at living area and master bedroom",
      "Space and electric outlet for window-type air conditioning system",
      "Space and utilities for single tub washing machine"
    ],
    unit_finishes: [
      {
        area: "Floor",
        bedroom: "Laminated flooring",
        living: "Homogeneous Tiles",
        kitchen: "Homogeneous Tiles",
        toilet: "Ceramic Tiles"
      },
      {
        area: "Wall",
        bedroom: "Painted Plastered Wall",
        living: "Painted Plastered Wall",
        kitchen: "Painted Plastered Wall",
        toilet:
          "Combination of ceramic tiles and plaster wall with paint finish"
      },
      {
        area: "Ceiling",
        bedroom: "Painted slab soffit (no ceiling)",
        living: "Painted slab soffit (no ceiling)",
        kitchen: "Painted slab soffit (no ceiling)",
        toilet: "Moisture resistant gypsum board in paint finish"
      },
      {
        area: "Other Deliverables",
        bedroom: "Bedroom closets",
        living: "",
        kitchen:
          "Granite counter top, Range hood, 2-burner cooktop for studio and 1 BR, 4 burner cooktop for 2 BR and 3 BR, Overhead and base cabinets",
        toilet:
          "Mirror, Shower enclosure, Provision of single point hot water line at shower area"
      }
    ]
  },
  {
    id: 11,
    property_id: "40023",
    cover_image: `${assetUrl}/tpp/cover.jpg`,
    logo_image: `${assetUrl}/tpp/logo.png`,
    pdf: `${assetUrl}/tpp/tpp.pdf`,
    video: `https://www.youtube.com/embed/olizpdh5sQY`,
    value_proposition:
      "Your unique character shines amidst the ordinary at The Pearl Place. A two-tower residential condominium at Pearl Drive corner Gold Loop in Ortigas Center, The Pearl Place offers you the freedom to customize your units according to your desire.",
    reasons: [
      "Strategically located in Ortigas Center, residents will enjoy having easy access to different commercial areas, hotels, schools, hospitals, and other places of interest the city has to offer. Moreover, its location is accessible to public transportation along Shaw Boulevard and Meralco Avenue, leading to other major road networks in the Metro.",
      "Adding value to its prime location, well-planned amenities and facilities will surely make you enjoy your leisure times. Residents may unwind by viewing the city skyline or host a gathering at the Summit Lounge. Gym, dance studio, game area, and kiddie and lap pools are just some of the features that serve as an extension of their living space.",
      "Located at the ground floor are commercial spaces where food and other services are offered to cater your needs and are just a few steps away from your unit.",
      "A master-planned residential condominium that provides an environment conducive to enjoy the spaces of everyday living. Units available are Studio, 1-bedroom, and 2-bedroom units with sizes ranging from 23 to 60 sq.m.",
      "Carefully designed units that offer distinct deliverables for buyers’ preference. They may choose from Bare, Bare with finished toilet, bathroom and kitchen, and Finished units."
    ],
    address:
      "Located at the Pearl Drive corner Gold Loop in Ortigas Center, The Pearl Place is indeed a prized piece of property. Its proximity to the country’s top shopping destinations, 5-star hotels and reputable schools increases makes it a wise home and investment option.",
    address_image: `${assetUrl}/tpp/map.png`,
    lat: 14.5788795,
    lng: 121.0573873,
    nearby_establishments: [
      {
        name: "Nearby Commercial Areas",
        places: [
          {
            name: "Robinsons Galleria",
            distance: ""
          },
          {
            name: "Shangri-la Plaza",
            distance: ""
          },
          {
            name: "SM Megamall",
            distance: ""
          },
          {
            name: "The Podium",
            distance: ""
          }
        ]
      },
      {
        name: "Nearby Academic Institutions",
        places: [
          {
            name: "University of Asia and the Pacific",
            distance: ""
          },
          {
            name: "Xavier School",
            distance: ""
          },
          {
            name: "La Salle Greenhills",
            distance: ""
          },
          {
            name: "Lourdes School of Mandaluyong",
            distance: ""
          },
          {
            name: "Immaculate Concepcion Academy",
            distance: ""
          },
          {
            name: "Saint Pedro Poveda College",
            distance: ""
          },
          {
            name: "St. Paul College Pasig",
            distance: ""
          }
        ]
      },
      {
        name: "Nearby Health Care",
        places: [
          {
            name: "Medical Plaza, Ortigas",
            distance: ""
          },
          {
            name: "The Medical City",
            distance: ""
          }
        ]
      },
      {
        name: "Nearby Hotels",
        places: [
          {
            name: "Crowne Plaza Manila Galleria",
            distance: ""
          },
          {
            name: "Holiday Inn Manila Galleria",
            distance: ""
          },
          {
            name: "Richmonde Hotel Ortigas",
            distance: ""
          },
          {
            name: "EDSA Shangri-la Hotel",
            distance: ""
          },
          {
            name: "Astoria Plaza",
            distance: ""
          }
        ]
      }
    ],
    site_development_image: `${assetUrl}/tpp/site-plan.png`,
    building_feature_image: `${assetUrl}/tpp/cover.jpg`,
    site_development: ["Lot Area: 3,073 square meters", "No. of towers: 2"],
    building_features: [
      "Lobby Lounge",
      "Three (3) passenger elevators per tower (one serves as passenger and service elevator)",
      "CCTV at strategic locations",
      "Individual mailboxes",
      "Emergency back-up power supply",
      "Drying cages located at the roof deck",
      "Podium parking"
    ],
    design_concept: ["MODERN MINIMALIST"],
    design_partners: [
      "PROJECT DESIGNER: JONATHAN O. GAN",
      "STRUCTURAL: OREGENES & ASSOCIATES",
      "MECHANICAL: L.R PUNZALAN & ASSOCIATES",
      "ELECTRICAL: MAR ALIX & PARTNERS",
      "PLUMBING/FIRE PROTECTION: F.L FIGUEROA & ASSOCIATES"
    ],
    amenities: [
      "Play pod",
      "Function Rooms",
      "Game Station",
      "Summit Lounge",
      "Kiddie Pool",
      "Adult Pool",
      "Reader’s Nook",
      "Children’s Playground",
      "Dance Studio",
      "Cetral Lobby",
      "Gym / Fitness Center"
    ],
    amenities_images: [
      `${assetUrl}/tpp/amenities/am1.png`,
      `${assetUrl}/tpp/amenities/am2.png`,
      `${assetUrl}/tpp/amenities/am3.png`,
      `${assetUrl}/tpp/amenities/am4.png`
    ],
    floor_plan_images: [
      `${assetUrl}/tpp/floor_plan_images/f1.png`,
      `${assetUrl}/tpp/floor_plan_images/f2.png`,
      `${assetUrl}/tpp/floor_plan_images/f3.png`,
      `${assetUrl}/tpp/floor_plan_images/f4.png`,
      `${assetUrl}/tpp/floor_plan_images/f5.png`,
      `${assetUrl}/tpp/floor_plan_images/f6.png`
    ],
    floor_stacking: [
      {
        name: "TPPA",
        properties: [
          {
            floor: "40th",
            number: "1",
            use: "Amenity / Residential Floor"
          },
          {
            floor: "7th to 39th",
            number: "33",
            use: "Residential Floors"
          },
          {
            floor: "6TH",
            number: "1",
            use: "Amenity Floor"
          },
          {
            floor: "LEVEL 1 TO 5",
            number: "5",
            use: "Podium Parking"
          },
          {
            floor: "Ground",
            number: "1",
            use: "Lobby, Commercial Spaces and Parking"
          }
        ]
      },
      {
        name: "TPPB",
        properties: [
          {
            floor: "40th",
            number: "1",
            use: "Residential Floor"
          },
          {
            floor: "7th to 39th",
            number: "33",
            use: "Residential Floors"
          },
          {
            floor: "6TH",
            number: "1",
            use: "Amenity / Residential Floor"
          },
          {
            floor: "LEVEL 1 TO 5",
            number: "5",
            use: "Podium Parking"
          },
          {
            floor: "Ground",
            number: "1",
            use: "Lobby, Commercial Spaces and Parking"
          }
        ]
      }
    ],
    floors: [
      {
        name: "TPP A: 7 - 33 floor",
        properties: [
          {
            col1: "No. of STUDIO Units",
            col2: "18"
          },
          {
            col1: "No. of 1BR Units",
            col2: "4"
          },
          {
            col1: "Total Units/Floor",
            col2: "22"
          },
          {
            col1: "Number of Floors",
            col2: "26"
          },
          {
            col1: "Total No. of Units",
            col2: "572"
          }
        ]
      },
      {
        name: "TPP A: 34 - 39 floor",
        properties: [
          {
            col1: "No. of STUDIO Units",
            col2: "2"
          },
          {
            col1: "No. of 2BR Units",
            col2: "10"
          },
          {
            col1: "Total Units/Floor",
            col2: "12"
          },
          {
            col1: "Number of Floors",
            col2: "6"
          },
          {
            col1: "Total No. of Units",
            col2: "72"
          }
        ]
      },
      {
        name: "TPP A: 40 floor",
        properties: [
          {
            col1: "No. of STUDIO Units",
            col2: "1"
          },
          {
            col1: "No. of 2BR Units",
            col2: "8"
          },
          {
            col1: "Total Units/Floor",
            col2: "9"
          },
          {
            col1: "Number of Floors",
            col2: "1"
          },
          {
            col1: "Total No. of Units",
            col2: "9"
          }
        ]
      },
      {
        name: "TPP B: 6 floor",
        properties: [
          {
            col1: "No. of STUDIO Units",
            col2: "12"
          },
          {
            col1: "No. of 1BR Units",
            col2: "2"
          },
          {
            col1: "Total Units/Floor",
            col2: "14"
          },
          {
            col1: "Number of Floors",
            col2: "1"
          },
          {
            col1: "Total No. of Units",
            col2: "14"
          }
        ]
      },
      {
        name: "TPP B: 7 - 30 floor",
        properties: [
          {
            col1: "No. of STUDIO Units",
            col2: "18"
          },
          {
            col1: "No. of 1BR Units",
            col2: "4"
          },
          {
            col1: "Total Units/Floor",
            col2: "22"
          },
          {
            col1: "Number of Floors",
            col2: "23"
          },
          {
            col1: "Total No. of Units",
            col2: "506"
          }
        ]
      },
      {
        name: "TPP B: 31 - 40 floor",
        properties: [
          {
            col1: "No. of STUDIO Units",
            col2: "2"
          },
          {
            col1: "No. of 2BR Units",
            col2: "10"
          },
          {
            col1: "Total Units/Floor",
            col2: "12"
          },
          {
            col1: "Number of Floors",
            col2: "10"
          },
          {
            col1: "Total No. of Units",
            col2: "120"
          }
        ]
      }
    ],
    units: [
      {
        name: "Tower A",
        image: `${assetUrl}/tpp/unit_images/u1.png`,
        properties: [
          {
            name: "1BR",
            values: "±34 sqm"
          }
        ]
      },
      {
        name: "Tower A",
        image: `${assetUrl}/tpp/unit_images/u2.png`,
        properties: [
          {
            name: "2BR",
            values: "±48 sqm"
          }
        ]
      },
      {
        name: "Tower A",
        image: `${assetUrl}/tpp/unit_images/u3.png`,
        properties: [
          {
            name: "Studio",
            values: "±24 sqm"
          }
        ]
      },
      {
        name: "Tower B",
        image: `${assetUrl}/tpp/unit_images/u4.png`,
        properties: [
          {
            name: "1BR",
            values: "±34 sqm"
          }
        ]
      },
      {
        name: "Tower B",
        image: `${assetUrl}/tpp/unit_images/u5.png`,
        properties: [
          {
            name: "2BR",
            values: "±48 sqm"
          }
        ]
      },
      {
        name: "Tower B",
        image: `${assetUrl}/tpp/unit_images/u6.png`,
        properties: [
          {
            name: "Studio",
            values: "±24 sqm"
          }
        ]
      }
    ],
    unit_images: [
      `${assetUrl}/tpp/unit_images/1BR.png`,
      `${assetUrl}/tpp/unit_images/STUDIO-UNIT.png`
    ],
    unit_features: [
      "Entrance panel door with viewer",
      "Individual meter for water and electricity",
      "Emergency back-up power supply in selected areas",
      "Provision for water heater at shower area",
      "Telephone and cable ready"
    ],
    unit_finishes: [
      {
        area: "Floor",
        bedroom: "Ceramic Tiles",
        living: "Ceramic Tiles",
        kitchen: "Ceramic Tiles",
        toilet: "Ceramic Tiles"
      },
      {
        area: "Cabinet",
        bedroom: "",
        living: "",
        kitchen: "Granite Countertop only; no base cabinets",
        toilet: ""
      },
      {
        area: "Wall",
        bedroom: "Paint finish",
        living: "Paint finish",
        kitchen: "Paint finish",
        toilet: "Ceramic Tile (Wet Area) Paint Finish (Dry Area)"
      },
      {
        area: "INTERNAL PARTITIONS",
        bedroom: "Painted Drywall Partition (for 1br and 2br units only)",
        living: "Painted Drywall Partition (for 1br and 2br units only)",
        kitchen: "Painted Drywall Partition (for 1br and 2br units only)",
        toilet: ""
      },
      {
        area: "Ceiling",
        bedroom: "Pointed Concrete Finish with exposed pipes",
        living: "Pointed Concrete Finish with exposed pipes",
        kitchen: "Pointed Concrete Finish with exposed pipes",
        toilet: "Moisture resistant gypsum board"
      },
      {
        area: "DOORS",
        bedroom: "Panel Door at Main Entry",
        living: "Panel Door at Main Entry",
        kitchen: "Panel Door at Main Entry",
        toilet: "Flush Door"
      },
      {
        area: "PLUMBING & SANITARY",
        bedroom: "",
        living: "",
        kitchen: "With kitchen sink , faucet",
        toilet:
          "Toilet fixtures (Water closet, Lavatory, Shower Head, Valves, Faucet, Soap and Tissue Holder"
      },
      {
        area: "ELECTRICAL",
        bedroom:
          "Lighting receptacles and switches; Power Outlets and Panel Board",
        living:
          "Lighting receptacles and switches; Power Outlets and Panel Board",
        kitchen:
          "Lighting receptacles and switches; Power Outlets and Panel Board",
        toilet:
          "Light receptacles, Switches, Power outlets and power supply provision for single point water heater"
      },
      {
        area: "FIRE PROTECTION",
        bedroom: "Smoke detectors, fire alarm and sprinkler system",
        living: "Smoke detectors, fire alarm and sprinkler system",
        kitchen: "Smoke detectors, fire alarm and sprinkler system",
        toilet: "Smoke detectors, fire alarm and sprinkler system"
      }
    ]
  },
  {
    id: 12,
    property_id: "40027",
    cover_image: `${assetUrl}/ace/cover.jpg`,
    logo_image: `${assetUrl}/ace/logo.png`,
    pdf: `${assetUrl}/ace/ace.pdf`,
    video: `https://www.youtube.com/embed/1N5LAu-IBNg`,
    value_proposition:
      "For start-up families, young professionals and entrepreneurs who are looking at buying their first living spaces close to work or to where they have lived, Acacia Escalades B offers a nurturing residential community, set in a easily accessible location, with amenities ideal for family and community activities, all backed-up by neighborhood friendly services and facilities, allowing you to experience comfortable living at the best prices.",
    reasons: [
      "EASY ACCESSIBLE LOCATION",
      "The strategic address is a close enough drive to all the best places for work and leisure but still provides you with the peace and quiet of a residential community.",
      "AMENITIES IDEAL FOR FAMILY AND COMMUNITY ACTIVITIES",
      "COMPLEMENTING NEIGHBORHOOD FACILITIES AND SERVICES"
    ],
    address:
      "Amang Rodriguez Avenue corner Calle Industria, Manggahan, Pasig City. Located within the thriving Pasig City, Acacia Escalades takes you closer to all the best places for leisure and work. Strategically built at Amang Rodriguez Avenue corner Calle Industria in Manggahan, Acacia Escalades is a close enough drive to city hotspots, while still providing you with the peace and quiet of a residential community. Just a few minutes away are the exciting retail and dining choices at Eastwood City, and the sheer convenience of having groceries nearby. Top educational institutions are within the neighbourhood as well or just a short car ride away. The development is also close to the Ortigas Central Business District, thus, making major business deals and meetings all within reach. Acacia Escalades’ central address means easy access as well to different transportation systems, conveniently taking one from home to various points across the metro.",
    address_image: `${assetUrl}/ace/map.png`,
    lat: 14.5258136,
    lng: 121.0631989,
    nearby_establishments: [
      {
        name: "Schools",
        places: [
          {
            name: "Ateneo de Manila University",
            distance: "6.7 km"
          },
          {
            name: "University of Asia and the Pacific",
            distance: "8 km"
          },
          {
            name: "UP Diliman",
            distance: "10.2 km"
          },
          {
            name: "Miriam College",
            distance: "17 km"
          },
          {
            name: "Entrepreneurs School of Asia",
            distance: "1.1 km"
          }
        ]
      },
      {
        name: "Commercial Areas",
        places: [
          {
            name: "Robinsons Metro East",
            distance: "2.5 km"
          },
          {
            name: "Eastwood City",
            distance: "2 km"
          },
          {
            name: "SM Hypermarket Pasig",
            distance: ""
          },
          {
            name: "Robinsons Galleria",
            distance: ""
          },
          {
            name: "SM Marikina",
            distance: ""
          }
        ]
      },
      {
        name: "Health Care",
        places: [
          {
            name: "The Medical City",
            distance: "3.7 km"
          }
        ]
      }
    ],
    site_development_image: `${assetUrl}/ace/site-plan.png`,
    building_feature_image: `${assetUrl}/ace/cover.jpg`,
    site_development: [
      "Lot Area: 10,477s qm.",
      "No. of buildings: 2",
      "Mixed- Use Condominium Development",
      "Number of residential units: Building A : 383 units, Building B : 414 units",
      "Number of Storeys: Building A: 15 storeys, Building B: 17 storeys",
      "Number of Residential Floors: Building A: 11 storeys, Building B: 13 storeys"
    ],
    building_features: [
      "Lobby lounge with reception",
      "CCTV monitoring on selected common areas",
      "Standby power generator for select common areas",
      "Individual mail boxes",
      "Centralized garbage holding area",
      "Building Administration office",
      "Common drying cage at the roof deck",
      "Sewage treatment plant",
      "Three fire exit stairs conforming to the Fire Code of the Philippines",
      "Single-loaded corridor",
      "Landscaped atrium",
      "Covered parking at the 2nd and 3rd floors",
      "3 Elevators/building",
      "Commercial/Retail spaces",
      "Guard house and car barrier"
    ],
    design_concept: [
      "Acacia Escalades follows a Modern Filipiniana Architectural Theme.",
      "“Modern Filipiniana Architecture is something contemporary but still within the confines of traditional Filipino building design. This is inspired by pre-colonial to Spanish-colonial structures in the Philippines with minimal or simple details to incorporate the concept of modern architecture” -ArkiAsia"
    ],
    design_partners: [
      "PROJECT DESIGNER: ARKIASIA",
      "STRUCTURAL: PIMENTEL ASSOCIATES INTERNATIONAL",
      "MECHANICAL: COMPREHENSIVE ENGINEERING SOLUTION",
      "ELECTRICAL: FA VELASCO DESIGN & CONSTRUCTION",
      "& SANITARY & FIRE PROTECTION: INTEGRATED INNOVATORS, CO."
    ],
    amenities: [
      "Swimming and Kiddie Pool",
      "Lobby / Lounge",
      "Gym",
      "Dance Studio",
      "Children’s Playground",
      "Function Room",
      "Landscaped Area"
    ],
    amenities_images: [
      `${assetUrl}/ace/amenities/am1.png`,
      `${assetUrl}/ace/amenities/am2.png`,
      `${assetUrl}/ace/amenities/am3.png`,
      `${assetUrl}/ace/amenities/am4.png`,
      `${assetUrl}/ace/amenities/am5.png`,
      `${assetUrl}/ace/amenities/am6.png`,
      `${assetUrl}/ace/amenities/am7.png`,
      `${assetUrl}/ace/amenities/am8.png`,
      `${assetUrl}/ace/amenities/am9.png`,
      `${assetUrl}/ace/amenities/am10.png`
    ],
    floor_plan_images: [
      `${assetUrl}/ace/floor_plan_images/f1.png`,
      `${assetUrl}/ace/floor_plan_images/f2.png`,
      `${assetUrl}/ace/floor_plan_images/f3.png`,
      `${assetUrl}/ace/floor_plan_images/f4.png`,
      `${assetUrl}/ace/floor_plan_images/f5.png`,
      `${assetUrl}/ace/floor_plan_images/f6.png`
    ],
    floor_stacking: [
      {
        name: "Tower A",
        properties: [
          {
            floor: "5th to 15th",
            number: "10",
            use: "Residential Floors"
          },
          {
            floor: "4th",
            number: "1",
            use: "Outdoor Amenities / Residential Floor"
          },
          {
            floor: "3rd",
            number: "1",
            use: "Drop-Off Area/ Main Lobby / Indoor Amenities"
          },
          {
            floor: "2nd",
            number: "1",
            use: "Podium Parking"
          },
          {
            floor: "Ground",
            number: "1",
            use: "Retail Lobby, Commercial Spaces and Parking"
          }
        ]
      },
      {
        name: "Tower B",
        properties: [
          {
            floor: "16th to 17th",
            number: "2",
            use: "Residential Floors"
          },
          {
            floor: "5th to 15th",
            number: "10",
            use: "Residential Floors"
          },
          {
            floor: "4th",
            number: "1",
            use: "Outdoor Amenities / Residential Floor"
          },
          {
            floor: "3rd",
            number: "1",
            use: "Drop-Off Area/ Main Lobby / Indoor Amenities"
          },
          {
            floor: "2nd",
            number: "1",
            use: "Podium Parking"
          },
          {
            floor: "Ground",
            number: "1",
            use: "Retail Lobby, Commercial Spaces and Parking"
          }
        ]
      }
    ],
    floors: [
      {
        name: "TOWER A 4th Floor - Amenity",
        properties: [
          {
            col1: "Studio",
            col2: "8 units"
          },
          {
            col1: "1 Bedroom",
            col2: "15 units"
          },
          {
            col1: "2 Bedroom",
            col2: "10 units"
          },
          {
            col1: "Total # of Units / Floor",
            col2: "33 units"
          },
          {
            col1: "Number of Floors",
            col2: "1 floors"
          },
          {
            col1: "Total # of Units",
            col2: "33 units"
          }
        ]
      },
      {
        name: "TOWER A 5TH, 7TH, 9TH, 11TH & 14TH",
        properties: [
          {
            col1: "Studio",
            col2: "8 units"
          },
          {
            col1: "1 Bedroom",
            col2: "15 units"
          },
          {
            col1: "2 Bedroom",
            col2: "12 units"
          },
          {
            col1: "Total # of Units / Floor",
            col2: "35 units"
          },
          {
            col1: "Number of Floors",
            col2: "5 floors"
          },
          {
            col1: "Total # of Units",
            col2: "175 units"
          }
        ]
      },
      {
        name: "TOWER A 6TH, 8TH, 10TH, 12TH, & 15TH",
        properties: [
          {
            col1: "Studio",
            col2: "8 units"
          },
          {
            col1: "1 Bedroom",
            col2: "15 units"
          },
          {
            col1: "2 Bedroom",
            col2: "12 units"
          },
          {
            col1: "Total # of Units / Floor",
            col2: "35 units"
          },
          {
            col1: "Number of Floors",
            col2: "5 floors"
          },
          {
            col1: "Total # of Units",
            col2: "175 units"
          }
        ]
      },
      {
        name: "TOWER B 4TH FLOOR",
        properties: [
          {
            col1: "Studio",
            col2: "9 units"
          },
          {
            col1: "1 Bedroom",
            col2: "13 units"
          },
          {
            col1: "2 Bedroom",
            col2: "8 units"
          },
          {
            col1: "Total # of Units / Floor",
            col2: "30 units"
          },
          {
            col1: "Number of Floors",
            col2: "1 floors"
          },
          {
            col1: "Total # of Units",
            col2: "30 units"
          }
        ]
      },
      {
        name: "Building B – 5th, 7th, 9th, 11th, 14th & 16th",
        properties: [
          {
            col1: "Studio",
            col2: "9 units"
          },
          {
            col1: "1 Bedroom",
            col2: "13 units"
          },
          {
            col1: "2 Bedroom",
            col2: "10 units"
          },
          {
            col1: "Total # of Units / Floor",
            col2: "32 units"
          },
          {
            col1: "Number of Floors",
            col2: "6 floors"
          },
          {
            col1: "Total # of Units",
            col2: "192 units"
          }
        ]
      },
      {
        name: "Building B – 6th, 8th, 10th, 12th, 15th & 17th",
        properties: [
          {
            col1: "Studio",
            col2: "9 units"
          },
          {
            col1: "1 Bedroom",
            col2: "13 units"
          },
          {
            col1: "2 Bedroom",
            col2: "10 units"
          },
          {
            col1: "Total # of Units / Floor",
            col2: "32 units"
          },
          {
            col1: "Number of Floors",
            col2: "6 floors"
          },
          {
            col1: "Total # of Units",
            col2: "192 units"
          }
        ]
      }
    ],
    units: [
      {
        name: "Studio",
        image: `${assetUrl}/ace/unit_images/u1.png`,
        properties: [
          {
            name: "Studio",
            values: "± 24 sqm"
          }
        ]
      },
      {
        name: "1 Bedroom",
        image: `${assetUrl}/ace/unit_images/u2.png`,
        properties: [
          {
            name: "1 Bedroom",
            values: "± 34 sqm"
          }
        ]
      },
      {
        name: "2 Bedroom",
        image: `${assetUrl}/ace/unit_images/u3.png`,
        properties: [
          {
            name: "2 Bedroom",
            values: "± 48 sqm"
          }
        ]
      }
    ],
    unit_images: [
      `${assetUrl}/ace/unit_images/1BR.png`,
      `${assetUrl}/ace/unit_images/STUDIO-UNIT.png`
    ],
    unit_features: [
      "Automatic smoke detectors & fire alarm with sprinkler system in all units",
      "Limited back-up power for all residential units",
      "PROVISIONS FOR:",
      "Individual electric and water meter",
      "Telephone line, Cable TV Line",
      "Window type air-con opening and electrical outlet",
      "Ventilation for kitchen and toilet/s",
      "Single point water heater at the shower area"
    ],
    unit_finishes: [
      {
        area: "Floor",
        bedroom: "Concrete slab ready to receive floor finish",
        living: "Concrete slab ready to receive floor finish",
        kitchen: "Concrete slab ready to receive floor finish",
        toilet: "Ceramic Tiles"
      },
      {
        area: "Cabinet",
        bedroom: "N/A",
        living: "N/A",
        kitchen: "Granite Countertop only; no base cabinet",
        toilet: "N/A"
      },
      {
        area: "Wall",
        bedroom: "Cement mortar plaster",
        living: "Cement mortar plaster",
        kitchen: "Cement mortar plaster",
        toilet: "Cement Tiles (Wet Area); Paint Finish (Dry Area)"
      },
      {
        area: "Ceiling",
        bedroom:
          "Painted underside of slab (one coat) with exposed beams; Fire sprinklers, plumbing pipes and other vent pipes are also exposed",
        living:
          "Painted underside of slab (one coat) with exposed beams; Fire sprinklers, plumbing pipes and other vent pipes are also exposed",
        kitchen:
          "Painted underside of slab (one coat) with exposed beams; Fire sprinklers, plumbing pipes and other vent pipes are also exposed",
        toilet: "Gypsum board"
      },
      {
        area: "Doors",
        bedroom: "No bedroom door will be provided",
        living: "Panel door at unit entrance",
        kitchen: "Panel door at unit entrance",
        toilet: "Flush door/s"
      },
      {
        area: "Windows",
        bedroom: "Glass with aluminum framing",
        living: "Glass with aluminum framing",
        kitchen: "Glass with aluminum framing",
        toilet: "Glass with aluminum framing"
      },
      {
        area: "Plumbing & Sanitary",
        bedroom: "N/A",
        living: "N/A",
        kitchen: "with Kitchen sink, Faucet",
        toilet: "Water Closet, Lavatory, Shower Head"
      },
      {
        area: "Electrical",
        bedroom:
          "Electrical conduits and utility boxes with wires, panel board and circuit breaker will be provided",
        living:
          "All other electrical provisions not located in walls will have provisions located on designated floor locations",
        kitchen: "Lighting fixtures are not supplied",
        toilet:
          "with Lighting Receptacle, switch and power outlet for single point water heater (for the shower)"
      },
      {
        area: "Fire Protection",
        bedroom: "Smoke detectors and fire alarm with sprinkler system",
        living: "Smoke detectors and fire alarm with sprinkler system",
        kitchen: "Smoke detectors and fire alarm with sprinkler system",
        toilet: "Smoke detectors and fire alarm with sprinkler system"
      }
    ]
  },
  {
    id: 13,
    property_id: "40025",
    cover_image: `${assetUrl}/axr/cover.jpg`,
    logo_image: `${assetUrl}/axr/logo.png`,
    pdf: `${assetUrl}/axr/axr.pdf`,
    video: `https://www.youtube.com/embed/HqCpLGJyPU0`,
    value_proposition:
      "For young professionals, millennials in the corporate / BPO industry and investors, Axis Residences is a viable city home address, providing efficiently cut living spaces ideal for a fast-paced lifestyle and quick access to modern-day conveniences via the development’s amenities, digital concierge service and strategic location made available through competitive prices, creating the perfect setting for a living space that “works” as home and sound investment option.",
    reasons: [
      "Efficiently cut living space options ideal for your fast-paced lifestyle",
      "Quick access to modern day conveniences",
      "Strategic location",
      "Pioneer, Mandaluyong lies in the middle of the Makati, Manila and Quezon City giving its residents quick access to the Makati, Ortigas, and Bonifacio Global City CBDs",
      "Highly accessible to major CBDs (Makati, BGC and Ortigas Center) and key transport points such as EDSA, Ortigas, & MRT"
    ],
    address:
      "Pioneer Street, Barangay Barangka Ilaya, Mandaluyong City. At Axis Residences, everything is just on your radar. Optimize your lifestyle and beat the rush with its strategic address, centrally placed amidst the major business districts of Ortigas, Makati and Bonifacio Global City. The project also boasts of easy access to major thoroughfares (EDSA and C5).",
    address_image: `${assetUrl}/axr/map.png`,
    lat: 14.5701159,
    lng: 121.0473887,
    nearby_establishments: [
      {
        name: "Commercial Areas / Establishments",
        places: [
          {
            name: "Forum Robinsons",
            distance: "120 m"
          },
          {
            name: "Shangri-La Plaza Mall",
            distance: "2.4 km"
          },
          {
            name: "Megamall",
            distance: "2.8 km"
          },
          {
            name: "Robinsons Galleria",
            distance: "3.8 km"
          }
        ]
      },
      {
        name: "Hospitals / Medical Center",
        places: [
          {
            name: "Victor R Potenciano Medical Center",
            distance: "1.5 km"
          },
          {
            name: "Unciano General Hospital",
            distance: "800 m"
          },
          {
            name: "Mandaluyong City Medical Center",
            distance: "1.8 km"
          },
          {
            name: "The Medical City",
            distance: "3.9 km"
          }
        ]
      },
      {
        name: "Schools / Learning Centers",
        places: [
          {
            name: "Lourdes School of Mandaluyong",
            distance: "2.2 km"
          },
          {
            name: "Saint Pedro PovedaCollege",
            distance: "3.9 km"
          },
          {
            name: "University of Asia and the Pacific",
            distance: "2.7 km"
          },
          {
            name: "La Salle Greenhills",
            distance: "4.5 km"
          }
        ]
      },
      {
        name: "Churches / Places of Worship",
        places: [
          {
            name: "St. Francis of Assisi Church",
            distance: "2.2 km"
          },
          {
            name: "EdsaShrine",
            distance: "3.6 km"
          }
        ]
      }
    ],
    site_development_image: `${assetUrl}/axr/site-plan.png`,
    building_feature_image: `${assetUrl}/axr/cover.jpg`,
    site_development: [
      "Lot Area: 9,742 square meters",
      "No. of towers: 2",
      "Number of residential units: 873 units for Tower A, 792 units for Tower B",
      "Number of floors per tower: 42 floors"
    ],
    building_features: [
      "Main entrance Lobby with Reception",
      "Four (4) passenger elevators per Tower (inclusive of 1 service elevator)",
      "CCTV monitoring (at strategic location)",
      "Automatic smoke detectors & fire alarm w/ sprinkler system (common areas)",
      "Annunciator panel with emergency speaker at all floors",
      "Elevated water tank and underground cistern",
      "Standby power generator (common areas and selected outlets in the unit)",
      "Individual mail boxes at the Ground Floor",
      "Centralized garbage holding area",
      "Building Administration office",
      "Fire Exits",
      "Common Drying Cage at Roof Deck"
    ],
    design_concept: ["Modern architectural design"],
    design_partners: [
      "ARCHITECTURAL: CASAS+Architects",
      "MECHANICAL: L.R. PUNZALAN & ASSOCIATES",
      "ELECTRICAL: MAR ALIX & PARTNERS",
      "PLUMBING & SANITARY / FIRE PROTECTION: NBF CONSULTING ENGINEERS INC.",
      "STRUCTURAL: PIMENTEL & ASSOCIATES"
    ],
    amenities: [
      "Adult Pool with Pool Deck",
      "Kiddie Pool",
      "Function Rooms",
      "Fitness Center",
      "Children’s Playground",
      "Multi-purpose Covered Court",
      "Pavilion",
      "Landscaped Garden",
      "Game Room"
    ],
    amenities_images: [
      `${assetUrl}/axr/amenities/am1.png`,
      `${assetUrl}/axr/amenities/am2.png`,
      `${assetUrl}/axr/amenities/am3.png`,
      `${assetUrl}/axr/amenities/am4.png`,
      `${assetUrl}/axr/amenities/am5.png`,
      `${assetUrl}/axr/amenities/am6.png`,
      `${assetUrl}/axr/amenities/am7.png`,
      `${assetUrl}/axr/amenities/am8.png`,
      `${assetUrl}/axr/amenities/am9.png`,
      `${assetUrl}/axr/amenities/am10.png`,
      `${assetUrl}/axr/amenities/am11.png`
    ],
    floor_plan_images: [
      `${assetUrl}/axr/floor_plan_images/f1.png`,
      `${assetUrl}/axr/floor_plan_images/f2.png`,
      `${assetUrl}/axr/floor_plan_images/f3.png`,
      `${assetUrl}/axr/floor_plan_images/f4.png`,
      `${assetUrl}/axr/floor_plan_images/f5.png`,
      `${assetUrl}/axr/floor_plan_images/f6.png`
    ],
    floor_stacking: [
      {
        name: "",
        properties: [
          {
            floor: "Roof Deck",
            number: "1",
            use: "Roof Deck"
          },
          {
            floor: "6th to 42nd",
            number: "36",
            use: "Residential"
          },
          {
            floor: "5TH",
            number: "1",
            use: "Amenity / Residential"
          },
          {
            floor: "2nd to 4th",
            number: "3",
            use: "Podium Parking"
          },
          {
            floor: "Ground",
            number: "1",
            use: "Main Lobby, Retail, and Driveway"
          }
        ]
      }
    ],
    floors: [
      {
        name: "TOWER A 5th Floor - Amenity",
        properties: [
          {
            col1: "Studio with balcony",
            col2: "10"
          },
          {
            col1: "2 Bedroom with balcony",
            col2: "3"
          },
          {
            col1: "Total # of Units / Floor",
            col2: "13"
          },
          {
            col1: "Number of Floors",
            col2: "1"
          },
          {
            col1: "Total # of Units",
            col2: "13"
          }
        ]
      },
      {
        name: "TOWER A 6th to 33rd Floor",
        properties: [
          {
            col1: "Studio",
            col2: "19"
          },
          {
            col1: "Studio Combined",
            col2: "3"
          },
          {
            col1: "Total # of Units / Floor",
            col2: "22"
          },
          {
            col1: "Number of Floors",
            col2: "28"
          },
          {
            col1: "Total # of Units",
            col2: "616"
          }
        ]
      },
      {
        name: "TOWER A 34th to 41st Floor",
        properties: [
          {
            col1: "Studio",
            col2: "19"
          },
          {
            col1: "2 Bedroom",
            col2: "3"
          },
          {
            col1: "Total # of Units / Floor",
            col2: "22"
          },
          {
            col1: "Number of Floors",
            col2: "8"
          },
          {
            col1: "Total # of Units",
            col2: "176"
          }
        ]
      },
      {
        name: "TOWER A 42nd Floor - Penthouse",
        properties: [
          {
            col1: "1 Bedroom",
            col2: "3"
          },
          {
            col1: "2 Bedroom",
            col2: "5"
          },
          {
            col1: "3 Bedroom",
            col2: "1"
          },
          {
            col1: "Total # of Units / Floor",
            col2: "9"
          },
          {
            col1: "Number of Floors",
            col2: "1"
          },
          {
            col1: "Total # of Units",
            col2: "9"
          }
        ]
      },
      {
        name: "TOWER B 5th floor - Amenity",
        properties: [
          {
            col1: "Studio",
            col2: "10"
          },
          {
            col1: "2 Bedroom",
            col2: "3"
          },
          {
            col1: "Total # of Units / Floor",
            col2: "13"
          },
          {
            col1: "Number of Floors",
            col2: "1"
          },
          {
            col1: "Total # of Units",
            col2: "13"
          }
        ]
      },
      {
        name: "TOWER B Typical Floor Plan 6th – 41st Floor",
        properties: [
          {
            col1: "Studio",
            col2: "19"
          },
          {
            col1: "2 Bedroom",
            col2: "3"
          },
          {
            col1: "Total # of Units / Floor",
            col2: "22"
          },
          {
            col1: "Number of Floors",
            col2: "36"
          },
          {
            col1: "Total # of Units",
            col2: "792"
          }
        ]
      },
      {
        name: "TOWER B 42nd Floor - Penthouse",
        properties: [
          {
            col1: "1 Bedroom",
            col2: "3"
          },
          {
            col1: "2 Bedroom",
            col2: "5"
          },
          {
            col1: "3 Bedroom",
            col2: "1"
          },
          {
            col1: "Total # of Units / Floor",
            col2: "9"
          },
          {
            col1: "Number of Floors",
            col2: "1"
          },
          {
            col1: "Total # of Units",
            col2: "9"
          }
        ]
      }
    ],
    units: [
      {
        name: "Studio",
        image: `${assetUrl}/axr/unit_images/u3.png`,
        properties: [
          {
            name: "AXRA Studio (Deluxe Unit)",
            values: "± 23.76 sqm"
          },
          {
            name: "AXRA Studio Combined (Executive Unit)",
            values: "± 50.04 sqm"
          }
        ]
      },
      {
        name: "1 Bedroom",
        image: `${assetUrl}/axr/unit_images/u1.png`,
        properties: [
          {
            name: "AXRA 1 Bedroom",
            values: "± 47.30 sqm"
          }
        ]
      },
      {
        name: "2 Bedroom",
        image: `${assetUrl}/axr/unit_images/u2.png`,
        properties: [
          {
            name: "AXRA 2 Bedroom",
            values: "± 50.94 sqm"
          },
          {
            name: "AXRB 2 Bedroom",
            values: "± 52 to 81 sqm"
          }
        ]
      },
      {
        name: "3 Bedroom",
        image: `${assetUrl}/axr/unit_images/u4.png`,
        properties: [
          {
            name: "AXRA 3 Bedroom",
            values: "± 52 to 81 sqm"
          }
        ]
      }
    ],
    unit_images: [
      `${assetUrl}/axr/unit_images/1BR.png`,
      `${assetUrl}/axr/unit_images/STUDIO-UNIT.png`
    ],
    unit_features: [
      "Tall windows in bedroom area (2.1 meters)",
      "Entrance panel door with viewer",
      "Emergency back-up power supply",
      "Granite kitchen counter top with kitchen sink including faucet & accessories, overhead and base cabinet",
      "Exhaust Fan at toilet",
      "Provision for: Range hood, Telephone and Cable Line ready, Water heater at the shower area"
    ],
    unit_finishes: [
      {
        area: "Floor",
        bedroom: "Laminated Wood",
        living: "Homogeneous Tiles",
        kitchen: "Homogeneous Tiles",
        toilet: "Ceramic Tiles"
      },
      {
        area: "Cabinet",
        bedroom: "N/A",
        living: "N/A",
        kitchen: "Granite Countertop only; no base cabinet",
        toilet: "N/A"
      },
      {
        area: "Wall",
        bedroom: "Plaster Wall with Paint Finish",
        living: "Plaster Wall with Paint Finish",
        kitchen: "Plaster Wall with Paint Finish",
        toilet:
          "Combination of Ceramic Tiles and Plaster Wall with Paint Finish"
      },
      {
        area: "Ceiling",
        bedroom: "Painted Soffit",
        living: "Painted Soffit",
        kitchen: "Moisture-resistant Gypsum Board in Paint Finish",
        toilet: "Moisture-resistant Gypsum Board in Paint Finish"
      },
      {
        area: "Other Deliverables",
        bedroom: "Bedroom Closet",
        living: "N/A",
        kitchen: "Overhead and base Cabinets and Sink, Granite Countertop",
        toilet: "N/A"
      }
    ]
  },
  {
    id: 14,
    property_id: "40036",
    cover_image: `${assetUrl}/aet/cover.jpg`,
    logo_image: `${assetUrl}/aet/logo.png`,
    pdf: `${assetUrl}/aet/aet.pdf`,
    video: `https://www.youtube.com/embed/ZXf9cgvt0I4`,
    value_proposition:
      "Primarily for INVESTORS and YOUNG PROFESSIONALS looking to purchase their first TANGIBLE ASSET, Aurora Escalades is a : complete, full-functioning mixed-use development by established real estate company (RLC); offering affordably priced finished units; well-suited to match various home and rental requirements, giving buyers POTENTIAL PROFIT- the ultimate value of a RELIABLE INVESTMENT.",
    reasons: [
      "A complete and full-functioning residential development by RLC, whose expertise in home & community building spans more than three decades (credibility)",
      "Standard finished studio units and facilities /amenities that have undergone spatial planning to fit various living requirements",
      "First Robinsons Communities property that allows unit owners lease it out for income generation via short (and long) term lease. Examples: AirBnB, HomeAway",
      "Reasonably priced condo units ; Flexible payment terms"
    ],
    address:
      "Aurora Escalades is near the heart of Cubao, a few blocks away from malls, schools, hospitals, major transportation hubs (MRT & LRT Station Line 2), and all the things one may need to live. With everything within reach, Aurora Escalades offers a high return on your investment.",
    address_image: `${assetUrl}/aet/map.png`,
    lat: 14.6257115,
    lng: 121.0570839,
    nearby_establishments: [
      {
        name: "Nearby Malls",
        places: [
          {
            name: "Gateway Mall",
            distance: ""
          },
          {
            name: "Alimall",
            distance: ""
          },
          {
            name: "SM Cubao",
            distance: ""
          },
          {
            name: "Farmers Plaza",
            distance: ""
          }
        ]
      },
      {
        name: "Nearby Office Hubs",
        places: [
          {
            name: "Araneta Center",
            distance: ""
          },
          {
            name: "UP Techno Hub",
            distance: ""
          }
        ]
      },
      {
        name: "Nearby Schools",
        places: [
          {
            name: "Ateneo de Manila University",
            distance: ""
          },
          {
            name: "Miriam College",
            distance: ""
          },
          {
            name: "University of the Philippines",
            distance: ""
          },
          {
            name: "Technological Institute of the Philippines",
            distance: ""
          },
          {
            name: "National College of Business and Arts",
            distance: ""
          },
          {
            name: "Philippines School of Business and Arts",
            distance: ""
          },
          {
            name: "The Living Epostle Christian Academy",
            distance: ""
          },
          {
            name: "St. Joseph Catholic School",
            distance: ""
          }
        ]
      },
      {
        name: "Nearby Urban Cities",
        places: [
          {
            name: "Marikina City",
            distance: ""
          },
          {
            name: "Antipolo City",
            distance: ""
          },
          {
            name: "San Juan City",
            distance: ""
          }
        ]
      }
    ],
    site_development_image: `${assetUrl}/aet/site-plan.png`,
    building_feature_image: `${assetUrl}/aet/cover.jpg`,
    site_development: [
      "Land Area: 3,300 sqm",
      "No. of towers: 1 Tower",
      "Number of residential units: 800 units",
      "Number of residential floors: 16 floors"
    ],
    building_features: [
      "Main Entrance lobby with reception counter",
      "CCTV monitoring on selected common areas",
      "Annunciator panel and emergency speaker",
      "Water is supply from elecated water tank and underground cistern",
      "Standby power generator for all common areas",
      "Standby power at seleted outlets in residential",
      "Sewage treatment plant",
      "Min. of two (2) fire exit stairs per building with well-lighted signages conforming to Fire Code of the Philippines",
      "Individual mailboxes",
      "Luggage Room",
      "Wi-Fi at selected amenity areas",
      "Centralized garbage holding room located at Ground Floor",
      "Garbage holding area per residential floor",
      "Building Administration office",
      "Security room",
      "Common laundry",
      "Drying area at roof deck",
      "Transformer and genset room",
      "Fire exit stairs"
    ],
    design_concept: [
      "Mixed-use Residential Condominium Development",
      "Modern Contemporary Design",
      "Concrete Façade with Glass Windows"
    ],
    design_partners: [
      "Architectural Design – ASYA DESIGN",
      "Structural Design – SY2 + ASSOCIATES",
      "Plumbing, Sanitary, and Fire Protection – F.L. Figueroa and Associates Inc.",
      "Electrical – ASYA ENGINEERING",
      "Electrical – ASYA ENGINEERING"
    ],
    amenities: [
      "Multi-purpose Room",
      "Network Lounge",
      "Movie Den",
      "Study Lounge",
      "Game Room",
      "Wellness Center",
      "Fitness Center",
      "Business Center",
      "Lap Pool",
      "Kiddie Pool",
      "Kids’ Play Area",
      "Garden Lounge",
      "Sky Deck",
      "Jogging Path"
    ],
    amenities_images: [
      `${assetUrl}/aet/amenities/am1.png`,
      `${assetUrl}/aet/amenities/am2.png`,
      `${assetUrl}/aet/amenities/am3.png`,
      `${assetUrl}/aet/amenities/am4.png`,
      `${assetUrl}/aet/amenities/am5.png`,
      `${assetUrl}/aet/amenities/am6.png`,
      `${assetUrl}/aet/amenities/am7.png`,
      `${assetUrl}/aet/amenities/am8.png`,
      `${assetUrl}/aet/amenities/am9.png`,
      `${assetUrl}/aet/amenities/am10.png`,
      `${assetUrl}/aet/amenities/am11.png`,
      `${assetUrl}/aet/amenities/am12.png`,
      `${assetUrl}/aet/amenities/am13.png`,
      `${assetUrl}/aet/amenities/am14.png`,
      `${assetUrl}/aet/amenities/am15.png`
    ],
    floor_plan_images: [
      `${assetUrl}/aet/floor_plan_images/f1.png`,
      `${assetUrl}/aet/floor_plan_images/f2.png`
    ],
    floor_stacking: [
      {
        name: "",
        properties: [
          {
            floor: "Roof Deck",
            number: "1",
            use: "Sky Deck"
          },
          {
            floor: "11th to 22nd",
            number: "12",
            use: "Zone 2"
          },
          {
            floor: "8th to 10th",
            number: "3",
            use: "Zone 1"
          },
          {
            floor: "7th",
            number: "1",
            use: "Upper Amenity"
          },
          {
            floor: "6th",
            number: "1",
            use: "Lower Amenity"
          },
          {
            floor: "2nd to 5th",
            number: "4",
            use: "Residential Parking"
          },
          {
            floor: "Ground",
            number: "1",
            use: "Main Lobby, Retail, and Driveway"
          }
        ]
      }
    ],
    floors: [
      {
        name: "TOWER 1",
        properties: [
          {
            col1: "No. of STUDIO Units",
            col2: "800"
          },
          {
            col1: "Total Units / Floor",
            col2: "50"
          },
          {
            col1: "No. of Residential Floors",
            col2: "16"
          },
          {
            col1: "Total Number of Units",
            col2: "800"
          }
        ]
      }
    ],
    units: [
      {
        name: "Studio",
        image: `${assetUrl}/aet/unit_images/u1.png`,
        properties: [
          {
            name: "Living/Sleeping/Dining",
            values: "±12.00 sqm"
          },
          {
            name: "Kitchen",
            values: "±6.00 sqm"
          },
          {
            name: "Common T&B",
            values: "±14.00 sqm"
          },
          {
            name: "TOTAL",
            values: "±22.00 to 30.00 sqm"
          }
        ]
      }
    ],
    unit_images: [
      `${assetUrl}/aet/unit_images/MODEL-UNIT-STUDIO.png`,
      `${assetUrl}/aet/unit_images/MODEL-UNIT-STUDIO-2.png`
    ],
    unit_features: [
      "Entrance panel door viewer",
      "Intercom per unit connected to the reception counter",
      "Automatic smoke detector and fire alarm with sprinkler system in all units",
      "Individual electric and water meter",
      "Cable TV line at Living / Bedroom",
      "Ventilation for kitchen and toilets",
      "Window type air conditioner provisions in all uniys",
      "Provision for water heater in toilet",
      "Washer/dryer provision for each units"
    ],
    unit_finishes: [
      {
        area: "Floor",
        bedroom: "Bedroom Closet",
        living: "Homogeneous Tiles",
        kitchen: "Homogeneous Tiles",
        toilet: "Homogenous Tiles"
      },
      {
        area: "Wall",
        bedroom: "",
        living: "Painted Plastered Walls",
        kitchen: "Painted Plastered Wall",
        toilet: "Combination of Homogeneous Tiles and Painted Plastered Wall"
      },
      {
        area: "Ceiling",
        bedroom: "Painted slab soffit (no ceiling)",
        living: "Painted Slab Soffit (no ceiling)",
        kitchen: "Painted Moisture Resistant Gypsum Board",
        toilet: "Painted Moisture Resistant Gypsum Board"
      },
      {
        area: "Other Deliverables",
        bedroom: "Modular with Mirror",
        living: "",
        kitchen: "Granite, Modular in Laminated Wood Finish",
        toilet: ""
      }
    ]
  },
  {
    id: 96,
    property_id: "12345",
    brand: {
      id: 2,
      name: "Robinsons Communities",
      code: "ZRCO",
      tagline: "Affordable Quality Condos.",
      description:
        "It is a trusted industry leader that sets itself apart from other real estate companies because of its consistency of quality and service, as well as its unwavering commitment to community, national, and global development.",
      image:
        "https://s3-ap-southeast-1.amazonaws.com/files.robinsonsland.com/brands/ZRCO.png",
      active: 1,
      created_at: null,
      updated_at: "2018-11-10 08:18:47",
      deleted_at: null
    },
    property_name: "AURORA ESCALADES",
    property_code: 12345,
    property: "TEST124",
    property_indicator: "B",
    created_at: "2018-12-03 14:16:53",
    updated_at: "2018-12-03 14:16:53",
    information: {
      id: 48,
      property_id: 96,
      cover_image: `${assetUrl}/aet/cover.jpg`,
      logo_image: `${assetUrl}/aet/logo.png`,
      value_proposition: "",
      reasons: "[]",
      address: "",
      address_image: "",
      lat: 0,
      lng: 0,
      nearby_establishments: "[]",
      site_development_image: "",
      building_feature_image: "",
      site_development: "[]",
      building_features:
        '{"site_development_image": "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c0620da280d0.png", "lot_area": "123 sqm", "no_of_buildings": "2", "development_type": "Hello world", "residential_units": [{"id": "a5c00476-e19e-6f5b-5a4e-60277282f923", "building_name": "Building A", "number_of_units": "22", "storey": "4", "residentail_floor": "2"}, {"id": "a5c00476-e19e-6f5b-5a4e-60277282f928", "building_name": "Building B", "number_of_units": "18", "storey": "4", "residentail_floor": "3"}], "architectural_design": "HELLLLOOOO WOOORLLD", "project_designer": "John DOe", "structural": "Jane Dpe", "mechanical": "Peter Dpe", "electrical": "Testing Doe", "sanitary_fire": "Hello Doe", "building_features_images": [{"id": "30c006d1-62c7-f83e-8e6a-1949d8163ec3", "url": "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c0620da280d0.png"}], "building_features": [{"id":"30c006d1-62c7-f83e-8e6a-1949d8163ec4", "name": "Lobbby lounge with reception"}, {"id":"30c006d1-62c7-f83e-8e6a-1949d8163ed2", "name": "Lobbby lounge with reception"}, {"id":"30c006d1-62c7-f83e-8e6a-1949d8163ec1", "name": "Lobbby lounge with reception"}, {"id":"30c006d1-62c7-f83e-8e6a-1949d8163e24", "name": "Lobbby lounge with reception"}, {"id":"30c006d1-62c7-f83e-8e6a-4949d8163ec4", "name": "Lobbby lounge with reception"}, {"id":"30c006d1-62c7-f83e-8e6a-1949d8165ec4", "name": "Lobbby lounge with reception"}, {"id":"30c006d1-62c7-f83e-8e62-1949d8163ec4", "name": "Lobbby lounge with reception"}, {"id":"30c006d1-62c7-f83e-8e6a-1949d8163fc4", "name": "Lobbby lounge with reception"}, {"id":"30c006d1-62c7-f82e-8e6a-1949d8163ec4", "name": "Lobbby lounge with reception"}, {"id":"30c006d1-62c7-f8fe-8e6a-1949d8163ec4", "name": "Lobbby lounge with reception"},{"id":"30c006d1-62c7-f83e-8e6a-1949d8163ss4", "name": "Lobbby lounge with reception"}, {"id":"30c006d1-62c7-f83e-8e6a-1949d8163ccc", "name": "Lobbby lounge with reception"}]}',
      design_concept: "[]",
      design_partners: "[]",
      amenities:
        '{"list": [{"id": "f3738fc0-75d2-f1ef-76b2-21327dd0e9d3", "name": "a1"}, {"id": "91c18ec6-91eb-1d58-29b5-848ff5fdbf5d", "name": "a2"}, {"id": "374834a5-f002-0f6c-a0a3-ef2b5fb909d0", "name": "a3"}], "images": ["https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c062fd8a587b.png", "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c062fcde7d45.png", "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c062fde56735.png", "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c062fd438e1f.png", "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c062fd0dc309.png"]}',
      amenities_images: "[]",
      floor_plan_images: "[]",
      floors:
        '{"buildings": [{"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd1", "floor_code": "1", "name": "Building A", "floor_stacking_image": "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c0620da280d0.png", "floor_stacking": [{"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd8", "floors": "3rd Floor", "details": "Amenities floor"}, {"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0cc8", "floors": "5th to 15th floor", "details": "Residential floor"}], "floor_plan": [{"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd8", "name": "Tower A 5th, 7th", "image": "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c062fd438e1f.png", "unit_types": [{"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd8", "unit_type": "Studio", "no_of_units": "12" }, {"id": "c65258ad-b70b-4ba2-5b41-a1b086fa0bd8", "unit_type": "One Bedroom", "no_of_units": "10"}]}, {"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd8", "name": "Tower B 5th, 7th", "image": "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c062fd438e1f.png", "unit_types": [{"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd4", "unit_type": "Studio", "no_of_units": "12" }, {"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd8", "unit_type": "One Bedroom", "no_of_units": "10"}]}]}, {"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd2", "floor_code": "2", "name": "Building B", "floor_stacking_image": "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c0620da280d0.png", "floor_stacking": [{"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd8", "floors": "3rd Floor", "details": "Amenities floor"}, {"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0cc8", "floors": "5th to 15th floor", "details": "Residential floor"}], "floor_plan": [{"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd8", "name": "Tower A 5th, 7th", "image": "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c062fd438e1f.png", "unit_types": [{"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd8", "unit_type": "Studio", "no_of_units": "12" }, {"id": "c65258ad-b70b-4ba2-5b41-a1b086fa0bd8", "unit_type": "One Bedroom", "no_of_units": "10"}]}, {"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd8", "name": "Tower B 5th, 7th", "image": "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c062fd438e1f.png", "unit_types": [{"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd4", "unit_type": "Studio", "no_of_units": "12" }, {"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd8", "unit_type": "One Bedroom", "no_of_units": "10"}]}] }]}',
      units:
        '{"buildings": [{"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd1", "unit_code": "1", "name": "Building A", "unit_plan": [{"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd8", "image": "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c0620da280d0.png", "details": "Tower A 22sqm"}, {"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd2", "image": "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c0620da280d0.png", "details": "Tower B 22sqm"}], "unit_finishes": [{"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd8", "area": "Floor", "bedroom": "Finished", "living": "finished", "kitchen": "finished", "masters": "finished"}, {"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd1", "area": "Ceiling", "bedroom": "Finished", "living": "finished", "kitchen": "finished", "masters": "finished"}], "unit_features": [{"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd8", "name": "Automatic door close open testing"}, {"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd1", "name": "Aircon spacing"}, {"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bds", "name": "Smoke Alarm"}], "unit_photos": ["https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c062fd8a587b.png", "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c062fcde7d45.png", "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c062fde56735.png", "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c062fd438e1f.png", "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c062fd0dc309.png"]} ]}',
      unit_images: "[]",
      unit_features: "[]",
      unit_finishes: "[]",
      created_at: "2018-12-03 14:16:53",
      updated_at: "2018-12-04 09:18:32",
      property_location: "Cubao, Metro Manila",
      cover_video: `https://www.youtube.com/embed/ZXf9cgvt0I4`,
      project_overview:
        '{"about": "testing the about", "videos": [{"id": "c65258ad-b70b-4ba2-5b41-a8b086fa0bd8", "url": "https://www.youtube.com//embed/vzJ2ildYDVk"}, {"id": "16fd0f1d-4502-7483-d71e-70f9e5a19799", "url": "https://www.youtube.com/embed/65BAeDpwzGY"}], "list_benefits": {"name": "benefit list", "benefits": [{"id": "388cda37-56e8-e402-cc48-5bbcefb76466", "item": "list1"}, {"id": "08444aa0-f1d7-9f79-33cf-32e0e04596b9", "item": "list2"}]}, "building_perspective": "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c060e415e007.png", "descriptive_benefits": [{"id": "043ddf48-cd7f-7eab-c638-1f302f83dbb0", "name": "benefit name", "description": "description test"}]}',
      location:
        '{"lat": 14.6257115, "lng": 121.0570839, "zoom": 17, "about": "test about", "vicinity_map": "https://rlc-misc.s3.ap-southeast-1.amazonaws.com/brands/ZRCO/projects/40036/5c0620da280d0.png", "nearby_places": [{"id": "a5c00476-e19e-6f5b-5a4e-60277282f932", "list": [{"id": "bd71535e-6b04-136c-3eaa-e6600bdc400b", "name": "s1"}, {"id": "849060d8-1315-aa0a-bf9b-be0210e6e48b", "name": "s2"}], "name": "Schools", "priority": 0}, {"id": "4d0f1cd5-6c14-8f1c-e461-21988e1fc37d", "list": [{"id": "225ce50e-16bd-7b0a-6640-ad8f8083a0d5", "name": "h1"}, {"id": "7186ecaa-0845-1704-f3e8-29f60efa0036", "name": "h5"}, {"id": "ab147768-e041-11db-0aee-926b93f3ef5a", "name": "h3"}], "name": "Healthcare", "priority": 2}, {"id": "10c006d1-62c7-f83e-8e6a-1949d8163ec3", "list": [{"id": "92d39cc5-62bd-d638-3c37-abcc95c8b0ae", "name": "c1"}], "name": "Commercial Areas", "priority": 1}]}',
      building_details: "[]"
    }
  },
  {
    id: 97,
    property_id: "40017",
    cover_image: `${assetUrl}/am/images/cover.jpg`,
    logo_image: `${assetUrl}/am/images/logo.png`,
    pdf: `${assetUrl}/grs/grs.pdf`,
    video: `https://www.youtube.com/embed/s93n-YovIxE`,
    value_proposition:
      "For Filipino and foreign retirees and successful Cebuanos coming from the AA-AAA segment, AmiSa provides its unit owners the experience of having a weekend seafront home, via its units designed for restful living, its amenities, its landscaping, the Magellan Bay’s stunning tropical seascape, and Mactan’s refreshing atmosphere, for a live-heal-play lifestyle.",
    reasons: [
      "Perfect location for weekend living",
      "Perfectly maintained amenities and landscaping",
      "Efficiently designed unit spaces with big/wide balconies to maximize seaside views",
      "A gated master planned complex"
    ],
    address:
      "Located in Punta Engaño, Mactan, Cebu which is only 15 minutes away from the Mactan Cebu International Airport.",
    address_image: `${assetUrl}/am/images/map.png`,
    lat: 10.3300379,
    lng: 124.0401244,
    nearby_establishments: [
      {
        name: "Malls/Shopping Centers",
        places: [
          {
            name: "Marina Mall",
            distance: ""
          },
          {
            name: "Parkmall",
            distance: ""
          },
          {
            name: "Mactan Newtown",
            distance: ""
          }
        ]
      },
      {
        name: "Hotels & Resorts",
        places: [
          {
            name: "Movenpick cebu",
            distance: ""
          },
          {
            name: "Shangrila Mactan",
            distance: ""
          },
          {
            name: "Abaca",
            distance: ""
          },
          {
            name: "Crimson Resort",
            distance: ""
          },
          {
            name: "Be Resorts",
            distance: ""
          }
        ]
      },
      {
        name: "Transportation Hubs",
        places: [
          {
            name: "Mactan International Airport",
            distance: ""
          },
          {
            name: "Cebu International Port",
            distance: ""
          }
        ]
      },
      {
        name: "Cultural Sites",
        places: [
          {
            name: "Lapu-Lapu Shrine",
            distance: ""
          },
          {
            name: "Magellan Marker",
            distance: ""
          }
        ]
      },
      {
        name: "Schools",
        places: [
          {
            name: "Bigfoot Studios",
            distance: ""
          },
          {
            name: "Intenational Academy of Film and Television",
            distance: ""
          },
          {
            name: "Saint Augustine International School",
            distance: ""
          },
          {
            name: "Aviatour Flight School",
            distance: ""
          }
        ]
      }
    ],
    site_development_image: `${assetUrl}/am/images/site-plan.png`,
    building_feature_image: `${assetUrl}/am/images/cover.jpg`,
    site_development: [
      "Approx. 6-hectare land area",
      "6 Residential Condominiums"
    ],
    building_features: [
      "Entrance lobby with reception/ security counter",
      "Two (2) passenger elevators for each tower",
      "CCTV monitoring of selected common areas",
      "Automatic heat/ smoke detection and fire sprinkler system",
      "Annunciator panel with emergency speaker at all floors",
      "Water reservoir",
      "Standby power generator for common areas and selected outlet in the residential unit",
      "Individual mail box",
      "Central garbage area",
      "Building Administration Office",
      "Fire Exits"
    ],
    design_concept: [
      "Residential towers are inspired by Australian Gold Coast architecture",
      "Master-planned residential community",
      "All flat units"
    ],
    design_partners: [
      "Architectural Partner:   ASYA Design Partners",
      "Landscaping Design:  PGAA Creative Design",
      "Beach Development:    Petra Konsult & Associate, Inc."
    ],
    amenities: [
      "Clubhouse",
      "Swimming Pools",
      "Fitness Center/Gym",
      "Videoke",
      "Game Room",
      "Mini Theater",
      "Biking/jogging path",
      "Multi-purpose court",
      "Picnic area",
      "Playground"
    ],
    amenities_images: [
      `${assetUrl}/am/images/amenities/a1.jpg`,
      `${assetUrl}/am/images/amenities/a2.jpg`,
      `${assetUrl}/am/images/amenities/a3.jpg`,
      `${assetUrl}/am/images/amenities/a4.jpg`,
      `${assetUrl}/am/images/amenities/a5.jpg`,
      `${assetUrl}/am/images/amenities/a6.png`,
      `${assetUrl}/am/images/amenities/a7.png`,
      `${assetUrl}/am/images/amenities/a8.png`
    ],
    floor_plan_images: [
      `${assetUrl}/am/images/fp/f1.png`,
      `${assetUrl}/am/images/fp/f2.png`,
      `${assetUrl}/am/images/fp/f3.png`,
      `${assetUrl}/am/images/fp/f4.png`,
      `${assetUrl}/am/images/fp/f5.png`,
      `${assetUrl}/am/images/fp/f6.png`,
      `${assetUrl}/am/images/fp/f7.png`
    ],
    floor_stacking: [
      {
        name: "Tower A",
        properties: [
          {
            floor: "15",
            number: "1",
            use: "Penthouse"
          },
          {
            floor: "2 to 14",
            number: "12",
            use: "Typical Residential Floors"
          },
          {
            floor: "Ground",
            number: "1",
            use: "Lobby/Garden Units"
          }
        ]
      },
      {
        name: "Tower B",
        properties: [
          {
            floor: "19",
            number: "1",
            use: "Penthouse"
          },
          {
            floor: "10 to 18",
            number: "8",
            use: "Typical Residential Floors"
          },
          {
            floor: "2 to 9",
            number: "8",
            use: "Typical Residential Floors"
          },
          {
            floor: "Ground",
            number: "1",
            use: "Lobby/Garden Units"
          }
        ]
      },
      {
        name: "Tower C",
        properties: [
          {
            floor: "19",
            number: "1",
            use: "Penthouse"
          },
          {
            floor: "10 to 18",
            number: "8",
            use: "Typical Residential Floors"
          },
          {
            floor: "3 to 9",
            number: "7",
            use: "Typical Residential Floors"
          },
          {
            floor: "2",
            number: "1",
            use: "Typical Residential Floors"
          },
          {
            floor: "Ground",
            number: "1",
            use: "Lobby/Garden Units/Amenities"
          }
        ]
      }
    ],
    floors: [
      {
        name: "Tower A",
        properties: [
          {
            col1: "No. of Studio Units",
            col2: "51"
          },
          {
            col1: "No. of 1BR Units",
            col2: "53"
          },
          {
            col1: "No. of 2BR Units",
            col2: "28"
          },
          {
            col1: "No. of 3BR Units",
            col2: "2"
          },
          {
            col1: "Total Units/Floor",
            col2: "15fl - 1, 2fl to 14fl - 15, 1fl - 1"
          },
          {
            col1: "Number of Floors",
            col2: "15"
          },
          {
            col1: "Total No. of Units",
            col2: "131"
          }
        ]
      },
      {
        name: "Tower B",
        properties: [
          {
            col1: "No. of Studio Units",
            col2: "37"
          },
          {
            col1: "No. of 2BR Units",
            col2: "116"
          },
          {
            col1: "No. of 3BR Units",
            col2: "2"
          },
          {
            col1: "Total Units/Floor",
            col2: "19fl - 1, 10fl to 18fl - 8, 2fl to 9fl - 8, 1fl - 1"
          },
          {
            col1: "Number of Floors",
            col2: "19"
          },
          {
            col1: "Total No. of Units",
            col2: "155"
          }
        ]
      },
      {
        name: "Tower C",
        properties: [
          {
            col1: "No. of Studio Units",
            col2: "135"
          },
          {
            col1: "No. of 2BR Units",
            col2: "51"
          },
          {
            col1: "No. of 3BR Units",
            col2: "3"
          },
          {
            col1: "Total Units/Floor",
            col2: "19fl - 1, 10fl to 18fl - 8, 3fl to 9fl - 7, 2fl - 1"
          },
          {
            col1: "Number of Floors",
            col2: "19"
          },
          {
            col1: "Total No. of Units",
            col2: "189"
          }
        ]
      }
    ],
    units: [
      {
        name: "One Bedroom",
        image: `${assetUrl}/am/images/units/u1.png`,
        properties: [
          {
            name: "Living/Dining/Kitchen",
            values: "22.18 sqm"
          },
          {
            name: "Dining",
            values: "14.16 sqm"
          },
          {
            name: "Common T&B",
            values: "5.86 sqm"
          },
          {
            name: "Balcony",
            values: "7.60 sqm"
          },
          {
            name: "Total",
            values: "49.8 sqm"
          }
        ]
      },
      {
        name: "Two Bedroom",
        image: `${assetUrl}/am/images/units/u2.png`,
        properties: [
          {
            name: "Living/Dining",
            values: "15.75 sqm"
          },
          {
            name: "Kitchen/Foyer",
            values: "9.58 sqm"
          },
          {
            name: "Utility Room",
            values: "5.65 sqm"
          },
          {
            name: "Bedroom Room",
            values: "8.26 sqm"
          },
          {
            name: "T&B",
            values: "5.60 sqm"
          },
          {
            name: "Master's Bedroom",
            values: "12.66 sqm"
          },
          {
            name: "Master's T&B",
            values: "6.40 sqm"
          },
          {
            name: "Balcony 1",
            values: "8.00 sqm"
          },
          {
            name: "Balcony 2",
            values: "9.30 sqm"
          },
          {
            name: "Hallway",
            values: "2.48 sqm"
          },
          {
            name: "Total",
            values: "83.68 sqm"
          }
        ]
      },
      {
        name: "Three Bedroom",
        image: `${assetUrl}/am/images/units/u3.png`,
        properties: [
          {
            name: "Living/Dining Area",
            values: "30.10 sqm"
          },
          {
            name: "Kitchen",
            values: "7.00 sqm"
          },
          {
            name: "Foyer",
            values: "3.80 sqm"
          },
          {
            name: "Hallway",
            values: "3.80 sqm"
          },
          {
            name: "Bedroom 2",
            values: "11.70 sqm"
          },
          {
            name: "Bedroom 2 T&B",
            values: "6.20 sqm"
          },
          {
            name: "Utility Room",
            values: "6.20 sqm"
          },
          {
            name: "Bedroom 3",
            values: "15.20 sqm"
          },
          {
            name: "Bedroom T&B",
            values: "6.30 sqm"
          },
          {
            name: "Master's Bedroom",
            values: "24.51 sqm"
          },
          {
            name: "Master's T&B",
            values: "6.70 sqm"
          },
          {
            name: "Balcony 1",
            values: "8.00 sqm"
          },
          {
            name: "Balcony 2",
            values: "9.30 sqm"
          },
          {
            name: "Balcony 3",
            values: "9.60 sqm"
          },
          {
            name: "Total",
            values: "148.41 sqm"
          }
        ]
      }
    ],
    unit_images: [
      `${assetUrl}/am/images/units/1BR-Unit.png`,
      `${assetUrl}/am/images/units/2BR-Unit.png`,
      `${assetUrl}/am/images/units/Studio-Unit.png`
    ],
    unit_features: [
      "Entrance panel with door viewer",
      "Intercom per unit connected to the reception counter",
      "Automatic smoke detectors and fire alarm with sprinkler system in all units",
      "Individual electric and water meter",
      "Cable TV line",
      "Telephone line per unit",
      "Ventilation for kitchen and toilets",
      "Window type air con openings and electrical outlet for all units except for Units B and O which will be provided with additional pipe sleeves and electrical provisions for split-type air con",
      "Hot water supply line (excluding water heater) for shower area at Toilet and Bath",
      "Electrical load provision of 20 amp for 2-burner electric cooktop"
    ],
    unit_finishes: [
      {
        area: "Floor",
        bedroom: "Laminated, Wood",
        living: "Homogeneous Tiles",
        kitchen: "Homogeneous Tiles",
        toilet: "Ceramic Tiles",
        balcony: "Ceramic Tiles"
      },
      {
        area: "Wall",
        bedroom: "Painted, Cement Finish",
        living: "Painted, Cement Finish",
        kitchen: "Painted, Cement Finish",
        toilet: "Combination of ceramic tiles and painted plastered cement",
        balcony: "1.2 meters high with metal railing"
      },
      {
        area: "Ceiling",
        bedroom: "Painted, Cement Finish",
        living: "Painted, Cement Finish",
        kitchen: "Painted, Cement Finish",
        toilet: "Painted Gypsum Board",
        balcony: ""
      },
      {
        area: "Others",
        bedroom: "",
        living: "",
        kitchen:
          "Granite finish countertop, overhead and undercounter cabinets",
        toilet: "",
        balcony: ""
      }
    ]
  }
];
